/**
 * User: kotofey
 * Date: 09.08.13 12:46
 */

var strip = function (html) {
    var tmp = document.createElement('DIV');
        tmp.innerHTML = html;

    return tmp.textContent || tmp.innerText || '';
};

var currentDateYearShift = function (shift) {
    var date = new Date();
    date.setFullYear(date.getFullYear() + shift);
    return date;
};

var currentDateMonthShift = function (shift) {
    var date = new Date();
    date.setMonth(date.getMonth() + shift);
    return date;
};

var currentDateDayShift = function (shift) {
    var date = new Date();
    date.setDate(date.getDate() + shift);
    return date;
};

var checkBrowser = function(){
    if(typeof($.reject) === "function"){
        var imagePath = 'css/images/';
        var reject = {all: false};

        try {
            if(budgetFlag){
                imagePath = '../' + imagePath;
            }
        } catch(e){}

        for(var i = 1; i <= 33; i++){
            if(i < 29) reject['firefox' + i] = true;
            if(i < 5) reject['safari' + i] = true;
            if(i < 21) reject['opera' + i] = true;
            if(i < 34) reject['chrome' + i] = true;
            if(i <= 11) reject['msie' + i] = true;
        }

        $.reject({
            /*reject: {
             all: false,
             msie5: true, msie6: true, msie7: true, msie8: true,
             opera9: true, opera10: true, opera11: true, opera12: true
             },*/
            reject: reject,
            close: false,
            header: 'Ваш браузер не поддерживается/устарел',
            paragraph1: '',
            paragraph2: 'Для дальнейшей работы необходимо установить один из нижеприведенных браузеров:',
            browserInfo: {
                firefox: {
                    text: 'Firefox 29+',
                    url: 'http://www.mozilla.com/firefox/'
                },
                safari: {
                    text: 'Safari 5+',
                    url: 'http://support.apple.com/kb/DL1531?viewlocale=ru_RU'
                },
                opera: {
                    text: 'Opera 21+',
                    url: 'http://www.opera.com/download/'
                },
                chrome: {
                    text: 'Chrome 34+',
                    url: 'http://www.google.com/chrome/'
                },
                msie: {
                    text: 'Internet Explorer 11',
                    url: 'http://www.microsoft.com/windows/Internet-explorer/'
                },
                gcf: {
                    allow: { all: false, msie: false }
                }
            },
            imagePath: imagePath,
            overlayBgColor: '#000',
            overlayOpacity: 0.7
        });
    }
};

$.fn.animateHighlight = function(highlightColor, duration) {
    if($(this).attr('role') != 'gridcell'){
        var highlightBg = highlightColor || "#FFFF9C";
        var animateMs = duration || 1500;
        var originalBg = this.css("backgroundColor");
        var originalPos = this.css("text-align");
        this.stop().css("background-color", highlightBg).animate({backgroundColor: originalBg}, animateMs, function(){
            $(this).removeAttr("style");
            $(this).css({"text-align": originalPos});
        });
    }
};

var removeSelectOpt = function(target){
    $.each(target.find('select.combobox option'), function(){
        if(isNaN(parseInt($(this).val())) && $(this).val() != '')
            $(this).remove();
    });
};

var addTmplSelectOpt = function(target){
    var newSelector, comboboxInput;
    $.each(target ,function(){
        comboboxInput = $(this).parent().find('.ui-combobox-input');
        if($(this).val() == '' && comboboxInput.val() != '' && !comboboxInput.hasClass('grey')){
            newSelector = comboboxInput.val();
            comboboxInput.removeClass('error');
            $(this).append('<option value="'+newSelector+'">'+newSelector+'</option>').val(newSelector);
        } else if(comboboxInput.hasClass('grey')) {
            comboboxInput.addClass('error');
        } else{
            comboboxInput.removeClass('error');
        }
    });
};

var replaceNOnBr = function (cellValue, options, rowObject) {
    cellValue = truncateLongText(cellValue, options, rowObject);
    return cellValue.replace(/\n/g, '<br>');
};

var truncateLongText = function (cellValue, options, rowObject) {
    var cellValCustom = '';
    //remove html tags
    if (/[a-z]+>/g.test(cellValue)) {
        cellValue = $(cellValue).text() || cellValue;
    }

    if(typeof cellValue == 'string') {
        if(cellValue.length > 150){
            cellValCustom = cellValue.substring(0, 150).slice(0,-1)+' <small class="link-simple detail_link" onclick="$.expandShortened(this)">далее...</small>';
        }
        else {
            cellValCustom = cellValue;
        }
        return "<span originalValue='" + cellValue + "'>"+cellValCustom+"</span>";
    } else {
        return "<span originalValue=''>" + cellValCustom + "</span>";
    }
};

var unformatLongText = function(cellValue, options, cellObject) {
    return $(cellObject.html()).attr("originalValue");
};

var closeTreeSelect = function(){
    $('body.panel').unbind('click');
    $('body.panel').click(function(){
        if (!$(this).hasClass('mytreeviewbutton') && !$(this).hasClass('myTreeView')) {
            $('div[mytreeviewmouse=leave]')
                .css('display','none')
                .removeClass('mydtreeviewvisible')
                .attr('mytreeviewmouse','null');
        }
    });
};

var getRIKListByDistrict = function(data){
    var disctrId = data.disctrId,
        i = data.i,
        rId = data.rId,
        mId = data.mId,
        pId = data.pId,
        childLvl = data.childLvl,
        rikDD = data.rikDD,
        altName = data.altName,
        readRight = data.readRight,
        cmpId = data.cmpId,
        preset_rId = data.preset_rId,
        rightType = data.rightType ? data.rightType : '',
        ignore_rights = data.ignore_rights,
        upu_rights = data.upu_rights && data.upu_rights === true,
        isPublicReceptionRegional = data.isPublicReceptionRegional && data.isPublicReceptionRegional === true;
    showAjaxLoading();
    var sendData = {
        qryType:'rikListByDisctrict',
        districtId:disctrId,
        childLvl: childLvl ? childLvl : $("#operator_type"+i).val(),
        altName: altName ? 'true' : 'false',
        rightType: rightType,
        // budgetFlag: budgetFlag,
        ignore_rights: ignore_rights,
        readRight: readRight || $.inArray( location.hash, ['#staff_selection', '#estimate_selection', '#finplan_selection', '#offs_one', '#offs_five', '#offs_six', '#offs_seven', '#offs_two', '#offs_three', '#offs_four', '#fr_report'] ) > -1,
        upu_rights: upu_rights
    };

    $.ajax({
        type: 'POST',
        url: dirUp + "php/getData.php",
        dataType: 'json',
        data: sendData,
        success: function(tr){
            hideAjaxLoading();
            checkSession(tr);
            if(!rikDD){
                $('#rik_unit'+i).prop('disabled', preset_rId ? true : false);

                var rikOpt = '<option value="">'+(altName ? 'Субъект федерации' : 'Региональное отделение')+':</option>';

                if(preset_rId){
                    $.each(tr.data, function(){
                        if(this.r_id == rId){
                            rikOpt += '<option value="'+this.r_id+'" fias="'+this.r_okato_id+'" selected="selected">'+(altName ? this.r_reg_name : this.r_name)+'</option>';
                            return false;
                        }
                    });
                }else{
                    $.each(tr.data, function(){
                        rikOpt += '<option value="'+this.r_id+'" fias="'+this.r_okato_id+'" '+(rId == this.r_id ? "selected=\'selected\'" : "")+'>'+(altName ? this.r_reg_name : this.r_name)+'</option>';
                    });
                }

                $('#rik_unit'+i).html("").append(rikOpt).parent().animateHighlight("#FAF000", 1000);

                $('#mo_unit'+i).html('<option value="">Местное отделение:</option>');
                $('#mo_unit'+i).addClass('grey');
                if(tr.data.length == 1){
                    $('#rik_unit'+i).removeClass('grey');
                    $('#rik_unit'+i+' option:last').attr("selected", "selected").change();
                }
                if(cmpId){
                    $('#rik_unit'+i).trigger('change', [cmpId]);
                }
                if (rightType === 'cpgi') {
                    ignore_rights = true;
                }
                /*
                * Показать список МО
                * */
                if(rId && mId || isPublicReceptionRegional){
                    getMOListByRIK({rId: rId, i: i, mId: mId, pId:pId, rightType: sendData.rightType, ignore_rights: ignore_rights, upu_rights: upu_rights});
                }
            } else if(rikDD){
                rikDD.set('disabled', false);
                for(var j = rikDD.options.length; j > 0; j--)
                    rikDD.remove(j-1);
                $.each(tr.data, function(){
                    rikDD.add({text: this.r_name, value: this.r_id});
                });
                $('#rik_unit').parent().parent().animateHighlight("#FAF000", 1000);
                if(tr.data.length == 1){
                    rikDD.set("selectedIndex", 0);
                }
            }
        }
    });
};

var getUIKListByRIK = function (r_id, uik_elem_id, uik_id){
    showAjaxLoading();
    $.post((typeof dirUp == 'string' ? dirUp : '') + 'php/getData.php', {qryType: 'uikListByRIK', r_id: r_id}, function (tr) {
        hideAjaxLoading();
        checkSession(tr);

        $(uik_elem_id).html('');
        $.each(tr.data, function() {
            $(uik_elem_id)
                .append($("<option></option>")
                    .attr('value', this.uik_id)
                    .text(this.uik_name));
        });

        if (tr.data.length > 1) {
            $(uik_elem_id).parent().animateHighlight('#FAF000', 1000);
        }

        if (uik_id) {
            $(uik_elem_id).val(uik_id);
        }

        if (tr.data.length == 2) {
            $(uik_elem_id + ' option:last').prop('selected', true);
        }
    }, 'json');
};

var getMOListByRIK = function(data){
    showAjaxLoading();
    var RIKId = data.rId,
        i = data.i,
        mId = data.mId,
        pId = data.pId,
        title = data.title ? data.title : 'Местное отделение:',
        ignore_rights = data.ignore_rights,
        upu_rights = data.upu_rights && data.upu_rights === true,
        sendData = {
            qryType: 'moListByRIK',
            RIKId: RIKId,
            rightType: data.rightType ? data.rightType : '',
            ignore_rights: data.ignore_rights,
            upu_rights: upu_rights
        };

    $.ajax({
        type:"POST",
        url:dirUp+"php/getData.php",
        dataType:'json',
        data:sendData,
        success: function(tr){
            hideAjaxLoading();
            checkSession(tr);

            $('#mo_unit'+i).prop('disabled', false);

            var moOpt = '<option value="">'+title+'</option>';
            $.each(tr.data, function(){
                moOpt += '<option value="'+this.mo_id+'" fias="' + this.mo_okato_id + '"  '+(mId == this.mo_id ? "selected=\'selected\'" : "")+'>'+this.mo_name+'</option>';
            });
            if($.isNumeric(mId) && mId != -1) $('#mo_unit'+i).removeClass('grey');
            if (!data.hide_fld) {
                $('#mo_unit'+i).parent().parent().slideDown(500);
            }
            $('#mo_unit'+i).html("").append(moOpt).parent().animateHighlight("#FAF000", 1000);
            if(tr.data.length == 1){
                $('#mo_unit'+i).removeClass('grey');
                $('#mo_unit'+i+' option:last').attr("selected", "selected").change();
            }
            if(pId && $('#mo_unit'+i).val() !== '') {
                getPOListBy($("#disctrict" + i).val(), $("#rik_unit" + i).val(), mId, i, pId);
            }
        }
    });
};

var getPOListBy = function(DId, RId, MId, i, pId){
    showAjaxLoading();

    $.ajax({
        type:"POST",
        url:dirUp + "php/getData.php",
        dataType:'json',
        data:{'qryType':'getPOListBy', 'DId':DId, 'RId':RId, 'MId':MId},
        success: function(tr){
            hideAjaxLoading();
            checkSession(tr);

            $('#po_unit'+i).prop('disabled', false);
            var moOpt = '<option value="">Первичное отделение:</option>';
            $.each(tr.data, function(){
                moOpt += '<option value="'+this.po_id+'" >'+this.po_name+'</option>';
            });
//						if(!isNaN(MId)) $('#po_unit'+i).removeClass('grey');
            if (tr.data.length==0)
            {
                $('#po_unit'+i).parent().parent().slideUp(500);
                $('#po_unit'+i).html("");
            }
            else{
                $('#po_unit'+i).parent().parent().slideDown(500);
                $('#po_unit'+i).html(moOpt).parent().animateHighlight("#FAF000", 1000);
            }
            //if(tr.data.length == 1){
            //	$('#po_unit0').removeClass('grey');
            //	$('#po_unit0'+' option:last').attr("selected", "selected").change();
            //}
            if($.isNumeric(pId) && pId != -1)
                $('#po_unit'+i).val(pId).removeClass('grey');
        }
    });

};

var uploadFile = function(fileElementId, fileType, funcAfter){
    var parentEl,
        error = $('<span class="error-msg" style="display: inline; margin-left: 5px;"></span>'),
        uploadAnim = '<span class="uploading"><img src="'+(fileType == 'request_files' || typeof dirUp == 'string' && dirUp == '../' ? '../' : '') + 'css/images/ajax-loader.gif"> Загрузка...</span>';

    var fileName = $('#'+fileElementId).val().split('\\');
    fileName = fileName[fileName.length - 1];
    const purifyFileName = [
        'dc_docs',
        'prjro_design_file',
        'prjro_proj_doc_file',
        'prjro_auth_files',
        'prjro_photo_files',
        'prjro_other_files'
    ].includes(fileType);
    if (purifyFileName) {
        fileName = purifyUploadNameFile(fileName);
        if (!fileName.length) {
            $.create_popup_dialog('<span class="error-msg">Недопустимое имя файла.<br>Разрешенные символы: буквы (русские/латинские), цифры, дефис, нижнее подчеркивание, пробел, точка.<br>Имя файла должно начинаться с буквы или цифры.</span>', 'Ошибка');
            $('#'+fileElementId).val('');
            return false;
        }
        if (extBlackList().includes(fileName.split('.').pop().toLowerCase())) {
            $.create_popup_dialog('<span class="error-msg">Запрещено загружать файлы с данным расширением</span>', 'Ошибка');
            $('#'+fileElementId).val('');
            return false;
        }
    }

    var check_file_type = function () {
        parentEl.find('.error-msg, label.error').remove();

        if (['member_photos', 'member_photos_site', 'update_employee_photos'].indexOf(fileType) !== -1 && ['jpg','jpeg','png', 'webp'].indexOf($('#'+fileElementId).val().split('.').pop().toLowerCase()) === -1) {
            error.html('Только jpg, webp или png-изображение');
            parentEl.append(error);
            return false;
        } else if (purifyFileName) {
            const allowExt = getAllowedUploadFilesExt({img: true, office: true, pdf: true});

            if (!allowExt.includes($('#'+fileElementId).val().split('.').pop().toLowerCase())) {
                $.create_popup_dialog('<span class="error-msg">Допустимые расширения для файлов: ' + allowExt.join(', ') + '</span>', 'Ошибка');
                $('#'+fileElementId).val('');
                return false;
            }
        }

        return true;
    };

    var filesArray = [
        'offense_files',
        'uik_messages_files',
        'thematic_discussions_files',
        'request_files',
        'email_attach',
        'pvg_protocol',
        'cand_programm',
        'member_files',
        'ba_files',
        'cikm_files',
        'cpgib_agreement_file',
        'cpgip_files',
        'cpgie_files',
        'rps_files',
        'rppp_files',
        'rpr_files',
        'rpmb_files',
        'rppma_files',
        'rppsr_files',
        'rpw_files',
        'cl_files',
        'ofs_files',
        'penalty_scans',
        'ap_documents',
        'dc_docs',
        'prjro_design_file',
        'prjro_proj_doc_file',
        'prjro_auth_files',
        'prjro_photo_files',
        'prjro_other_files',
    ];

    if ($.inArray(fileType, filesArray) != -1) {
        parentEl = $('#'+fileElementId).parent();
        if (!check_file_type()) {
            return false;
        }
        $('#'+fileElementId).hide().before(uploadAnim);
        parentEl.find('.remove_file').hide();
    }
    else if ($.inArray(fileType, ['member_photos', 'm_photo_site', 'member_photos_site', 'projects_federal_logos', 'event_docs', 'rik_fin_docs', 'cik_docs', 'chvanstvo', 'dp_scans']) != -1 || fileType.indexOf('project') != -1) {
        parentEl = $('#'+fileElementId).parent().parent();
        if (!check_file_type()) {
            return false;
        }
        parentEl.append(uploadAnim);
    }

    var tmplDirName = $('#tmplDirName').val();
    if (tmplDirName == '' || fileType === 'member_photos_site') {
        tmplDirName = parentEl.parent().find('[name=tmplDirName]').val();
    }
    $.ajaxFileUpload({
        url: (typeof dirUp == 'string' && dirUp == '../' || ['cikm_files'].indexOf(fileType) != -1 ? '../' : '') + 'php' + (['request_files','ba_files'].indexOf(fileType) != -1 ? '-local' : '') + '/getData.php',
        secureuri:false,
        fileElementId:fileElementId,
        data: {qryType: 'uploadFile', fileElementId: fileElementId, tmplDirName: tmplDirName, fileType: fileType},
        dataType:'json',
        success:function (tr, status) {
            if(checkSession(tr)) {
                parentEl.find('.remove_file').show();
                parentEl.find('.uploading').remove();
                if(tr.error != ''){
                    $.create_popup_dialog(`<span class="error-msg">${tr.error}</span>`, 'Ошибка');
                    error.html(tr.error);
                    if (purifyFileName) {
                        parentEl.find('a.remove_file').hide();
                        parentEl.find('input.attachment').val('').hide();
                        $('#'+fileElementId).val('').show();
                    }
                    else if (['offense_files', 'thematic_discussions_files', 'uik_messages_files', 'request_files', 'email_attach', 'member_files', 'cpgib_agreement_file', 'cpgip_files', 'cpgie_files', 'rps_files', 'rppp_files', 'rpr_files', 'rpmb_files', 'rppma_files', 'rppsr_files', 'rpw_files', 'cl_files', 'penalty_scans', 'ap_documents', 'ofs_files'].indexOf(fileType) != -1){
                        $('#'+fileElementId).show();
                        parentEl.append(error);
                    }
                    else if (['member_photos', 'projects_federal_logos', 'member_photos_site', 'event_docs', 'cik_docs', 'dp_scans'].indexOf(fileType) != -1){
                        parentEl.find('input:last').val('').addClass('error');
                        parentEl.find('input:eq(0)').attr('title', 'Файл не выбран');
                        parentEl.find('input').show();
                        parentEl.append(error);
                        $('#'+fileElementId).change(function(){
                            uploadFile(fileElementId, fileType, funcAfter);
                        });
                    }
                } else {
                    if(
                        ['offense_files', 'request_files', 'email_attach', 'pvg_protocol', 'cand_programm'].indexOf(fileType) != -1 ||
                        (fileType == 'member_files' && !$('#m_files').parent().hasClass('FormElement')) //если не форма редактирования мемберов
                    ){
                        $('#'+fileElementId).remove();
                        parentEl.find('.remove_file').before('<input class="attachment" id="'+fileElementId+'" name="'+fileElementId+'" disabled="disabled" value="'+fileName+'">');

                        if(fileType == 'cand_programm')
                            $('#'+fileElementId).attr('style', 'width: 275px;');
                    } else if(['member_photos', 'projects_federal_logos', 'member_photos_site'].indexOf(fileType) != -1) {
                        parentEl.find('input:eq(0)').attr('title', fileName);
                        parentEl.find('input:last').val(fileName).removeClass('grey').removeClass('error');

                        $('#'+fileElementId).change(function(){
                            uploadFile(fileElementId, fileType, funcAfter);
                        });
                    }

                    if(typeof funcAfter == 'function'){
                        funcAfter(fileName);
                    }
                }
            }
        },
        error: function (err) {
            if (purifyFileName) {
                parentEl.find('.uploading').remove();
                parentEl.find('a.remove_file').hide();
                parentEl.find('input.attachment').val('').hide();
                $('#'+fileElementId).val('').show();
            }
            $.create_popup_dialog('<span class="error-msg">Произошла ошибка при загрузке файла<br>Повторите попытку</span>', 'Ошибка');
            return false;
        }
    });
};

var get_correct_str = function (num, str1, str2, str3, only_str) {
    var res;
    var val = num % 100;

    if (val > 10 && val < 20) {
        res = str3;
    } else {
        val = num % 10;
        if (val == 1) {
            res = str1;
        } else if (val > 1 && val < 5) {
            res = str2;
        } else {
            res = str3;
        }
    }

    if (!only_str) {
        res = num + ' ' + res;
    }

    return res;
};

privateOffice = async function(){
    showAjaxLoading();
    await Erdb.importErdbModule('Service/PasswordValidator');

    $("#private_office_tmpl #rules").html("");
    var cikFlag = $('#addRights').length ? false : true;
    var url = cikFlag ? "../php/getData.php" : "php/getData.php";
    $.ajax({
        type:"POST",
        url:url,
        dataType:'json',
        data:{'qryType':'getCurrRights', 'userId':__userId__, 'privateOfficeFlag':true, 'cikFlag' : cikFlag},
        success: function(tr){
            if(checkSession(tr)) {
                tr.data = tr.data ? tr.data : [];
                if(tr.currRights != null && tr.role != 'sys-admin' && tr.role != 'admin'){
                    var rightsSimpleHtml = '';
                    var xhtml = '<table>';
                    var skipRights = ['oppg16', 'pg2023may'];
                    $.each(tr.currRights, function(){
                        if(skipRights.includes(this.ur_name)) {
                            return true;
                        }

                        if(this.ur_type != 0){
                            var typeName = '',
                                typeAccess = '';
                            if($.inArray(this.ur_name, [
                                'erv','sms-send','auth-log','spec_news','cardfile','budget', 'comment_regional_office_works',
                                'comment_technology_management','comment_financial_and_economic_security','comment_organizational_management',
                                'party_registration', 'passport_view', 'protected_member', 'ro_payments', 'member_statistics', 'presence', 'arm', 'mer',
                                'telbook', 'cik', 'cik_docs', 'support_operator', 'call', 'financier', 'events', 'events_placemnt', 'projects_list', 'documents',
                                'call-region', 'cik_meetings_tech', 'cik_meetings_org','federal-partRadar', 'limited_federal-partRadar', 'pg_news', 'email-send', 'push_notify',
                                'asu_sync', 'administration_vpsh', 'strat_monitor', 'red_button', 'access_uchp', 'council_of_faction', 'uchp_employee', 'cpgi', 'erru', 'arbitrage', 'access_tech_card', 'cloud', 'plan', 'sim', 'up', 'public_reception'

                            ]) != -1)
                            {
                                if(this.ur_name == 'arm'){
                                    typeName = 'использование АРМ руководитель';
                                    typeAccess = 'Да';
                                } else if(this.ur_name == 'federal-partRadar') {
                                    typeName = 'федеральный полный доступ в Партрадар';
                                    typeAccess = 'Да';
                                } else if(this.ur_name == 'limited_federal-partRadar'){
                                    typeName = 'федеральный ограниченный доступ в Партрадар';
                                    typeAccess = 'Да';
                                } else if(this.ur_name == "mer") {
                                    typeName = 'использование матрицы электоральных расчетов';
                                    if (this.ur_type == 1) {
                                        typeAccess = 'Пользователь';
                                    } else if(this.ur_type == 2) {
                                        typeAccess = 'Технолог';
                                    } else if(this.ur_type == 3) {
                                        typeAccess = 'Администратор';
                                    }
                                } else if(this.ur_name == "strat_monitor") {
                                    typeName = 'Стратегический монитор';
                                    if(this.ur_type == 1) typeAccess = 'Администратор';
                                    else if(this.ur_type == 2) typeAccess = 'Оператор';
                                    else if(this.ur_type == 3) typeAccess = 'Аудитор';
                                } else if (this.ur_name == "red_button") {
                                    typeName = 'Красная кнопка';
                                    if(this.ur_type == 1) typeAccess = 'Администратор';
                                    else if(this.ur_type == 2) typeAccess = 'Модератор сигналов К.К.';
                                    else if(this.ur_type == 3) typeAccess = 'Модератор комментариев К.К.';
                                    else if(this.ur_type == 4) typeAccess = 'Федеральный координатор';
                                    else if(this.ur_type == 5) typeAccess = 'Региональный координатор';
                                    else if(this.ur_type == 6) typeAccess = 'Региональный исполнительный комитет';
                                    else if(this.ur_type == 7) typeAccess = 'Губернатор';
                                    else if(this.ur_type == 8) typeAccess = 'Председатель общественного совета';
                                } else if (this.ur_name == "access_uchp") {
                                    typeName = 'Доступ к УЧП';
                                    if(this.ur_type == 1) typeAccess = 'УЧП фед. доступ - Администратор';
                                    else if(this.ur_type == 2) typeAccess = 'УЧП фед. доступ - Оператор';
                                    else if(this.ur_type == 3) typeAccess = 'УЧП фед. доступ - Просмотр';
                                    else if(this.ur_type == 4) typeAccess = 'УЧП рег. доступ - Администратор';
                                    else if(this.ur_type == 5) typeAccess = 'УЧП рег. доступ - Оператор';
                                    else if(this.ur_type == 6) typeAccess = 'УЧП рег. доступ - Просмотр';
                                } else if(this.ur_name == "erv") {
                                    typeName = 'работу с голосованиями';
                                    typeAccess = 'Да';
                                } else if(this.ur_name == 'telbook') {
                                    typeName = 'справочник';
                                    typeAccess = 'Да';
                                } else if(this.ur_name == 'cik') {
                                    typeName = 'интерфейс сотрудника ЦИК';
                                    typeAccess = 'Да';
                                } else if(this.ur_name == 'cik_docs') {
                                    typeName = 'документы ЦИК';
                                    typeAccess = 'Да';
                                } else if(this.ur_name == 'projects_list') {
                                    typeName = 'администрирование партпроектов';
                                    typeAccess = 'Да';
                                } else if(this.ur_name == 'pg_news'){
                                    typeName = 'Новости ПГ';
                                    typeAccess = 'Да';
                                } else if (this.ur_name == 'email-send') {
                                    typeName = 'Создание email-рассылок';
                                    typeAccess = 'Да';
                                } else if (this.ur_name == 'push_notify') {
                                    typeName = 'Создание PUSH-рассылок';
                                    typeAccess = 'Да';
                                } else if (this.ur_name == 'asu_sync') {
                                    typeName = 'Синхронизацию с УЧП';
                                    typeAccess = 'Да';
                                } else if (this.ur_name == "administration_vpsh"){
                                    typeName = 'Администрирование ВПШ';
                                    typeAccess = 'Да';
                                } else if (this.ur_name == 'uchp_employee') {
                                    typeName = 'Сотрудник департамента УЧП';
                                    typeAccess = 'Да';
                                } else if (this.ur_name == 'erru'){
                                    typeName = 'Редакция сайта ER.RU';
                                    typeAccess = 'Да';
                                } else if(this.ur_name == 'support_operator'){
                                    rightsSimpleHtml += '<b>Оператор поддержки: </b> Да<br>';
                                } else if(this.ur_name == 'call'){
                                    typeName = 'администрирование системы мобилизации';
                                    typeAccess = 'Да';
                                } else if(this.ur_name == 'call-region'){
                                    typeName = 'администрирование системы мобилизации своего региона';
                                    typeAccess = 'Да';
                                } else if(this.ur_name == "auth-log") {
                                    typeName = 'просмотр лога авторизаций';
                                    typeAccess = this.ur_type == 2 ? 'Полный доступ' : 'Нижестоящие операторы';
                                } else if(this.ur_name == "sms-send") {
                                    typeName = 'работу с sms-рассылками';
                                    typeAccess = this.ur_type == 2 ? 'Полный доступ' : 'Только чтение';
                                } else if(this.ur_name == 'spec_news'){
                                    typeName = 'работу со спец. новостями';
                                    typeAccess = this.ur_type == 2 ? 'Полный доступ' : 'Только чтение';
                                } else if(this.ur_name == "cardfile"){
                                    typeName = 'работу со справочником';
                                    typeAccess = this.ur_type == 2 ? 'Полный доступ' : 'Только чтение';
                                } else if(this.ur_name == 'budget'){
                                    typeName = ' доступ к финансированию';
                                    if(this.ur_type == 1) typeAccess = 'Запрашивающий финансирование';
                                    else if(this.ur_type == 2) typeAccess = 'Администратор финансирования';
                                    else if(this.ur_type == 3) typeAccess = 'Определяющий стоимость';
                                    else if(this.ur_type == 4) typeAccess = 'Распределяющий финансирование';
                                } else if(this.ur_name == 'presence'){
                                    typeName = ' присутствие';
                                    if(this.ur_type == 1) typeAccess = 'Просмотр';
                                    else if(this.ur_type == 2) typeAccess = 'Оператор КПП';
                                    else if(this.ur_type == 3) typeAccess = 'Администратор охраны';
                                } else if(this.ur_name == 'comment_regional_office_works'){
                                    typeName = ' комментарий Управления Региональной Работы';
                                    typeAccess = this.ur_type == 2 ? 'Полный доступ' : 'Только чтение';
                                } else if(this.ur_name == 'comment_technology_management'){
                                    typeName = ' комментарий Технологического Управления';
                                    typeAccess = this.ur_type == 2 ? 'Полный доступ' : 'Только чтение';
                                } else if(this.ur_name == 'comment_financial_and_economic_security'){
                                    typeName = ' комментарий Управления Финансово-хозяйственного обеспечения';
                                    typeAccess = this.ur_type == 2 ? 'Полный доступ' : 'Только чтение';
                                } else if(this.ur_name == 'comment_organizational_management'){
                                    typeName = ' комментарий Организационного управления';
                                    typeAccess = this.ur_type == 2 ? 'Полный доступ' : 'Только чтение';
                                } else if(this.ur_name == 'protected_member'){
                                    typeName = ' защищенные записи в списке членов-секретарей';
                                    typeAccess = this.ur_type == 2 ? 'Полный доступ' : 'Только чтение';
                                } else if(this.ur_name == 'ro_payments'){
                                    typeName = ' работу с платежами РО';
                                    typeAccess = 'Полный доступ';
                                } else if(this.ur_name == 'member_statistics'){
                                    typeName = ' статистику членов';
                                    typeAccess = ' Просмотр';
                                } else if(this.ur_name == 'party_registration'){
                                    rightsSimpleHtml += '<b>Право Специалист парт-учёта: </b> Полный доступ<br>';
                                } else if(this.ur_name == 'passport_view'){
                                    typeName = ' просмотр паспортных данных';
                                    typeAccess = ' Да';
                                } else if(this.ur_name == 'financier'){
                                    rightsSimpleHtml += '<b>Финансист: </b> Да<br>';
                                } else if(this.ur_name == 'events'){
                                    typeName = ' Мероприятия';
                                    typeAccess = this.ur_type == 2 ? 'Полный доступ' : 'Только чтение';
                                } else if(this.ur_name == 'events_placemnt'){
                                    typeName = ' размещение на Мероприятиях';
                                    typeAccess = this.ur_type == 2 ? 'Полный доступ' : 'Только чтение';
                                } else if(this.ur_name == 'documents'){
                                    typeName = ' Архив документов';
                                    typeAccess = this.ur_type == 2 ? 'Полный доступ' : 'Только чтение';
                                } else if(this.ur_name == 'cik_meetings_tech' && this.ur_type == 4){
                                    typeName = ' Техническое администрирование совещаний';
                                    typeAccess = 'Да';
                                } else if(this.ur_name == 'cik_meetings_org' && this.ur_type == 4){
                                    typeName = ' Организационное администрирование совещаний';
                                    typeAccess = 'Да';
                                } else if(this.ur_name == 'cpgi'){
                                    typeName = ' ЦПГИ';
                                    typeAccess = this.ur_type == 2 ? 'Федеральный' : 'Региональный';
                                } else if (this.ur_name == "council_of_faction") {
                                    typeName = 'Доступ к сайту Совет рук.фракций';
                                    typeAccess = this.ur_type == 2 ? 'Доступ к сайту Совет рук.фракций - Федеральный доступ' : 'Доступ к сайту Совет рук.фракций - Региональный доступ';
                                } else if (this.ur_name == 'public_reception') {
                                    typeName = 'Доступ к Общественным приемным';
                                    typeAccess = this.ur_type == 2 ? 'Доступ к Общественным приемным - Федеральный доступ' : 'Доступ к Общественным приемным - Региональный доступ';
                                } else if(this.ur_name == 'arbitrage'){
                                    typeName = ' судебная практика';
                                    if(this.ur_type == 1) typeAccess = 'Право Судебная практика - Ответственное лицо РИК';
                                    else if(this.ur_type == 2) typeAccess = 'Право Судебная практика - Юрист РИК';
                                    else if(this.ur_type == 3) typeAccess = 'Право Судебная практика - Федеральный куратор';
                                } else if(this.ur_name == 'access_tech_card'){
                                    typeName = 'Доступ к техкарте';
                                    if(this.ur_type == 1) typeAccess = 'Полный доступ';
                                    else if(this.ur_type == 2) typeAccess = 'Частичный доступ';
                                    else if(this.ur_type == 3) typeAccess = 'Только чтение';
                                } else if (this.ur_name == 'cloud' && this.ur_type == 4) {
                                    typeName = ' Доступ к облаку';
                                    typeAccess = 'Да';
                                } else if (this.ur_name == 'plan' && this.ur_type == 4) {
                                    typeName = ' Право администрирования системы ПЗ';
                                    typeAccess = 'Да';
                                } else if (this.ur_name == 'sim' && this.ur_type == 4) {
                                    typeName   = 'Ответственный по сим-картам';
                                    typeAccess = 'Да';
                                } else if (this.ur_name == 'up' && this.ur_type == 4) {
                                    typeName   = ' ВВЕРХ';
                                    typeAccess = 'Да';
                                }

                                if(['party_registration','support_operator','financier'].indexOf(this.ur_name) == -1)
                                    rightsSimpleHtml += '<b>Право на '+typeName+': </b>'+typeAccess+'<br>';
                                return true;
                            }

                            if(this.ur_name.indexOf("-ik") > 0) typeName = 'ИК и резерв';
                            else if(this.ur_name.indexOf("-staffs") > 0) typeName = 'Штатные расписания';
                            else if(this.ur_name.indexOf("-costs") > 0) typeName = 'Сметы';
                            else if(this.ur_name.indexOf("-finplans") > 0) typeName = 'Фин-планы';
                            else if(this.ur_name.indexOf("-offense") > 0) typeName = 'Выборы - нарушения';
                            else if(this.ur_name.indexOf("-fractions") > 0) typeName = 'Фракции';
                            else if(this.ur_name.indexOf("-elections") > 0) typeName = 'Выборы';
                            else if(this.ur_name.indexOf("-projects") > 0) typeName = 'Партпроекты';
                            else if(this.ur_name.indexOf("-booker") > 0) typeName = 'Главный бухгалтер';
                            else if(this.ur_name.indexOf("-supporters") > 0) typeName = 'Сторонники';
                            else if(this.ur_name.indexOf("-partRadar") > 0) typeName = 'Парт-радар';
                            else if(this.ur_name.indexOf("-region_passport") > 0) typeName = 'Паспорт региона';
                            else typeName = 'Члены/секретари';

                            if(['district', 'district-supporters'].indexOf(this.ur_name) !== -1 && this.d_id === null){
                                this.pr_d_name = 'Федеральный';
                            } else if (this.ur_name === 'all_regions-region_passport') {
                                this.pr_d_name = 'Все регионы';
                            }

                            xhtml += '<tr>';
                            xhtml += '<td><b>'+typeName+': </b></td>';
                            xhtml += '<td>&nbsp;'+(this.ur_type == 1 ? 'Только чтение': 'Полный доступ')+' (<u>'+(this.pr_mo_d_name != undefined ? this.pr_mo_d_name+' -> '+this.pr_mo_r_name+' -> '+this.pr_mo_name : (this.pr_r_d_name != undefined ? this.pr_r_d_name+' -> '+this.pr_r_name : this.pr_d_name))+'</u>)</td>';
                            xhtml += '</tr>';
                        }
                    });
                    xhtml += '</table>';
                    xhtml += '<br>' + rightsSimpleHtml;

                } else if(tr.role != 'sys-admin' && tr.role != 'admin' && !cikFlag){
                    $("#private_office_tmpl #rules").append('У вас нет прав доступа.');
                } else{
                    $('#currRightsTitle').addClass('hidden');
                }

                $("#private_office_tmpl #rules").append(xhtml);
                $("#work_panel_wrap").html($("#private_office_tmpl").html().replace(/\{TMPL\}/g,''));
                $("#bd_remind").val(tr.bd_remind);
                $("#search_on_enter").val(tr.search_on_enter);
                var isEmployee = tr.role === 'employee';
                if(isEmployee){
                    $('#oper_email').parent().after($('#empl_data_tmpl').html());
                    $('#empl_email_work').parent().after($('#oper_email').parent());
                    $('#oper_email').prop('readonly', true);

                    $.tipTipMy('#oper_email','Адрес партийной почты');
                    $.inputHints('#empl_certificate','Номер удостоверения:');
                    $.inputHints('#empl_phone_work','Рабочий телефон:');
                    $.inputHints('#empl_phone_work_ext','Внутренний номер:');
                    $.inputHints('#empl_phone_mobile','Мобильный телефон:');
                    $.inputHints('#empl_phone_addition','Дополнительный телефон:');
                    $.inputHints('#empl_email','Личный email:');
                    $.inputHints('#empl_email_work','Служебный email:');
                    $.inputHints('#empl_facebook','Профиль в Facebook:');
                    $.inputHints('#empl_vkontakte','Профиль в VKontakte:');
                    $.inputHints('#empl_odnoklassniki','Профиль в Одноклассниках:');
                    $.inputHints('#empl_twitter','Профиль в Twitter:');
                    $.inputHints('#empl_website','Веб-сайт:');
                    $.inputHints('#empl_icq','ICQ-номер:');
                    $.inputHints('#empl_skype','Skype:');
                    $.inputHints('#empl_jabber','Jabber:');
                    $.inputHints('#empl_login','Логин:');
                    $.inputHints('#empl_pass','Пароль:');
                    $.inputHints('#empl_address','Адрес:');
                    $.inputHints('#empl_room_num','Номер комнаты:');
                    const photoSrc = typeof tr.data.m_personal_photo_small_full_path !== 'undefined' ? tr.data.m_personal_photo_small_full_path : '/files/member_photos/nophoto.jpg';
                    $('#profile_photo').attr('src', photoSrc + '?' + Math.random());

                    $('#empl_website').focusin(function(){
                        if($(this).val() == "") $(this).val("http://").caret(7);
                        $(this).select(false);
                    });
                    $('#empl_website').focusout(function(){
                        if(
                            $(this).val() == "http://" ||
                            $(this).val() == "https://" ||
                            ($(this).val().indexOf('http://') != 0 && $(this).val().indexOf('https://') != 0)
                        )
                            $(this).val("");
                    });

                    $.each(tr.data, function(){
                        if($('#'+arguments[0]).length && arguments[0] != 'empl_photo_big' && arguments[0] != 'empl_photo_small'){
                            if($('#'+arguments[0]).hasClass('checkbox'))
                                $('#'+arguments[0]).prop('checked', (arguments[1] == 1 ? false : true));
                            else if(arguments[1])
                                $('#'+arguments[0]).val(arguments[1]).removeClass('grey');
                        }
                    });

                    $('#empl_phone_mobile').mask('+7(999)999-99-99').focusout();
                    $("#empl_phone_work_ext").mask('9?999999999').focusout();

                    var changeProfilePhoto = function(fileElementId){
                        showAjaxLoading();
                        $.ajaxFileUpload ({
                            url:url,
                            secureuri:false,
                            fileElementId:fileElementId,
                            data: {qryType: 'uploadFile', fileElementId: fileElementId, fileType: 'update_employee_photos', 'cikFlag' : cikFlag},
                            dataType:'json',
                            success:function (tr, status) {
                                if(checkSession(tr)) {
                                    hideAjaxLoading();
                                    if(tr.error != ''){
                                        $('#work_panel_wrap label.'+fileElementId).html(tr.error);
                                    } else {
                                        $('#work_panel_wrap label.'+fileElementId).html('');
                                        var photoEl = $('#profile_photo'),
                                            photoElClone = photoEl;
                                        photoEl.prop('src', tr.data.new_url + '?' + Math.random());
                                    }
                                    $('#'+fileElementId).change(function(){
                                        changeProfilePhoto(fileElementId);
                                    });
                                }
                            }
                        });
                    };

                    $('#profile_photo_val').change(function(){
                        changeProfilePhoto($(this).attr('id'));
                    });
                } else {
                    $.inputHints('#oper_email','Адрес электронной почты:');
                    $('#oper_email').val($('#private_office_tmpl .oper_email').val());

                    $("#work_panel .skin_list input").change(function(){
                        showAjaxLoading();
                        $.ajax({
                            type:"POST",
                            url:"php/getData.php",
                            dataType:'json',
                            data:{'qryType':'set_skin', 'skin' : $(this).val()},
                            success: function(tr){
                                location.reload(false);
                            }
                        });
                    });

                    $("#work_panel .pinGridHeader input").prop('checked', __pinGridHeader__).change(function(){
                        showAjaxLoading();
                        var pinFlag = $(this).prop('checked');
                        $.ajax({
                            type:"POST",
                            url:"php/getData.php",
                            dataType:'json',
                            data:{'qryType':'set_pin', 'pin': pinFlag},
                            success: function(tr){
                                hideAjaxLoading();
                                __pinGridHeader__ = pinFlag;
                                $("#work_panel_wrap").removeAttr('class').addClass('pin_'+pinFlag);
                            }
                        });
                    });

                    $("#work_panel .rowNum #row_num").val(__rowNum__).change(function(){
                        showAjaxLoading();
                        var rowNum = $(this).val();
                        $.ajax({
                            type: "POST",
                            url:"php/getData.php",
                            dataType:'json',
                            data:{'qryType':'set_row_num', 'row_num': rowNum},
                            success: function(){
                                hideAjaxLoading();
                                __rowNum__ = rowNum;
                            }
                        });
                    });
                }

                $.tipTipMy('#oper_pass','Текущий пароль');
                $.tipTipMy('#oper_new_pass','Новый пароль');
                $.tipTipMy('#oper_new_pass_repeat','Подтверждение нового пароля');
                $(".button, .generate").button();

                hideAjaxLoading();

                $('#oper_new_pass')
                    .on('keyup focusin', (event) => {
                        showPasswordValidationTooltip(
                            '#oper_new_pass',
                            'position: absolute'
                        );
                    })
                    .focusout((event) => $('.passwordValidationTooltip').remove());

                $("#work_panel_wrap .generate").click(function(){
                    $(this).blur();
                    showAjaxLoading();
                    $.ajax({
                        type:"POST",
                        url:url,
                        dataType:'json',
                        data: {
                            qryType: 'generatePass',
                            cikFlag: cikFlag
                        },
                        success: function(tr){
                            hideAjaxLoading();
                            $("#oper_new_pass, #oper_new_pass_repeat").val(tr.data);
                        }
                    })
                });

                $("#work_panel_wrap .button.clear").click(function(){
                    $("#privateOffice").click();
                });

                $.wrapSubmit();

                $("#work_panel .private-office-form").validate({
                    keyup: true,
                    ignoreTitle: true,
                    ignore: [],
                    focusInvalid: false,
                    rules: {
                        empl_phone_addition:{minlength: 10, maxlength: 11},
                        empl_phone_work:{minlength: 5, maxlength: 11},
                        oper_pass: {required: "#oper_new_pass:filled"},
                        oper_new_pass: {
                            required: "#oper_pass:filled",
                            equalTo: "#oper_new_pass_repeat"
                        },
                        oper_new_pass_repeat: {
                            required: "#oper_pass:filled",
                            equalTo: "#oper_new_pass"
                        },
                        profile_photo_val: {accept: "image/*"}
                    },
                    invalidHandler: function(form, validator) {
                        $("#work_panel_wrap .work-res").html("&nbsp;");
                        setTimeout(function(){
                            $.each($('.private-office-form .field'), function(){
                                if ($(this).children()[0].id != "oper_email" ){
                                    if($(this).find('label').is(':visible'))
                                        $(this).children().addClass('error');
                                    else $(this).children().removeClass('error');
                                }
                            });
                        }, 0);
                    },
                    submitHandler:function (form) {
                        if ($('#oper_pass').val()?.trim()) {
                            const passwordValidationCheckData = passwordValidationCheck({
                                password: $("#oper_new_pass").val()
                            });
                            if (!passwordValidationCheckData.result) {
                                $('#oper_new_pass, #oper_new_pass_repeat').addClass('error');
                                $('#work_panel_wrap .work-res')
                                    .html(`<span class='error-msg'>Пароль: ${passwordValidationCheckData.message}</span>`)
                                    .animateHighlight("#FAF000", 1000);
                                return;
                            }
                            else {
                                $('#oper_new_pass, #oper_new_pass_repeat').removeClass('error');
                                $('#work_panel_wrap .work-res').html("&nbsp;");
                            }
                        }

                        $('#work_panel_wrap .work-res').html("&nbsp;");
                        $('#oper_pass, #oper_new_pass, #oper_new_pass_repeat').removeClass('error');
                        showAjaxLoading();

                        var data = $("#work_panel form").serializeArray();
                        data.push({name: 'qryType', value: 'updateUserData'});
                        data.push({name: 'cikFlag', value: cikFlag});
                        if(isEmployee){
                            $.each($('#work_panel form input[type=checkbox]:not(:checked)'), function(){
                                data.push({name: $(this).attr('id'), value: 'off'});
                            });
                        }
                        $.ajax({
                            type:"POST",
                            url:url,
                            dataType:'json',
                            data:data,
                            success: function(tr){
                                hideAjaxLoading();
                                if(checkSession(tr)) {
                                    if(tr.error != ''){
                                        $("#work_panel_wrap .work-res").html("<span class='error-msg'>"+tr.error+"</span>").animateHighlight("#FAF000", 1000);
                                    } else {
                                        $("#private_office_tmpl .private-office-form .oper_email").val($('#oper_email').val());
                                        $("#work_panel_wrap .work-res").html("<span class='success-msg'>"+tr.msg+"</span>").animateHighlight("#FAF000", 1000);
                                    }
                                }
                            }
                        });
                    }
                });
            }
        }
    });
};

(function ($) {
    $.jqGridInitHeader = function(){
        if ($('body.login').length) {
            return;
        }

        var place_for_scroll = $('#events_list').hasClass('selected') || $('#cellDetails').length ? 7 : 0;
        if(!$("#er_map").hasClass("selected") && !$("#news_list").hasClass("selected") && !$("#spec_news_list").hasClass("selected") && !$("#system_messages").hasClass("selected") && !$('#rik_card').hasClass('selected') && !$('#budget_filling').hasClass('selected')) {
            $('#work_panel').addClass('m-top-50');
        }

        if(place_for_scroll){
            if($("#eventPlacementsGrid").length) place_for_scroll = 0;
            $('#grid').setGridWidth($('#gbox_grid').parent().width() - place_for_scroll);
        }

        var grid_title = $('#gview_grid .ui-jqgrid-title'),
            grid_titlebar = $('#gview_grid .ui-jqgrid-titlebar'),
            gboxW = $('#gbox_grid').width(),
            wpW =
                $("#membersSelector").length > 0 ? ($("#membersSelector").width()+$("#membersSelector").parent().parent().position().left) :
                $("#offenseSelector").length > 0 ? ($("#offenseSelector").width()+$("#offenseSelector").parent().parent().position().left) :
                $("#paymentSelector").length > 0 ? ($("#paymentSelector").width()+$("#paymentSelector").parent().parent().position().left) :
                $("#budgetAccountsSelector").length > 0 ? ($("#budgetAccountsSelector").width() + $("#budgetAccountsSelector").parent().parent().position().left) :
                $("#work_panel_wrap").width() - place_for_scroll;

        $('#pager_center, #grid_toppager_center, #pager_right, #grid_toppager_right').removeAttr('style');
        if(wpW < gboxW){
            grid_titlebar.css({width: '100%'});

            $('#pager_center').offset({left: (wpW - $('#pager_center').width())});
            $('#grid_toppager_center').offset({left: (wpW - $('#grid_toppager_center').width())});

            $('#pager_right').offset({left: (wpW - $('#pager_right').width())});
            $('#grid_toppager_right').offset({left: (wpW - $('#grid_toppager_right').width())});
        } else {
            grid_titlebar.css({width: gboxW});

            $('#pager_center, #grid_toppager_center, #pager_right, #grid_toppager_right').css({right: 0});
        }

        if(typeof __userSkin__ != 'undefined' && __userSkin__ == 'wittera' && grid_title.length){
            var max_width = 0;
            grid_title.css({'left': 0, 'position': 'relative', 'opacity': 1});
            if(grid_title.offset().left - $('#grid_toppager_left').width() < 10){
                max_width = grid_titlebar.width() - $('#grid_toppager_left').width() - ( $('#grid_toppager_center').length ? $('#grid_toppager_center').width() : $('#grid_toppager_right').width() );
                if(max_width < 5){
                    grid_title.css({'opacity': 0});
                } else {
                    grid_title.css({'left': $('#grid_toppager_left').width() + 10, 'position': 'absolute', 'max-width': max_width});
                }
            }
        }

        //chrome hack: set header position
        //todo: optimize this
        if($.browser.chrome){
            grid_titlebar.animate({left: "-=0"},1,function(){
                $(this).css({width: '+=1'});
                $(this).css({width: '-=1'});
            });
            $("#pg_grid_toppager").css({width: '+=1px'});
            setTimeout(function(){
                $("#pg_grid_toppager").css({width: '100%'});
            },1);
        }

        if(__pinGridHeader__){
            $("#work_panel").unbind('scroll').scroll(function(){
                $.jsGridInitPinGridHeader(this);
            });
            setTimeout(function(){
                $("#work_panel").scroll();
            }, 1);
        }

        $.jsGridInitPaging();
        $.jsGridInitInputHints();
        $.shrinkGrid();
        $("#alertmodHistory").draggable({handle:'.ui-jqdialog-titlebar'});
        $("#addRights").draggable({handle:'.ui-jqdialog-titlebar'});
        $("#empl_full_size_photo").draggable({handle:'.ui-jqdialog-titlebar'});
    };

    $.jsGridInitPinGridHeader = function(_this){
        var headerEl = $('#work_panel_wrap.pin_true #gview_grid > .ui-jqgrid-hdiv'),
            marginTop = parseInt(headerEl.css('border-bottom-width')) + parseInt(headerEl.css('border-top-width')) +
                        parseInt(headerEl.css('margin-top')) + parseInt(headerEl.css('margin-bottom'));
        $('#grid').css({'margin-top': marginTop+headerEl.height()});
        headerEl.css({top: $(_this).scrollTop()});
    };

    $.jsGridInitPaging = function(){
        if( typeof __userSkin__ != 'undefined' && $.inArray( __userSkin__ , [ 'mikki' , 'bondi' , 'pumpkin' , 'linen' ]) != -1 ){
            $("#footer .ui-paging-info").remove();
            $("#footer").append($("#grid_toppager_right .ui-paging-info").clone());
        }
    };

    $.jsGridInitInputHints = function(){
        if(typeof __userSkin__ != 'undefined'){
            if(__userSkin__ == 'linen' || __userSkin__ == 'pumpkin'){
                $.each($('#gview_grid .ui-search-toolbar input:visible'), function() {
                    this.placeholder = 'Найти'
                });
            }
        }
    };

    $.jqGridSubGridRebuild = function(divid, rowid, hideAjaxLand){
        $('#grid').setGridParam({'chckDateFilSubGrid':divid});
        setTimeout(function(){
            if($('#'+divid+' table').length > 0){
                if(typeof hideAjaxLand == 'undefined')
                    hideAjaxLoading();
                $('.ui-subgrid .fa-eye.link-simple').click(function(){
                    $(this).parents('.ui-subgrid:first').prev('.jqgrow').find('.ui-sgcollapsed .link-simple').click();
                });
                if (!$('#'+divid+' .ui-search-toolbar').length) {
                    $('#'+divid+' tr:even').addClass('subgridRowAlt');
                    $('#grid_'+rowid+' .st_posts_dtl .subgridRowAlt').removeClass('subgridRowAlt');
                }
            } else {
                $.jqGridSubGridRebuild(divid, rowid, hideAjaxLand);
            }
        },100);
    };

    $.jqGridSubGridToolbarRebuild = function(){
        $.each($('.ui-subgrid .navtable .ui-pg-button span'), function(k, v){
            if($(this).hasClass('ui-icon-plus')) $(this).attr('class','fa fa-plus');
            else if($(this).hasClass('ui-icon-document')) $(this).attr('class','fa fa-file-text-o');
            else if($(this).hasClass('ui-icon-trash')) $(this).attr('class','fa fa-trash-o');
            else if($(this).hasClass('ui-icon-search')) $(this).attr('class','fa fa-search');
            else if($(this).hasClass('ui-icon-disk')) $(this).attr('class','fa fa-file-excel-o');
            else if($(this).hasClass('ui-icon-pencil')) $(this).attr('class','fa fa-pencil');
            else if($(this).hasClass('ui-icon-refresh')) $(this).attr('class','fa fa-refresh');
            else if($(this).hasClass('ui-icon-print')) $(this).attr('class','fa fa-print');
            else if($(this).hasClass('ui-icon-grip-solid-vertical')) $(this).attr('class','fa fa-eye-slash');
            else if($(this).hasClass('ui-separator')) $(this).parent().show();
            else if($(this).hasClass('ui-icon-note')) $(this).attr('class','fa fa-list');
            else if($(this).hasClass('ui-icon-person')) $(this).attr('class','fa fa-photo');
            else if($(this).hasClass('ui-icon-clock')) $(this).attr('class','fa fa-file-archive-o');
            else if($(this).hasClass('ui-icon-circle-check')) $(this).attr('class','fa fa-check-circle');
            else if($(this).hasClass('ui-icon-circle-close')) $(this).attr('class','fa fa-times-circle');
            else if($(this).hasClass('ui-icon-calculator')) $(this).attr('class','fa fa-list-alt');
            else if($(this).hasClass('ui-icon-wrench')) $(this).attr('class','fa fa-send-o');
            else if($(this).hasClass('fa-separator'))
                $(this)
                    .parent().parent().removeClass('ui-corner-all')
                    .addClass('ui-state-disabled')
                    .css({display: 'table-cell', width: '4px'})
                    .html('<span class="ui-separator"></span>');
        });
    };

    $.shrinkGrid = function () {
        var grid_url = $('#grid').jqGrid('getGridParam', 'url');
        if (__grid_size__ && __grid_size__[grid_url]) {
            var width,
                font_size;
            if (__grid_size__[grid_url].set_full_size) {
                width = __grid_size__[grid_url].width;
                font_size = __grid_size__[grid_url].font_size;
                delete __grid_size__[grid_url];
            } else {
                width = $('#work_panel_wrap').width() + 10;
                font_size = 12;
            }
            $('#gview_grid, #gview_grid a').attr('style', 'font-size: ' + font_size + 'px !important');
            $('#grid').setGridWidth(width);
            $.each($('.ui-jqgrid-htable .ui-jqgrid-resize'), function(){
                $(this).mousedown();
                $(this).mouseup();
            });
        }
        $('.ui-jqgrid-resize').css('height', 0);
        $('.ui-jqgrid-sortable').css('padding-top', 0);
    };

    $.erdbSelectStyle = function (sel) {
        $.each($(sel + ' select'), function () {
            if (!$(this).parent().hasClass('select-erdb-style')) {
                $(this)
                    .width('calc(100% + 20px)')
                    .wrap('<div class="select-erdb-style" />');
            }
        });
    };

    $.erdbDateReStyle = function(sel){
        if($("#work_panel #gs_m_bday_yy").length == 0 && $("#work_panel #gs_m_supporter_admission_date_yy").length == 0) {
            var dateEl = $(sel);
            dateEl.prop('type','hidden');

            if(['#gs_m_bday', '#gs_bday'].includes(sel)) {
                dateEl.after($("#select_option_years_tmpl").html());
                dateEl.after($("#select_option_months_tmpl").html());
                dateEl.after($("#select_option_days_tmpl").html());

                $("#work_panel #gs_m_bday_yy, #work_panel #gs_m_bday_mm, #work_panel #gs_m_bday_dd").change(function () {
                    $('#grid').trigger('reloadGrid');
                });
            } else if(sel == '#gs_m_supporter_admission_date') {
                dateEl.after($("#select_option_adm_years_tmpl").html());
                dateEl.after($("#select_option_adm_months_tmpl").html());
                dateEl.after($("#select_option_adm_days_tmpl").html());

                $("#work_panel #gs_m_supporter_admission_date_yy, #work_panel #gs_m_supporter_admission_date_mm, #work_panel #gs_m_supporter_admission_date_dd").change(function () {
                    $('#grid').trigger('reloadGrid');
                });
            }
        }
    };

    $.footerCleaner = function(sel){
        setTimeout(function(){
            if($(sel).length == 0){
                $("#footer").html('');
            } else {
                $.footerCleaner(sel);
            }
        },500);
    };

    $.create_popup_dialog = function (xhtml, title, submitFunc, add_buttons, openFunc, closeFunc, disableСloseOverlay, popup_cnt) {
        var buttons = [];

        buttons[buttons.length] = {
            text: "Отмена",
            class: "fm-button f-left",
            style: "color: #bdbdbd;",
            click: function() { $(this).dialog("close"); }
        };

        if(typeof submitFunc == 'function'){
            buttons[buttons.length] =
            {
                text: "Ок",
                class: "submit fm-button f-right",
                click: function(){
                    submitFunc();
                    $(this).dialog("close");
                }
            };
        }

        if(add_buttons){
            for (var i = 0; i < add_buttons.length; i++){
                if(!add_buttons[i]['text']) continue;

                buttons[buttons.length] =
                {
                    text: add_buttons[i]['text'],
                    class: "fm-button f-right " + (add_buttons[i]['classes'] ? add_buttons[i]['classes'] : ''),
                    click: add_buttons[i]['func']
                };
            }
        }

        if (!popup_cnt) {
            popup_cnt = $('#popup_dialog').length;
            if(!popup_cnt) {
                popup_cnt = '';
            }
        }

        var $dialog = $('<div id="popup_dialog_form' + popup_cnt + '"></div>')
            .html(xhtml)
            .dialog({
                autoOpen: true,
                title: title,
                closeoverlay: !disableСloseOverlay,
                modal: true,
                position: ['middle', 150],
                width: 'auto',
                zIndex: 3001,
                close: function (ev, ui) {
                    $(this).dialog('destroy');
                    $('#popup_dialog_form'+popup_cnt).remove();
                    if(typeof closeFunc == 'function') {
                        closeFunc();
                    }
                },
                open: function (ev, ui) {
                    $('.ui-dialog-buttonset :button').blur();

                    if (!disableСloseOverlay) {
                        $('body .ui-widget-overlay:last').click(function () {
                            $('#popup_dialog' + popup_cnt).find('a.ui-dialog-titlebar-close').click();
                        });
                    }

                    if(typeof openFunc == 'function') {
                        openFunc('popup_dialog' + popup_cnt);
                    }
                },
                create: function (event, ui) {
                    $(this).parent().attr('id', 'popup_dialog' + popup_cnt).addClass('popup_dialog');
                },
                buttons: buttons
            });

        return $dialog;
    };

    $.jqGridPoMerge = function(){
        var rowid = $('#grid').jqGrid('getGridParam', 'selrow'),
            rowData = $('#grid').jqGrid('getRowData', rowid),
            mo_id = rowData.mo_id,
            po_id = rowData.po_id;

        $.create_popup_dialog(
            '<table class="members_data">'+
                '<tr><td class="">Выберите к какому ПО прикрепить персоналиев из удаляемого ПО:</td></tr>'+
                '<tr><td>'+
                    '<input id="po_merge_mo_id" type="hidden" value="'+mo_id+'" />'+
                    '<select id="po_new_id">'+
                        '<option value="">Первичное отделение:</option>'+
                    '</select>'+
                '</td></tr>'+
            '</table>',
            'Объединение ПО',
            function(){
                showAjaxLoading();
                $.ajax({
                    type:'POST',
                    url:'php/tbl.PO.MEMB.php',
                    dataType:'json',
                    data:{oper: 'add', fstVal: po_id, sndVal: $('#po_new_id').val()},
                    success: function(tr){
                        checkSession(tr);
                        $('#grid').trigger('reloadGrid');
                    }
                });
            }
        );

        $.jqGridPoList ('#po_merge_mo_id', '#po_new_id', -1, '', function(){
            $('#po_new_id option[value="'+po_id+'"]').remove();
            $('#po_new_id option').eq(0).prop('disabled', true);
        });

        $('#popup_dialog .submit').hide();
        $('#po_new_id').change(function(){
            $('#popup_dialog .submit').show(300);
        });
    };

    $.jqGridMembMerge = function(passport_access){
        var $dialog = $('<div id="memb_merge_form"></div>')
            .html(
                '<form>' +
                    '<input autofocus>'+
                    '<table class="members_data">'+
                        '<tr>'+
                            '<td class="row_name"></td>'+
                            '<td>'+
                                '<input id="m_fio" name="m_fio" class="grey required" value="">'+
                                '<input type="hidden" id="m_id" name="m_id" value="-1">'+
                            '</td>'+
                            '<td>'+
                                '<input id="m_transfer_fio" name="m_transfer_fio" class="grey required" value="">'+
                                '<input type="hidden" id="m_transfer_id" name="m_transfer_id" value="-1">'+
                            '</td>'+
                            '<td class="merge-link-parent">'+
                                '<span class="merge-link open">Список данных</span>'+
                                '<span class="merge-link close hidden">Скрыть список</span>'+
                            '</td>'+
                        '</tr>'+
                    '</table>'+
                '</form>'
            )
            .dialog({
                autoOpen: true,
                title: 'Объединение персоналий',
                closeoverlay: true,
                modal: true,
                position: ['middle', 'middle'],
                width: "auto",
                zIndex : 3001,
                close: function( ev, ui ) {
                    $(this).dialog("destroy");
                    $(this).remove();
                },
                open: function( ev, ui) {
                    $('#memb_merge_form input:first').remove();
                    $('body .ui-widget-overlay:last').click(function(){
                        $('#memb_merge_form').parent().find('a.ui-dialog-titlebar-close').click();
                    });
                    var m_id_t = $('#m_transfer_id').val(),
                        m_id_o = $('#m_id').val();

                    $('#m_transfer_fio, #m_fio').prop('readonly', true);

                    $('.party_match').remove();
                    $('#m_transfer_fio').after('<i class=\"transfer match_popup fa fa-user party_match' + (m_id_t && m_id_t != -1 ? '' : ' no_match') + '\" m_id=\"' + (m_id_t ? m_id_t : '') + '\" title=\"партийное соответствие\"></i>');
                    $('#m_fio').after('<i class=\"orig match_popup fa fa-user party_match' + (m_id_o && m_id_o != -1 ? '' : ' no_match') + '\" m_id=\"' + (m_id_o ? m_id_o : '') + '\" title=\"партийное соответствие\"></i>');

                    $('.party_match').click(function(){
                        if($(this).hasClass('transfer'))
                            set_party_match($(this), '#m_transfer_fio', '#m_transfer_id', true, false, false, false, ['memb_merge', passport_access]);
                        else if($(this).hasClass('orig'))
                            set_party_match($(this), '#m_fio', '#m_id', true, false, false, false, ['memb_merge', passport_access]);
                    });

                    $("#memb_merge form").validate({
                        keyup: true,
                        ignore: [],
                        ignoreTitle: true,
                        focusInvalid: false,
                        submitHandler:function (form) {
                            showAjaxLoading();
                            var data = $("#memb_merge form").serializeArray();
                            data.push({name: 'qryType', value: 'membMerge'});

                            $.each($('#memb_merge select'), function(){
                                data.push({name: $(this).removeClass('valid').attr('class'), value: $(this).val()});
                            });

                            $.ajax({
                                type:"POST",
                                url:"php/getData.php",
                                dataType:"json",
                                data: data,
                                success:function (tr) {
                                    hideAjaxLoading();
                                    checkSession(tr);
                                    if (tr.error) {
                                        $('#memb_merge .server_error, label.error[for = m_fio], label.error[for = m_transfer_fio]').detach();
                                        if (tr.error === 'Выбран один и тот же персоналий') {
                                            $('#m_transfer_fio').addClass('error').after('<label for="m_transfer_fio" generated="true" class="error"></label>');
                                            $('#m_fio').addClass('error').after('<label for="m_fio" generated="true" class="error"></label>');
                                            $('label.error[for = m_fio], label.error[for = m_transfer_fio]').html(tr.error);
                                            $('#memb_merge').find('.submit').blur();
                                        } else {
                                            $('#m_transfer_fio, #m_fio').removeClass('error');
                                            $('#memb_merge form').prepend('<span class="server_error" style="border: 1px solid red; display: block; margin-bottom: 18px;"><label style="color:red; margin-left: 5px; font-size: 14px; font-weight: bold;"></label></span>');
                                            $('#memb_merge .server_error label').html(tr.error);
                                            $('#memb_merge').find('.submit').blur();
                                        }
                                    } else {
                                        $('body .ui-widget-overlay:last').click();
                                        $.create_popup_dialog(
                                            'Объединение персоналий прошло успешно.',
                                            'Информация',
                                            false,
                                            false,
                                            popupDialogId => $(popupDialogId.replace('popup_dialog', '#popup_dialog_form')).dialog({
                                                width: 280,
                                                buttons: [
                                                    {
                                                        text: "Закрыть",
                                                        class: "fm-button f-left",
                                                        style: "color: #bdbdbd;",
                                                        click: function() { $(this).dialog("close"); }
                                                    }
                                                ]
                                            }),
                                            () => $('#grid')[0].triggerToolbar()
                                        );
                                    }
                                }
                            });
                        }
                    });
                },
                create: function( event, ui ) {
                    $(this).parent().attr('id', 'memb_merge');
                    $.inputHints('#m_transfer_fio', 'ФИО главного персоналия');
                    $.inputHints('#m_fio', 'ФИО удаляемого персоналия');
                },
                buttons: [
                    {
                        text: "Отмена",
                        class: "fm-button f-left",
                        style: "color: #bdbdbd;",
                        click: function() {
                            $(this).dialog("destroy");
                            $('#memb_merge_form').remove();
                        }
                    },
                    {
                        text: "Объединить",
                        class: "submit fm-button f-right",
                        click: function(){
                            $('label.error[for = m_fio], label.error[for = m_transfer_fio]').detach();

                            const mTransferId = parseInt($('#m_transfer_id').val()),
                                mId = parseInt($('#m_id').val()),
                                mTransferFioElm = $('#m_transfer_fio'),
                                mFioElm = $('#m_fio');

                            mTransferFioElm.removeClass('error');
                            mFioElm.removeClass('error');

                            if (mTransferId === -1 || mId === -1) {
                                if (mTransferId === -1) {
                                    mTransferFioElm.addClass('error').after('<label for="m_transfer_fio" generated="true" class="error">Не задано партийное соответствие</label>');
                                }
                                if (mId === -1) {
                                    mFioElm.addClass('error').after('<label for="m_fio" generated="true" class="error">Не задано партийное соответствие</label>');
                                }
                                $('#memb_merge').find('.submit').blur();
                                return;
                            }

                            if (mTransferId === mId) {
                                mTransferFioElm.addClass('error').after('<label for="m_transfer_fio" generated="true" class="error">Выбран один и тот же персоналий</label>');
                                mFioElm.addClass('error').after('<label for="m_fio" generated="true" class="error">Выбран один и тот же персоналий</label>');
                                $('#memb_merge').find('.submit').blur();
                                return;
                            }

                            if (!$('#memb_merge_form .memb_data').length) {
                                $('#memb_merge_form .merge-link.open').click();
                                if ($('#memb_merge_form .memb_data').length) {
                                    return;
                                }
                            }

                            const emEmailElement = $('select.em_email');
                            if (emEmailElement.length &&
                                (parseInt(emEmailElement.val()) === 1 && !$('#memb_merge_form .memb_merge_em_email_second').text()) ||
                                (parseInt(emEmailElement.val()) === 0 && !$('#memb_merge_form .memb_merge_em_email_first').text())
                            ) {
                                $.create_popup_dialog(
                                    'У персоналия будет удалён партийный адрес электронной почты. Продолжить?',
                                    'Предупреждение',
                                    () => $("#memb_merge form").submit(),
                                    false,
                                    popupDialogId => $(popupDialogId.replace('popup_dialog', '#popup_dialog_form')).dialog({
                                        width: 280
                                    })
                                );
                            }
                            else {
                                $("#memb_merge form").submit();
                            }
                        }
                    }
                ]
            });
    };

    $.jqGridMOListByRIK = function(data){
        showAjaxLoading();
        var RIKId = data.rId,
            mId = data.mId,
            rightType = data.rightType;

        var sendData = {
            qryType:'moListByRIK',
            RIKId:RIKId,
            rightType: rightType
        };

        $.ajax({
            type:"POST",
            url:"php/getData.php",
            dataType:'json',
            data:sendData,
            success: function(tr){
                hideAjaxLoading();
                var moEl = (data.editType == 'form' ? $('#mo_name') : $('#'+data.rowid+'_mo_name'));

                var moOpt = '<option value="">Местное отделение:</option>';
                $.each(tr.data, function(){
                    moOpt += '<option value="'+this.mo_id+'" fias="' + this.mo_okato_id + '" '+(mId == this.mo_id ? "selected=\'selected\'" : "")+'>'+this.mo_name+'</option>';
                });

                moEl.html("").append(moOpt).parent().animateHighlight("#FAF000", 1000);
                if(tr.data.length == 1){
                    moEl.find('option:last').attr("selected", "selected");
                }
            }
        });
    };

    $.jqGridTIKListByRIK = function(data){
        showAjaxLoading();

        $.ajax({
            type:"POST",
            url:"php/getData.php",
            dataType:'json',
            data:{'qryType':'tikListByIKS', 'RIKId':data.rId},
            success: function(tr){
                hideAjaxLoading();
                var tikEl = (data.editType == 'form' ? $('#tik_name') : $('#'+data.rowid+'_tik_name'));

                var tikOpt = '<option value="">Территориальная ИК:</option>';
                $.each(tr.data, function(){
                    tikOpt += '<option value="'+this.tik_id+'" '+(data.tikId == this.tik_id ? "selected=\'selected\'" : "")+'>'+this.tik_name+'</option>';
                });

                tikEl.html("").append(tikOpt).parent().animateHighlight("#FAF000", 1000);
                if(tr.data.length == 1){
                    tikEl.find('option:last').attr("selected", "selected");
                }
            }
        });
    };

    $.dropDownChange = function(titleid){
        var cnt = 0;
        var selectors = $('#' + titleid.split('_title')[0] + '_child');
        $.each(selectors.find('li'), function(){
            if($(this).hasClass('selected')){
                cnt++;
                return false;
            }
        });

        if(cnt == 0){
            $("#" + titleid).find('.ddlabel').css({'color': '#5f5f5f'});
        } else {
            $("#" + titleid).find('.ddlabel').css({'color': '#ffffff'});
        }

        if(titleid == "disctrict_title"){
            $("#" + titleid).find('.ddlabel').html("Федеральный округ:");
        } else if(titleid == "sng_id_title"){
            $("#" + titleid).find('.ddlabel').html("Группы пользователей:");
        } else if (titleid == "rik_unit_title"){
            $("#" + titleid).find('.ddlabel').html("Региональное отделение:");
        } else if (titleid == "offense_type_title"||titleid == "offs_type_title"){
            $("#" + titleid).find('.ddlabel').html("Вид нарушения:");
        } else if (titleid == "right_budget_title"){
            $("#" + titleid).find('.ddlabel').html("Доступ к финансированию...");
        } else if (titleid == "strat_monitor_rik_list_title"){
            $("#" + titleid).find('.ddlabel').html("РО...");
        } else if (titleid == "ap_category_title") {
            $("#" + titleid).find('.ddlabel').html("Вид нарушения: ");
        }
    };

    $.jqGridRIKList = async function(dElId, rikElId, moElId, strId, getMoListFlag, role, section){
        var dId = $(dElId).val();
        section = (typeof section == 'undefined' ? '' : section);
        const tr = await $.ajax({
            type:"POST",
            url:dirUp+"php/getData.php",
            dataType:'json',
            data:{'qryType':'rikListByOperator', 'districtId':dId, 'strId': strId, childLvl: role, section: section}
        });
        checkSession(tr);
        var rName = '',
            hdr = (role == 'fraction' ? 'Название региона' : 'Региональное отделение'),
            rikOpt = '<option value="">'+hdr+':</option>';

        if(!!tr.data) {
            $.each(tr.data, function () {
                if (role == 'fraction' || role === 'offense')
                    rName = this.r_reg_name;
                else rName = this.r_name;

                if (!isNaN(this.r_id)) {
                    if (tr.data.currRId == this.r_id) {
                        rikOpt += '<option value="' + this.r_id + '" selected="selected"';
                        getMoListFlag = true;
                    } else {
                        rikOpt += '<option value="' + this.r_id + '" ';
                    }
                    rikOpt += ($.inArray(role, ['projects_regional']) != -1 ? 'fias="' + this.r_okato_id + '"' : '') + ' >' + rName + '</option>';
                }
            });
        }

        $(rikElId).html(rikOpt).change().show().parent().animateHighlight('#FAF000', 1000);
        if (typeof disablePartyMemberRegion === 'function' &&
            ['#members_list', '#members_for_deletion', '#deputies', '#memb_notifies', '#party_members', '#supporters', '#imported_supporters', '#supporters_site'].includes(location.hash)
        ) {
            disablePartyMemberRegion();
        }
        if (role == 'projects_regional' && $('#prjr_level').val() != 0 && !$('#prjr_okato_not_exists').prop('checked')) {
            var fias_guid = $('#' + $('#grid').jqGrid('getGridParam', 'selrow') + ' td[aria-describedby=\"grid_fias_guid\"]').html();
            const postTr = await $.ajax({
                type: "POST",
                url: 'php/getData.php',
                dataType: 'json',
                data: {
                    qryType: 'getOkatoParents',
                    fias_guid: fias_guid,
                }
            });
            checkSession(postTr);
            if (postTr.data) {
                for (var i = postTr.data.length - 1; i >= 0; i--) {
                    $('#editmodgrid li[fias_guid="' + postTr.data[i].parent_aoguid + '"] div').click();
                }
                $('#editmodgrid li[fias_guid="' + fias_guid + '"] span').addClass('mytreeviewselected');
                $('#tr_prjr_fias_name .mytreeviewselected').click();
            }
        }

        if ($(rikElId + ' option:not([value=""])').length == 1) {
            $(rikElId + ' option:not([value=""])').prop('selected', true);
            getMoListFlag = true;
        }

        if($.inArray(role, ['r-operator', 'rik', 'elect_history_regional', 'fraction', 'projects_regional', 'projects_regional_objects', 'finplans', 'budget_accounts', 'budget_contractor', 'electoral_districts', 'territorial_groups', 'offense']) == -1){
            var moOpt = '<option value="">Местное отделение:</option>';
            $(moElId).html(moOpt).parent().animateHighlight("#FAF000", 1000);
        } else {
            getMoListFlag = false;
        }

        if (getMoListFlag) {
            await $.jqGridMoList(rikElId, moElId, strId, role);
        } else if ($('#grid_m_id').length > 0) {
            const poElId = ('#'+($('#editmodgrid').is(':visible') ? '' : strId + '_')+'po_name'),
                poOpt = '<option value="">Первичное отделение:</option>';
            $(poElId).html("").append(poOpt).parent().animateHighlight("#FAF000", 1000);
        }

        // if($('#grid_m_id').length > 0){
        //     var poElId = ('#'+($('#editmodgrid').is(':visible') ? '' : strId + '_')+'po_name');
        //     var poOpt = '<option value="">Первичное отделение:</option>';
        //     $(poElId).html("").append(poOpt).parent().animateHighlight("#FAF000", 1000);
        // }
    };

    $.jqGridMoList = async function(rikElId, moElId, usrId, role, isMunMo, cb){ // mo_type: 0 - mo; 1 - mun mo
        var rId = $(rikElId).val();

        const tr = await $.ajax({
            type:"POST",
            url:"php/getData.php",
            dataType:'json',
            data:{'qryType':'moListByOperator', 'RIKId':rId, 'usrId':usrId, 'role': role, isMunMo: isMunMo}
        });
        checkSession(tr);
        var moOpt = '<option value="">Местное отделение:</option>';

        if (!!tr.data) {
            $.each(tr.data, function(){
                if(!isNaN(this.mo_id))
                    moOpt += '<option value="'+this.mo_id+'" '+(tr.data.currMId == this.mo_id ? "selected=\'selected\'" : "")+'>'+this.mo_name+'</option>';
            });
        }

        $(moElId).html(moOpt).show().parent().animateHighlight('#FAF000', 1000);

        if ($(moElId + ' option:not([value=""])').length == 1) {
            $(moElId + ' option:not([value=""])').prop('selected', true);
        }

        if($('#grid').hasClass('run_mo_change')){
            $(moElId).change();
        }

        if($('#grid_m_id').length > 0){
            var poElId = ('#'+($('#editmodgrid').is(':visible') ? '' : usrId + '_')+'po_name');
            if($(moElId).val() != '')
                await $.jqGridPoList(moElId, poElId, usrId, role);
            else {
                var poOpt = '<option value="">Первичное отделение:</option>';
                $(poElId).html("").append(poOpt).parent().animateHighlight("#FAF000", 1000);
            }
        }

        if(typeof cb == 'function'){
            cb();
        }
    };

    $.jqGridPoList = async function(moElId, poElId, usrId, role, cb){
        const tr = await $.ajax({
            type:"POST",
            url:"php/getData.php",
            dataType:'json',
            data:{'qryType':'poListByOperator', 'MIKId':$(moElId).val(), 'usrId':usrId, role: role ? role : ''}
        });
        checkSession(tr);
        var poOpt = '<option value="">Первичное отделение:</option>';
        $.each(tr.data, function(){
            if(!isNaN(this.po_id))
                poOpt += '<option value="'+this.po_id+'" '+(tr.data.currPId == this.po_id ? "selected=\'selected\'" : "")+'>'+this.po_name+'</option>';
        });

        $(poElId).html("").append(poOpt).show().parent().animateHighlight("#FAF000", 1000);

        if(typeof cb == 'function'){
            cb();
        }
    };

    $.jqGridSetSelectorHandlers = async function(strId, dElId, rikElId, moElId, poElId, role, section){
        $(dElId+', '+rikElId+', '+moElId).unbind();
        section = (typeof section == 'undefined' ? '' : section);

        if (['m-operator', 'mo', 'po', 'deputies_meetings', 'electoral_districts_local', 'territorial_groups_local', 'memb_notifies'].includes(role)) {
            if ($(dElId).val() != "") {
                await $.jqGridRIKList(dElId, rikElId, moElId, strId, $(dElId).val() != 0, role, section);
            }

            // e.originalEvent - свойство есть, когда элемент в фокусе.
            // Здесь предотвращает повторные вызовы события change из функции $.jqGridRIKList:
            // служит идентификатором того, что событие было вызвано из интерфейса, а не из кода
            var locationHash = location.hash;
            $(dElId).change(async function(e){
                if(e.originalEvent) {
                    await $.jqGridRIKList(dElId, rikElId, moElId, strId, false, role, section);
                }

                if(['#members_list', '#deputies', '#memb_notifies', '#party_members', '#supporters'].includes(locationHash)){
                    if($(dElId).val() == 0){
                        $('#grid').jqGrid('setColProp', 'r_name', { editrules: {required: false, edithidden: true} });
                        $('#grid').jqGrid('setColProp', 'mo_name', { editrules: {required: false, edithidden: true} });
                    } else {
                        $('#grid').jqGrid('setColProp', 'r_name', { editrules: {required: true, edithidden: true} });
                        $('#grid').jqGrid('setColProp', 'mo_name', { editrules: {required: $('#m_party_memb').prop('checked') || $('#m_supporter_type').val() == 'Перешел в члены Партии', edithidden: true} });
                    }

                }
            });
            $(rikElId).change(async function(e){
                if(e.originalEvent) {
                    await $.jqGridMoList(rikElId, moElId, strId, role);
                }
            });
            if(poElId != -1) {
                $(moElId).change(async function (e) {
                    if(e.originalEvent){
                        if ($(this).val() != '')
                            await $.jqGridPoList(moElId, poElId, strId);
                        else $(poElId).html('<option value="">Первичное отделение:</option>');
                    }
                });
            }

            $(dElId).show().parent().animateHighlight("#FAF000", 1000);
        } else if (['r-operator', 'rik', 'premise_provision', 'fraction', 'finplans', 'budget_accounts', 'budget_contractor', 'electoral_districts', 'territorial_groups', 'elect_history_regional', 'offense'].includes(role)) {
            if ($(dElId).val() != "" && $(dElId).val() != 0) {
                await $.jqGridRIKList(dElId, rikElId, moElId, strId, false, role, section);
            }

            $(moElId).hide();
            $(moElId+" option:first").attr("value","-1");
            $(dElId).change(async function(){
                if($(this).val() == 0)
                    $(rikElId).html('');
                else
                    await $.jqGridRIKList(dElId, rikElId, moElId, strId, false, role, section);
            });
            $(dElId).show().parent().animateHighlight("#FAF000", 1000);
        } else if (role == 'd-operator') {
            $(rikElId).hide();
            $(moElId).hide();
            $(rikElId+" option:first").attr("value","-1").html('');
            $(moElId+" option:first").attr("value","-1");
            $(dElId).show().parent().animateHighlight("#FAF000", 1000);
        } else if (role == 'admin'){
            $(dElId).hide();
            $(rikElId).hide();
            $(moElId).hide();
            $(dElId+" option:first").attr("value","-1");
            $(rikElId+" option:first").attr("value","-1");
            $(moElId+" option:first").attr("value","-1");
        } else if(['projects_regional', 'projects_regional_objects'].indexOf(role) !== -1){
            $(dElId).on('change', async (e) => {
                if (e.target.value) {
                    await $.jqGridRIKList(dElId, rikElId, moElId, strId, false, role, section);
                }
            });
        }
    };

    $.jqGridIKLists = function(rowid, tblName) {
        var strId, dElId, rikElId, moElId, role, poElId;
        strId = rowid;
        dElId = '#'+strId+'_d_name';
        $(dElId+' option:first').prop('disabled', true);
        rikElId = '#'+strId+'_r_name';
        moElId = '#'+strId+'_mo_name';
        if(tblName == 'oper'){
            role = $('#'+strId+' td[aria-describedby=\"grid_u_role_2\"] input').val();
            poElId = -1;
        } else if(tblName == 'memb'){
            role = 'mo';
            poElId = '#'+strId+'_po_name';
        } else if(tblName == 'po'){
            role = 'po';
            poElId = -1;
        } else if(tblName == 'cmp'){
            role = 'rik';
            poElId = -1;
            moElId = -1;
        }
        $.jqGridSetSelectorHandlers(strId, dElId, rikElId, moElId, poElId, role);
    };

    $.jqGridEditModGrid = async function (isAddMode){
        var locationHash = location.hash;
        if(['#operator_list', '#members_list', '#deputies', '#memb_notifies', '#party_members', '#election_campaigns', '#elect_history_regional', '#premise_provision', '#zs_list', '#projects_regional_list', '#finplan_list', '#budget_contractor', '#budget_accounts', '#supporters', '#deputies_meetings', '#join_po_members', '#merge_districts', '#territorial_groups', '#merge_districts_local', '#territorial_groups_local', '#members_for_deletion', '#projects_regional_objects_list'].indexOf(locationHash) !== -1){
            var strId, dElId, rikElId, moElId, poElId, role, section;
            var getLists = async function(){
                var $editmodgrid = $('#editmodgrid');
                $editmodgrid.find('i.fa-globe.ui-icon-locked, i.fa-list-alt.ui-icon-locked, i.fa-ticket.ui-icon-locked, i.fa-users.ui-icon-locked').css({'display':'none'});
                var row = $('#' + $('#grid').jqGrid('getGridParam', 'selrow'));
                const is_party_member = row.find('td.m_party_memb_col > input').prop('checked');
                if ((row.find('.ui-inline-del').length == 0 && row.find('.ui-inline-soft-del').length == 0 && row.find('.ui-inline-edit').length == 0 || (row.find('.m_vr_id').html() > 0 && is_party_member) || row.find('.m_check_elections_rights').html() > 0) && !isAddMode && locationHash !== '#members_for_deletion' || locationHash == '#supporters' && isAddMode == 'closed') {
                    $editmodgrid.css({'opacity': '1'});
                    var err = '';
                    $('#d_name').html('<option value="'+row.find('td[aria-describedby="grid_d_id"]').html()+'">'+row.find('td[aria-describedby="grid_d_name"]').html()+'</option>');
                    $('#r_name').html('<option value="'+row.find('td[aria-describedby="grid_r_id"]').html()+'">'+row.find('td[aria-describedby="grid_r_name"]').html()+'</option>');
                    $('#mo_name').html('<option value="'+row.find('td[aria-describedby="grid_mo_id"]').html()+'">'+row.find('td[aria-describedby="grid_mo_name"]').html()+'</option>');
                    $('#po_name').html('<option value="'+row.find('td[aria-describedby="grid_po_id"]').html()+'">'+row.find('td[aria-describedby="grid_po_name"]').html()+'</option>');
                    if ((row.find('.m_check_elections_rights').html() > 0 || (row.find('.m_vr_id').html() > 0 && is_party_member)) && (row.find('.ui-inline-del').length || row.find('.ui-inline-soft-del').length || row.find('.ui-inline-edit').length)) {
                        setTimeout(async () => {
                            const $updEditModGrid =  $('#editmodgrid');
                            $updEditModGrid
                                .find('i.fa-globe.ui-icon-locked, i.fa-list-alt.ui-icon-locked, i.fa-ticket.ui-icon-locked, i.fa-users.ui-icon-locked')
                                .css({'display':'inline-block'});
                            /*
                            * если сисадимны,
                            * то формируются ФО/МО/РО/ПО в форме
                            * */
                            if (__userRole__ === 'sys-admin') {
                                section = '';
                                if (locationHash === '#supporters') {
                                    section = '-supporters';
                                }

                                showAjaxLoading();
                                await $.jqGridSetSelectorHandlers(
                                    row.attr('id'),
                                    '#d_name',
                                    '#r_name',
                                    '#mo_name',
                                    '#po_name',
                                    'mo',
                                    section
                                );
                                hideAjaxLoading();
                            }
                            /*
                            * Все поля в первых 4-х табах блокируются
                            * */
                            else {
                                $updEditModGrid
                                    .find('tr.pole_fa-globe, tr.pole_fa-list-alt, tr.pole_fa-ticket, tr.pole_fa-users')
                                    .find('input, select, textarea').attr('disabled', true);
                            }
                        }, 100);
                    }
                    else {
                        err = 'Нет прав для редактирования данной записи.';
                        $('#sData').hide();
                        $('#FormError').show().find('td').html(err);
                        setTimeout(function () {
                            $('#id_g').attr('name', 'grid_id');
                            $('#FormError .to_possible_error').hide();
                            $('#editmodgrid .FormData').find('input, select, textarea').attr('disabled', true).removeAttr('name');
                        }, 100);
                    }
                }
                else {
                    $('#editmodgrid .FormData').find('input, select, textarea').not('.attachment').attr('disabled', false);
                    strId = isAddMode ? -1 : row.attr("id");
                    dElId = '#d_name';
                    $(dElId+' option:first').prop('disabled', true);
                    rikElId = '#r_name';
                    moElId = '#mo_name';
                    section = '';
                    if (['#members_list', '#supporters', '#members_for_deletion', '#deputies', '#memb_notifies', '#party_members'].includes(locationHash)) {
                        role = 'mo';
                        poElId = '#po_name';
                        if (locationHash == '#supporters') {
                            section = '-supporters';
                        }
                    } else if (locationHash == '#election_campaigns') {
                        role = 'rik';
                        poElId = -1;
                        moElId = -1;
                        section = '-offense';
                    } else if (locationHash == '#elect_history_regional') {
                        role = 'elect_history_regional';
                        poElId = -1;
                        moElId = -1;
                        section = '-elections';
                    } else if(locationHash == '#deputies_meetings'){
                        role = 'deputies_meetings';
                        poElId = '#po_name';
                    } else if(locationHash == '#join_po_members'){
                        role = 'po';
                        poElId = -1;
                    } else if(locationHash == '#zs_list'){
                        role = 'fraction';
                        poElId = -1;
                        moElId = -1;
                        rikElId = '#r_reg_name';
                        section = '-fractions';
                        $(dElId+' option:first').attr('disabled','disabled');
                    } else if(['#projects_regional_list', '#projects_regional_objects_list'].indexOf(locationHash) !== -1){
                        role = locationHash
                            .slice(1)
                            .replace('_list', '');
                        poElId = -1;
                        moElId = -1;
                        section = '-projects';
                    } else if(locationHash == '#finplan_list'){
                        role = 'finplans';
                        poElId = -1;
                        moElId = -1;
                        rikElId = '#r_name';
                        section = '-finplans';
                    } else if(['#budget_contractor', '#budget_accounts'].indexOf(locationHash) !== -1){
                        role = locationHash.split('#')[1];
                        poElId = -1;
                        moElId = -1;
                        rikElId = '#r_name';
                        section = '-booker';
                    } else if(locationHash == '#premise_provision') {
                        role = 'premise_provision';
                    } else if(locationHash == '#merge_districts'){
                        role = 'electoral_districts';
                        poElId = -1;
                        moElId = -1;
                    } else if (locationHash == '#territorial_groups') {
                        role = 'territorial_groups';
                        poElId = -1;
                        moElId = -1;
                    } else if(locationHash == '#merge_districts_local'){
                        role = 'electoral_districts_local';
                        poElId = -1;
                    } else if (locationHash == '#territorial_groups_local') {
                        role = 'territorial_groups_local';
                        poElId = -1;
                    }
                    await $.jqGridSetSelectorHandlers(strId, dElId, rikElId, moElId, poElId, role, section);
                }
            };

            await getLists();
        } else if($("#grid tr.ui-state-highlight .ui-inline-del").length == 0 && $("#grid tr.ui-state-highlight .ui-inline-edit").length == 0 && !isAddMode){
            $('#editmodgrid').css({'opacity': '1'});

            $("#FormError").show().find('td').html('Недостаточно прав для редактирования данной записи.');
            $('#sData').hide();
            $('#editmodgrid input, #editmodgrid select, #editmodgrid textarea').attr('disabled', true);
        } else {
            $('#editmodgrid input, #editmodgrid select, #editmodgrid textarea').attr('disabled', false);
            $('#sData').show();
        }
    };

    $.jqGRemoveSearchOpt = function(selEl) { //jqGrid search window hack
        var firstOpt = $(selEl).find('option:first');
        if ($(selEl).attr('role') == 'select' && firstOpt.val() == '') {
            firstOpt.remove();
        }
    };

    $.jqGCopySearchOpt = function(selEl,prnSelector) { //jqGrid search window hack
        if($(selEl).attr('role') == 'select'){
            $(selEl).addClass('.mo-list');
            if($(prnSelector).prop('disabled')) {
                $(selEl).html('<option>...отфильтруйте основной список по Фед.округу или РИКу</option>').addClass('grey');
            } else {
                $(selEl).html($(prnSelector).html()).removeClass('grey');
                $(selEl).find('option:eq(0)').remove();
            }
        }
    };

    $.jqGSimulChangeVal = function(){
        setTimeout(function(){
            $('#searchcntfbox_grid .data .input-elm').change();
        },0);
    };

    $.jqGSimulChangeAll = function(){
        setTimeout(function(){
            $('#searchcntfbox_grid .columns select').change();
        },0);
    };

    $.jqGAddButtons = function(){
        setTimeout(function(){
            $("#searchmodfbox_grid").css({width: '65%'})
        }, 0);
        $("#fbox_grid").addClass('font-size-14');
        $("#fbox_grid_reset")
            .after('<a href="javascript:void(0)" id="fbox_grid_font_decrease" class="fm-button ui-state-default ui-corner-all fm-button-icon-right ui-reset" title="Уменьшить шрифт">&nbsp;<span class="ui-icon ui-icon-circle-minus"></span></a>')
            .after('<a href="javascript:void(0)" id="fbox_grid_font_increase" class="fm-button ui-state-default ui-corner-all fm-button-icon-right ui-reset" title="Увеличить шрифт">&nbsp;<span class="ui-icon ui-icon-circle-plus"></span></a>');
        $("#fbox_grid_font_increase").click(function(){
            $.jqGSearchDialogIncreaseFont();
        });
        $("#fbox_grid_font_decrease").click(function(){
            $.jqGSearchDialogDecreaseFont();
        });
    };

    $.jqGSearchDialogIncreaseFont = function(){
        var currFS = parseInt($('#fbox_grid').css('font-size').split('px')[0]);
        $('#fbox_grid, #fbox_grid span, #fbox_grid div, #fbox_grid select, #fbox_grid input, #fbox_grid a').attr('style', 'font-size: '+(currFS+1)+'px !important');
    };

    $.jqGSearchDialogDecreaseFont = function(){
        var currFS = parseInt($('#fbox_grid').css('font-size').split('px')[0]);
        $('#fbox_grid, #fbox_grid span, #fbox_grid div, #fbox_grid select, #fbox_grid input, #fbox_grid a').attr('style', 'font-size: '+(currFS-1)+'px !important');
    };

    $.jqGridOffenseDtl = function(jqGId){
        $("#grid .ofDtl").click(function(){
            $('#infoType').val($(this).parent().attr('aria-describedby') == 'grid_of_subject' ? 'subject' : 'declarer');
            $('#ofId').val($(this).attr('name'));
            $('#ofCellVal').val($(this).html());
            $("#alertmodHistory .ui-jqdialog-title").html($('#infoType').val() == 'subject' ? 'Субъект нарушения' : 'Сведения о заявителе');
            showAjaxLoading();
            $.ajax({
                type:"GET",
                url:(typeof dirUp == 'string' ? dirUp : '') + "php/tbl.OFFENSE.DTL.OLD.php",
                dataType:"html",
                data:{infoType: $('#infoType').val(), ofId: $('#ofId').val(), cellVal: $('#ofCellVal').val(), campType: (location.hash.indexOf('#offense_og_list') !== -1) ? 'og' : ''},
                success:function (tr) {
                    $("#historyDialog").html(tr);
                }
            });
        });
    };

    $.jqGridFAQAgreed = function(jqGId, gridLocation = 'php'){
        $(jqGId+" .ui-inline-del").parent().prepend('<div class="ui-pg-div ui-inline-agreed link-simple f-left" title="проблема решена"><span class="ui-icon ui-icon-check"></span></div>');
        $(jqGId+" .ui-inline-agreed").click(function(){
            var fqId = $(this).parents('tr').attr('id');

            $.ajax({
                type:"POST",
                url:`../${gridLocation}/tbl.FDBCK.QUESTION.php`,
                dataType:"html",
                data:{oper: 'agreed', fq_id: fqId},
                success:function (tr) {
                    $("#grid").trigger("reloadGrid");
                }
            });
        });
    };

    $.jqGridElectionStatus = function(jqGId, elect_status){
        $.getScript('js/elections.status.change.js', function(){
            var status_order;
            $('#work_panel').css('top', '190px');
            $('#grid_toppager').css('border', '0 none');
            $('#elect_status_btn').remove();
            $('#work_panel_wrap').prepend(
                '<div id="elect_status_btn">'+
                    '<input type="button" value="Назначение ПГ" class="elect_status status_inactive" status="pvg_appoint">'+
                    '<input type="button" value="Проведение ПГ" class="elect_status status_inactive" status="pvg_holding">'+
                    '<input type="button" value="Выдвижение" class="elect_status status_inactive" status="cand_nomination">'+
                    '<input type="button" value="Регистрация" class="elect_status status_inactive" status="cand_registration">'+
                    '<input type="button" value="Итоги выборов" class="elect_status status_inactive" status="cand_results">'+
                '</div>'
            );
            $('#elect_status_btn .elect_status').button();

            $('#grid tr.ui-widget-content').click(function(){
                electStatusChange.elect_id = $(this).attr('id');
                electStatusChange.buttonsRefresh(elect_status.order[$(this).find('td[aria-describedby="grid_elect_status_id"]').html()].order);
            });

            $.each($('#grid tr.ui-widget-content'), function(){
                status_order = elect_status.order[$(this).find('td[aria-describedby="grid_elect_status_id"]').html()].order;
                $(this).find('.ui-inline-save').parent().append(
                    '<div class="ui-pg-div">'+
                        '<input type="button" value="Назначение ПГ" class="elect_status '+( status_order >= 2 ? 'status_readonly' : '')+'" status="pvg_appoint">'+
                        '<input type="button" value="Проведение ПГ" class="elect_status '+( status_order >= 3 ? 'status_readonly' : (status_order < 2 ? 'status_inactive' : ''))+'" status="pvg_holding">'+
                        '<input type="button" value="Выдвижение" class="elect_status '+( status_order >= 5 ? 'status_readonly' : (status_order < 3 ? 'status_inactive' : ''))+'" status="cand_nomination">'+
                        '<input type="button" value="Регистрация" class="elect_status '+( status_order >= 6 ? 'status_readonly' : (status_order < 5 ? 'status_inactive' : ''))+'" status="cand_registration">'+
                        '<input type="button" value="Итоги выборов" class="elect_status '+( status_order >= 8 ? 'status_readonly' : (status_order < 7 ? 'status_inactive' : ''))+'" status="cand_results">'+
                    '</div>'
                ).find('.elect_status').button();
            });

            $('#elect_status_btn .elect_status').click(function(){
                $('#'+$('#grid').jqGrid('getGridParam', 'selrow')+' .elect_status[status="'+$(this).attr('status')+'"]').click();
            });

            $(jqGId+' .elect_status').click(function(){
                var status_readonly = false;
                if($(this).hasClass('status_inactive')){ $(this).blur(); return false; }
                else if($(this).hasClass('status_readonly')) status_readonly = true;

                var elect_id = $(this).parents('tr.jqgrow').attr('id');
                $('#grid').jqGrid('setSelection', elect_id, false);
                var clikedButton = $(this),
                $dialog = $('<div id="elect_status_change_form"></div>')
                .html($('#'+(clikedButton.attr('status') == 'cand_registration' || clikedButton.attr('status') == 'cand_results'  ? 'cand_nomination' : clikedButton.attr('status'))+'_tmpl').html().replace(/\{TMPL\}/g,''))
                .dialog({
                    autoOpen: false,
                    title: clikedButton.attr('value'),
                    closeoverlay: true,
                    modal: true,
                    position: ['middle', 50],
                    width: 1000,
                    zIndex : 3001,
                    close: function( ev, ui ) {
                        $(this).dialog("destroy");
                        $('#elect_status_change_form').remove();
                    },
                    open: function( ev, ui) {
                        $('#elect_status_change_form input:first').remove();
                        $('.ui-dialog-buttonset :button').blur();

                        $('#election_status_change .dateRUS').each(function () {
                            $(this).datepicker({
                                dateFormat: "dd.mm.yy",
                                changeMonth: true,
                                changeYear: true,
                                showAnim: "slideDown",
                                minDate: new Date(2001, 1, 1)
                            });
                        });

                        if(status_readonly || $('#'+elect_id+' .ui-inline-del').length == 0){
                            if((__userRole__ == 'sys-admin' || __userRole__ == 'admin' || __userRole__ == 'r-operator') && status_readonly){
                                if(clikedButton.attr('status') != 'cand_results')
                                    $('#election_status_change form').prepend('<span style="border: 1px solid red; display: block;"><label style="color:red; margin-left: 5px; font-size: 14px; font-weight: bold;">Редактирование приведет к сбросу данных по следующим статусам.</label></span><br>');
                            } else if( clikedButton.attr('status') == 'cand_registration' && clikedButton.next().length && clikedButton.next().hasClass('status_inactive') ){
                                $('#election_status_change .complete span').html('Выборы проведены');
                                $('#election_status_change .complete').prev().hide();
                            } else {
                                $('#election_status_change form').find('input, select').prop('disabled', true);
                                $('#election_status_change form').find('.add_candidate, .add_file, .add_member').parent().remove();
                                $('#election_status_change').find('.remove_link,.submit,.ui-combobox-toggle,.elect_cancel,.elect_second_round,.clear_date').remove();
                                $('#add_cand_party, #add_party').remove();
                                if($('#'+elect_id+' .ui-inline-del').length == 0) $('#election_status_change .link.remove, #election_status_change .add-member-link').remove();
                            }
                        }

                        $('body .ui-widget-overlay:last').click(function(){
                            $('#election_status_change').find('a.ui-dialog-titlebar-close').click();
                        });
                        $('#elect_status_change_form .digits').numberMask();
                        $('#elect_status_change_form .percent')
                            .numberMask({pattern:/^\d+\.{0,1}\d{0,2}$|^\d+,{0,1}\d{0,2}$/})
                            .keyup(function(){
                                $(this).val( $(this).val().replace(/\,/, ".") );
                            }).focusout(function(){
                                $(this).val( $(this).val().replace(/\,/, ".") );
                            });
                    },
                    create: function( event, ui ) {
                        $(this).parent().attr('id', 'election_status_change');
                        $('#elect_status_change_form').prepend('<input autofocus>');
                        electStatusChange.elect_id = elect_id;
                        electStatusChange[clikedButton.attr('status')]();
                        $('#election_status_change .elect_button').hover(function(){
                            $(this).removeClass('ui-state-default').addClass('ui-state-hover');
                        },function(){
                            $(this).removeClass('ui-state-hover').addClass('ui-state-default');
                        });

                        $('#election_status_change .submit').click(function(){
                            if($(this).hasClass('complete')) electStatusChange.isComplete = true;
                            else electStatusChange.isComplete = false;
                        });

                        $.wrapSubmit('#election_status_change');
                    },
                    buttons: [
                        {
                            text: "Отмена",
                            class: "fm-button f-left",
                            style: "color: #bdbdbd;",
                            click: function() { $(this).dialog("destroy"); $('#elect_status_change_form').remove();}
                        },
                        {
                            text: "Сохранить",
                            class: "submit fm-button f-right",
                            click: function(){}
                        }
                    ]
                });
            });
        });
    };

    var get_pkey = function(jqGId, elem){
        var gridId = jqGId.substring(1, jqGId.length)+'_';

        var tr = elem.parents('tr:first'),
            keyVal = tr.attr('id'),
            tdVal = gridId.indexOf('_t_') == - 1 || $('#events_list').hasClass('selected')
                ? tr.find('td:eq(1)').attr('aria-describedby').split(gridId)[1]
                : tr.find('td:eq(0)').attr('aria-describedby').split(gridId)[1] == 'rn' ? tr.find('td:eq(1)').attr('aria-describedby').split(gridId)[1] : tr.find('td:eq(0)').attr('aria-describedby').split(gridId)[1];

        if (keyVal.indexOf('_') != -1) {
            keyVal = keyVal.split('_')[0];
        }
        if (['subgrid', 'rac_id'].includes(tdVal)) {
            tdVal = tr.find('td:eq(2)').attr('aria-describedby').split(gridId)[1];
        } else if(tdVal == 'sd_root') {
            tdVal = 'sd_id';
        } else if(tdVal == 'cb'){
            if ($('#join_po_members').hasClass('selected')) {
                tdVal = tr.find('td:eq(2)').attr('aria-describedby').split(gridId)[1];
            } else {
                tdVal = tr.find('td:eq(3)').attr('aria-describedby').split(gridId)[1];
            }
        }

        if (tdVal === 'ra_id') {
            keyVal = tr.find('td:eq(2)').html();
        }

        return {keyName: tdVal, keyVal: keyVal};
    };

    $.jqNotifyListHistoryPopup = function(){

        $("#alertmodHistory .ui-jqdialog-title").html('История');
        $("#alertmodHistory .ui-jqdialog-content").removeAttr('style');

        $('#alertmodHistory .ui-jqdialog-content').css({
            'max-height': '600px',
            'overflow-y': 'scroll',
        });

        $("#alertmodHistory").css({
            'top':        '15%',
            'width':      '745px',
            'overflow-x': 'hide'
        });
        $("#alertmodHistory").css({left: ($(document).width() - $("#alertmodHistory").width())/2});

        $.jgrid.viewModal("#alertmodHistory",{});
        $("#historyDialog").html('<img src="css/images/ajax-loader.gif">');

        $.ajax({
            type:"GET",
            url:"php/tbl.TRACK.php",
            dataType:"html",
            data: {'keyName': 'nl_operator_id', 'keyVal': -1 },
            success:function (tr) {
                checkSession(tr);
                $("#historyDialog").html(tr);
            }
        });
    }

    $.jqGridHistoryPopup = function(jqGId){
        $(jqGId+" .ui-inline-save").parent().append('<div class="ui-pg-div ui-inline-history" title="История изменений записи"><span class="ui-icon ui-icon-script"></span></div>');
        $(jqGId+" .ui-inline-history").click(function(){
            $("#alertmodHistory .ui-jqdialog-title").html('История изменений записи');
            var budgetFlag = typeof budgetFlag !== 'undefined' || (typeof dirUp !== 'undefined' && dirUp == '../');
            var path = (budgetFlag ? '../' : '');
            $("#alertmodHistory .ui-jqdialog-content").removeAttr('style');
            $("#alertmodHistory").css({width: '780px', top: '15%'});
            $("#alertmodHistory").css({left: ($(document).width() - $("#alertmodHistory").width())/2});

            var data = get_pkey(jqGId, $(this));
            data.budgetFlag = typeof budgetFlag !== 'undefined' ? budgetFlag : false;

            if(!$.isNumeric(data.keyVal)){
                $.selectRowWarning(jqGId, -1, 'Этот участник еще не редактировался');
                return false;
            }

            $.jgrid.viewModal("#alertmodHistory",{});
            $("#historyDialog").html('<img src="'+path+'css/images/ajax-loader.gif">');

            $.ajax({
                type:"GET",
                url:path+"php/tbl.TRACK.php",
                dataType:"html",
                data: data,
                success:function (tr) {
                    checkSession(tr);
                    $("#historyDialog").html(tr);
                }
            });
        });

        $(jqGId+" .ui-inline-history").hover(function(){
            $(this).addClass('ui-state-hover');
        }, function(){
            $(this).removeClass('ui-state-hover');
        });
    };

    $.jqGridPhotoPopup = function(jqGId){
        $(jqGId+" .ui-inline-history").parent().append('<div class="ui-pg-div ui-inline-photo" title="Показать фотографию"><span class="ui-icon ui-icon-person"></span></div>');
        $(jqGId+" .ui-inline-photo").click(function(){
            var data = get_pkey(jqGId, $(this));
            data.qryType = 'getMemberPhoto';

            showAjaxLoading();
            $.ajax({
                type:"GET",
                url:"php/getData.php",
                dataType:"json",
                data: data,
                success:function (tr) {
                    memb_photo_load(tr.data.photo, tr.data.no_photo);
                }
            });
        });

        $(jqGId+" .ui-inline-photo").hover(function(){
            $(this).addClass('ui-state-hover');
        }, function(){
            $(this).removeClass('ui-state-hover');
        });
    };

    $.jqGridCreatePartEmail = function(jqGId){
        var title = "Адрес парт-почты";
        $(jqGId+" .ui-inline-save").parent().append('<div class="ui-pg-div ui-inline-email" title="'+title+'"><span class="ui-icon ui-icon-mail-closed"></span></div>');
        $(jqGId+" .ui-inline-email").click(function(){
            var tr = $(this).parents('tr'),
                jqGridUrl = $(jqGId).jqGrid('getGridParam', 'url').split('php/')[1];

            $("#gen_part_email").remove();
            var dialog = $('<div></div>')
                .html('<div id="gen_part_email"><img src="css/images/ajax-loader.gif"></div>')
                .dialog({
                    autoOpen: false,
                    title: title,
                    modal: true,
                    resizable: false,
                    zIndex : 3001,
                    height: 'auto',
                    width: 'auto',
                    close: function(ev, ui) {
                        $(this).dialog('destroy');
                        $(this).remove();
                    },
                    buttons: [
                        {
                            text: "Создать и отослать",
                            class: "submit hidden button",
                            click: function(){
                                $("#gen_part_email .ui-dialog-buttonpane .error-msg").slideUp(function(){
                                    $(this).remove();
                                });
                            }
                        },{
                            text: "Удалить",
                            class: "delete hidden button",
                            click: function(){}
                        },{
                            text: "Смена пароля",
                            class: "pass_regen hidden button",
                            click: function(){}
                        },{
                            text: "Изменить",
                            class: "email_edit hidden button",
                            click: function(){}
                        },{
                            text: "Закрыть",
                            class: "button",
                            click: function() {
                                $(this).dialog("close");
                            }
                        }]
                });
            dialog.dialog('open');

            var resFld = null,
                rowIdName = '';

            if (['tbl.MEMB.php', 'tbl.MEMB.DEPUTIES.php', 'tbl.PARTY.MEMBERS.php', 'tbl.SUPPORTERS.php'].includes(jqGridUrl)) {
                rowIdName = 'memb';
            } else if (jqGridUrl == 'tbl.RIK.php') {
                rowIdName = 'rik';
            } else if (jqGridUrl == 'tbl.MIK.php') {
                rowIdName = 'mik';
            }

            var genForm = $('#gen_part_email'),
                remove_em_id = false;
            $.ajax({
                type:"POST",
                url:"php/getData.php",
                dataType:"json",
                data:{ qryType: 'genPartEmailInit', rowId: tr.attr('id'), rowName: rowIdName },
                success:function (tr) {
                    genForm.html($("#gen_part_email_tmpl").html());
                    genForm.find('.fio').html(tr.fio);
                    genForm.find('.rik').html(tr.rik);
                    genForm.find('.email').val(tr.email);
                    resFld = genForm.find('.result');

                    if(rowIdName == 'rik') {
                        genForm.find('.email').prop('disabled',true);
                        genForm.find('.fioWrap').remove();
                    }
                    if(rowIdName == 'mik') {
                        genForm.find('.fioWrap').remove();
                        genForm.find('.mоWrap').show().find('.mo').html(tr.mik);
                    }

                    genForm.parent().next().appendTo("#gen_part_email");
                    genForm.find('.pin').mask("99999999").val(tr.pin);
                    genForm.find('.submit').show();
                    if(tr.exists) {
                        genForm.find('.submit').hide();
                        genForm.find('.email').prop('disabled',true);
                        genForm.find('.pin').parents('tr').hide();
                        if(tr.em_activate_date != undefined && tr.em_activate_date != null){
                            genForm.find('.pass_regen')
                                .show()
                                .click(function(){
                                    if(confirm("Сбросить текущий пароль к email и сгенерировать новый?")) {
                                        partEmailFormPassRegen();
                                    }
                                });
                        }
                        if(rowIdName == 'mik') {
                            genForm.find('.email_edit')
                                .show()
                                .on('click', function () {
                                    genForm.find('.pin').parents('tr').show();
                                    genForm.find('.email').prop('disabled', false);
                                    genForm.find('.submit').show();
                                    genForm.find('.pass_regen, .email_edit').remove();
                                    remove_em_id = tr.em_id;
                                });
                        }
                        if(rowIdName == 'memb') {
                            genForm.find('.delete')
                                .show()
                                .click(function(){
                                    if(confirm("Удалить данный партийный email?")) {
                                        partEmailFormDelete();
                                    }
                                });
                        }
                    }
                    $.wrapSubmit('#gen_part_email');
                    partEmailFormSubmit();
                }
            });
            var partEmailFormSubmit = function(){
                genForm.find('form').validate({
                    keyup: true,
                    ignoreTitle: true,
                    focusInvalid: false,
                    focusCleanup: true,
                    invalidHandler: function(form, validator) {},
                    submitHandler:function (form) {
                        genForm.find('.result').html('<img src="css/images/ajax-loader.gif">');
                        $.ajax({
                            type:"POST",
                            url:"php/getData.php",
                            dataType:"json",
                            data:{
                                qryType: 'genPartEmailCreate',
                                rowId: tr.attr('id'),
                                rowName: rowIdName,
                                email: genForm.find('.email').val(),
                                pin: genForm.find('.pin').val(),
                                remove_em_id: remove_em_id
                            },
                            success:function (tr) {
                                if (tr.error) {
                                    resFld.html(`<span class="error-msg">${tr.error}</span>`);
                                    return false;
                                }
                                var res = $.parseJSON(tr.res);
                                if(res.code == 0){
                                    genForm.find('input').prop('disabled',true);
                                    genForm.find('.submit').button("option", "disabled", true);
                                    resFld.html('<span class="success-msg">email успешно создан<br>'+tr.res_send+'</span>');
                                } else if(res.code == 1) {
                                    resFld.html('<span class="error-msg">указанный пин-код уже существует</span>');
                                } else if(res.code == 2) {
                                    resFld.html('<span class="error-msg">указанный email уже существует</span>');
                                } else if(res.code == 3) {
                                    resFld.html('<span class="error-msg">для данного члена уже сгенерирован email-адрес</span>');
                                } else if (res.code == 4){
                                    resFld.html('<span class="error-msg">Почта должна заканчиваться на .er.ru или на .edinros.ru</span>');
                                } else if (res.code == 5){
                                    resFld.html('<span class="error-msg">Почта должна заканчиваться на .er.ru</span>');
                                }
                            }
                        });
                    }
                });
            };
            var partEmailFormPassRegen = function(){
                genForm.find('.result').html('<img src="css/images/ajax-loader.gif">');
                $.ajax({
                    type:"POST",
                    url:"php/getData.php",
                    dataType:"json",
                    data:{ qryType: 'genPartEmailPassRegen', rowId: tr.attr('id'), rowName: rowIdName},
                    success: function(tr){
                        if (tr.error) {
                            resFld.html(`<span class="error-msg">${tr.error}</span>`);
                            return false;
                        }
                        genForm.find('.pass_regen').button("option", "disabled", true);
                        resFld.html('<span class="success-msg">пароль к email успешно изменен<br>'+tr.res_send+'</span>');
                    }
                });
            };
            var partEmailFormDelete = function(){
                genForm.find('.result').html('<img src="css/images/ajax-loader.gif">');
                $.ajax({
                    type:"POST",
                    url:"php/getData.php",
                    dataType:"json",
                    data:{ qryType: 'genPartEmailDelete', rowId: tr.attr('id'), rowName: rowIdName},
                    success: function(tr){
                        if (tr.error) {
                            resFld.html(`<span class="error-msg">${tr.error}</span>`);
                            return false;
                        }
                        var emailEl = genForm.find('.email'),
                            email = emailEl.val();
                        emailEl.after('<strike>'+email+'</strike>').remove();
                        genForm.find('.delete, .pass_regen').button("option", "disabled", true);
                        resFld.html('<span class="success-msg">email успешно удален</span>');
                    }
                });
            };
        });

        $(jqGId+" .ui-inline-email").hover(function(){
            $(this).addClass('ui-state-hover');
        }, function(){
            $(this).removeClass('ui-state-hover');
        });
    };

    $.jqGridUserAuthHistory = function(jqGId) {
        $(jqGId+" .ui-inline-save").parent().append('<div class="ui-pg-div ui-inline-authHistory" title="История авторизаций"><span class="ui-icon ui-icon-document"></span></div>');
        $(jqGId+" .ui-inline-authHistory").click(function(){
            $("#alertmodHistory .ui-jqdialog-title").html('История авторизаций');
            $("#alertmodHistory").css({width: '790px', top: '15%'});
            $.jgrid.viewModal("#alertmodHistory",{});

            $("#historyDialog").html('<img src="css/images/ajax-loader.gif">');
            var userId = $(this).parents('tr').attr('id');

            $.ajax({
                type:"GET",
                url:"php/tbl.AUTHLOG.php",
                dataType:"html",
                data:{ keyVal: userId },
                success:function (tr) {
                    $("#historyDialog").html(tr);
                }
            });
        });

        $(jqGId+" .ui-inline-authHistory").hover(function(){
            $(this).addClass('ui-state-hover');
        }, function(){
            $(this).removeClass('ui-state-hover');
        });

        $("#alertmodHistory").attr("style",$("#alertmod").attr("style"));
        $("#alertmodHistory").css({left: ($(document).width() - $("#alertmodHistory").width())/2});
    };

    $.jqGridShowVitae = function(jqGId) {
        $(jqGId+" .ui-inline-save").parent().append('<div class="ui-pg-div ui-inline-vitae" title="Объективка"><span class="ui-icon ui-icon-contact"></span></div>');
        $(jqGId+" .ui-inline-vitae").click(function(){
            var vitaeUrl;
            var mId = $(this).parents('tr:first').attr('id');
            var fuckingprinter;
            if(location.hash == '#rik_list'){
                vitaeUrl = '../../php/form.VITAE_rik.php';
                fuckingprinter = true;
            } else {
                vitaeUrl = '../../php/form.VITAE.php';
            }
            showAjaxLoading();
            $.ajax({
                type:"GET",
                url:vitaeUrl,
                dataType:"html",
                data:{ keyVal: mId },
                success:function (tr) {
                    if(checkSession(tr)) {
                        hideAjaxLoading();
                        if(!fuckingprinter){
                            var winW = 2*window.screen.availWidth/3,
                                winH = 4*window.screen.availHeight/5;
                            Win = window.open('about:blank','targetWindow','toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width='+winW+',height='+winH);
                            Win.document.write('<script type=\'text/javascript\'>window.onload = function() { window.print(); }</script>');
                            Win.document.write("<link rel='stylesheet' type='text/css' media='screen, print' href='../../css/main.css?ver=0.02'>");
                            Win.document.write("<link rel='stylesheet' type='text/css' media='screen, print' href='../../css/print.css?ver=0.02'>");
                            Win.document.write(tr);
                            Win.document.close();
                        } else {
                            var winW = 297*4,
                            winH = 210*4;
                            Win = window.open('about:blank','targetWindow','toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width='+winW+',height='+winH);
                            //Win.document.write('<script type=\'text/javascript\'>window.onload = function() { window.print(); }</script>');
                            Win.document.write("<link rel='stylesheet' type='text/css' media='screen' href='../../css/main.css?ver=0.02'>");
                            Win.document.write("<link rel='stylesheet' type='text/css' media='screen' href='../../css/print.css?ver=0.02'>");
                            Win.document.write(tr);
                            Win.document.close();
                        }

                    }
                }
            });
        });

        $(jqGId+" .ui-inline-contact").hover(function(){
            $(this).addClass('ui-state-hover');
        }, function(){
            $(this).removeClass('ui-state-hover');
        });
    };

    $.getVitae = function(mId) {
        var vitaeUrl;
        showAjaxLoading();
        if(location.hash == '#rik_list' && !budgetFlag){
            vitaeUrl = '../../php/form.VITAE_rik.php';
        } else {
            vitaeUrl = '../../php/form.VITAE.php';
        }
        $.ajax({
            type:"GET",
            url: vitaeUrl,
            dataType:"html",
            data:{ keyVal: mId },
            success:function (tr) {
                if(checkSession(tr)) {
                    hideAjaxLoading();
                    var winW = 2*window.screen.availWidth/3,
                        winH = 4*window.screen.availHeight/5;
                    Win = window.open('about:blank','targetWindow','toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width='+winW+',height='+winH);
                    Win.document.write('<script type=\'text/javascript\'>window.onload = function() { window.print(); }</script>');
                    Win.document.write("<link rel='stylesheet' type='text/css' media='screen, print' href='../../css/main.css?ver=0.02'>");
                    Win.document.write("<link rel='stylesheet' type='text/css' media='screen, print' href='../../css/print.css?ver=0.02'>");
                    Win.document.write(tr);
                    Win.document.close();
                }
            }
        });
    };

    $.jqGridShowVitaeByLink = function(jqGId) {
        $(jqGId+" .member_link").click(function(){
            var mId = $(this).parents('tr:first').find('td[aria-describedby="'+$(this).parent().attr('aria-describedby')+'_id"]').html();
            if($.isNumeric($(this).attr('m_id')))
                mId = $(this).attr('m_id');

            $.getVitae(mId);
        });

        $(jqGId+" .ui-inline-contact").hover(function(){
            $(this).addClass('ui-state-hover');
        }, function(){
            $(this).removeClass('ui-state-hover');
        });
    };

    $.getVitaeAlt = function (mId) {
        showAjaxLoading();
        $.ajax({
            type:"GET",
            url:"php/form.VITAE.ALT.php",
            dataType:"html",
            data:{ keyVal: mId },
            success:function (tr) {
                if(checkSession(tr)) {
                    hideAjaxLoading();
                    var winW = 2*window.screen.availWidth/3,
                        winH = 4*window.screen.availHeight/5;
                    Win = window.open('about:blank','targetWindow','toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width='+winW+',height='+winH);
                    Win.document.write('<script type=\'text/javascript\'>window.onload = function() { window.print(); }</script>');
                    Win.document.write("<link rel='stylesheet' type='text/css' media='screen, print' href='../../css/main.css?ver=0.02'>");
                    Win.document.write("<link rel='stylesheet' type='text/css' media='screen, print' href='../../css/print.css?ver=0.02'>");
                    Win.document.write(tr);
                    Win.document.close();
                }
            }
        });
    };

    $.jqGridShowVitaeAlt = function(jqGId) {
        $(jqGId+" .ui-inline-save").parent().append('<div class="ui-pg-div ui-inline-vitae-alt" title="Объективка в формате ЦИК"><span class="ui-icon ui-icon-bookmark"></span></div>');
        $(jqGId+" .ui-inline-vitae-alt").click(function(){
            var mId = $(this).parents('tr:first').attr('id');
            $.getVitaeAlt(mId);
        });

        $(jqGId+" .ui-inline-bookmark").hover(function(){
            $(this).addClass('ui-state-hover');
        }, function(){
            $(this).removeClass('ui-state-hover');
        });
    };

    $.jqGridShowVitaeRps = function(jqGId) {
        $(jqGId+" .ui-inline-save").parent().append('<div class="ui-pg-div ui-inline-vitae-rps" title="Руководящий состав ПРПС"><span class="ui-icon ui-icon-bookmark"></span></div>');
        $(jqGId+" .ui-inline-vitae-rps").click(function(){
            var rId = $(this).parents('tr:first').attr('id');
            showAjaxLoading();
            $.ajax({
                type:"GET",
                url:"php/form.VITAE.RPS.php",
                dataType:"html",
                data:{ keyVal: rId },
                success:function (tr) {
                    if(checkSession(tr)) {
                        hideAjaxLoading();
                        var winW = 2*window.screen.availWidth/3,
                            winH = 4*window.screen.availHeight/5;
                        Win = window.open('about:blank','targetWindow','toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width='+winW+',height='+winH);
                        Win.document.write('<script type=\'text/javascript\'>window.onload = function() { window.print(); }</script>');
                        Win.document.write("<link rel='stylesheet' type='text/css' media='screen, print' href='../../css/main.css?ver=0.02'>");
                        Win.document.write("<link rel='stylesheet' type='text/css' media='screen, print' href='../../css/print.css?ver=0.02'>");
                        Win.document.write(tr);
                        Win.document.close();
                    }
                }
            });
        });

        $(jqGId+" .ui-inline-bookmark").hover(function(){
            $(this).addClass('ui-state-hover');
        }, function(){
            $(this).removeClass('ui-state-hover');
        });
    };

    $.jqGridAddMemberToBdRemind = function(jqGId) {
        $(jqGId+" .ui-inline-vitae-alt").parent().append('<div class="ui-pg-div ui-inline-add-bd-remind" title="Добавить в напоминания о ДР"><span class="ui-icon ui-icon-flag"></span></div>');
        $(jqGId+" .ui-inline-add-bd-remind").click(function(){
            var mId = $(this).parents('tr:first').attr('id');
            $('<div id="add_bd_remind_dlg" />')
                .html('<input type="checkbox" id="remind_email" checked="true"/>&nbspУведомлять по e-mail<br/><input type="checkbox" id="remind_sms"/>&nbspУведомлять по смс')
                .dialog({
                    autoOpen: true,
                    title: 'Добавить напоминание о ДР',
                    modal: true,
                    resizable: true,
                    zIndex : 99,
                    width: 450,
                    position: ['middle', 50],
                    height:200,
                    close: function(ev, ui) { $('#add_bd_remind_dlg').parent().remove(); $('#add_bd_remind_dlg').remove(); },
                    open: function(ev, ui){

                    },
                    buttons: {
                        'close' : {
                            text: 'Закрыть',
                            click: function(){
                                $('#add_bd_remind_dlg').dialog('close');
                            }
                        },
                        'Okay' : {
                            text: 'Добавить',
                            id: 'add_bd_remind_btn',
                            click: function(){
                                datas = {mId: mId, email: $('#remind_email').prop('checked'), sms: $('#remind_sms').prop('checked'), qryType: 'addBdRemind'};
                                showAjaxLoading();
                                $.ajax({
                                    type:'POST',
                                    url:'php/getData.php',
                                    dataType:'html',
                                    data:datas,
                                    success:function(tr){
                                        hideAjaxLoading();
                                        $('#add_bd_remind_dlg').dialog('close');
                                    }
                                });
                            }
                        }
                    },
                    create: function(ev, ui){ }
                }
            );
        });
    };

    $.jqGridPrintDTL = function(jqGId, jqLink){
        $(jqGId+" .ui-inline-save").parent().append('<div class="ui-pg-div ui-inline-printdtl" title="Печать текущей записи"><span class="ui-icon ui-icon-print"></span></div>');
        $(jqGId+" .ui-inline-printdtl").click(function(){
            $.jqPrintOrExcel ($(this).parents('tr').attr('id'), jqLink, false);
        });

        $(jqGId+" .ui-inline-printdtl").hover(function(){
            $(this).addClass('ui-state-hover');
        }, function(){
            $(this).removeClass('ui-state-hover');
        });
    };

    $.jqGridExcelDTL = function(jqGId, jqLink){
        $(jqGId+" .ui-inline-save").parent().append('<div class="ui-pg-div ui-inline-exceldtl" title="Экспорт в Excel">'+
            '<span class="ui-icon ui-icon-disk"></span></div>');
        $(jqGId+" .ui-inline-exceldtl").click(function(){
            $.jqPrintOrExcel ($(this).parents('tr').attr('id'), jqLink, true);
        });

        $(jqGId+" .ui-inline-exceldtl").hover(function(){
            $(this).addClass('ui-state-hover');
        }, function(){
            $(this).removeClass('ui-state-hover');
        });
    };

    $.jqGridFrZsExcelExport = function(grid_id, frzs_name){
        if(!$.isNumeric(grid_id.split('_')[1])){
            var $dialog = $('<div id="excel_export_form"></div>')
                .html('<div>Пожалуйста, выберите запись</div>')
                .dialog({
                    autoOpen: true,
                    title: "ВНИМАНИЕ",
                    modal: true,
                    resizable: true,
                    zIndex : 3001,
                    width: 'auto',
                    height: 80,
                    position: { my: "center", mx: "center", of: window },
                    close: function(ev, ui) {
                        $(this).dialog("destroy");
                        $('#excel_export_form').remove();
                    },
                    buttons: []
                });
            $dialog.dialog('open');
            $('body .ui-widget-overlay:last').click(function(){
                $('#excel_export_form').parent().find('a.ui-dialog-titlebar-close').click();
            });
        }else{
            var $dialog = $('<div id="excel_export_form"></div>')
                .html(
                    '<label> Выгрузить список членов всех фракций:</label>'+
                    '<br>'+
                    '<label>"'+frzs_name+'" ?</label>'
                )
                .dialog({
                    autoOpen: false,
                    title: 'Экспорт в Excel',
                    modal: true,
                    zIndex : 3001,
                    close: function(ev, ui) { $(this).dialog('destroy'); $('#excel_export_form').remove(); },
                    open: function (ev, ui){
                        $('body .ui-widget-overlay:last').click(function(){
                            $('#excel_export_form').parent().find('a.ui-dialog-titlebar-close').click();
                        });
                    },
                    create: function(event, ui){
                        $(this).parent().attr('id', 'excel_export');
                    },
                    width: 300,
                    buttons: [
                        {
                            text: "Отмена",
                            class: "fm-button f-left",
                            style: "color: #bdbdbd;",
                            click: function() { $(this).dialog("destroy"); $('#excel_export_form').remove(); }
                        },
                        {
                            text: "Экспорт",
                            class: "fm-button f-right",
                            click: function() {
                                $.ajax({
                                    type:"POST",
                                    url:"php/tbl.FRACTION.ZS.EXPORT.php",
                                    dataType:'html',
                                    data:{ frzs_id: grid_id.split('_')[1]},
                                    success: function(tr){
                                        checkSession(tr);
                                        $('#excel_export_form').append('<div id="excel_data" class="hidden">'+tr+'</div>');

                                        tableToExcel('#export_data_table');
                                        $('#excel_data').remove();
                                    }
                                });
                            }
                        }
                    ]
                })
            ;

            $dialog.dialog('open');
            $('.ui-dialog-buttonset :button').blur();
        }

    };

    $.jqPrintOrExcel = function(rid, link, excel){
        showAjaxLoading();
        $.ajax({
            type: "POST",
            url: link,
            dataType: "html",
            data:{ rowid: rid, output: true},
            success:function (tr) {
                hideAjaxLoading();
                tr = "<table id=\"bills\">" + $(tr).find('table').html().replace(/<h\d>(.+)<\/h\d>/g,'$1') +"</table>";
                if(excel){
                    $('body').append("<a id='ExcelDownload' style='display:none;'></a>");
                    var uri = 'data:application/vnd.ms-excel;base64,'
                    , template = '<html xmlns:o=\"urn:schemas-microsoft-com:office:office\" xmlns:x=\"urn:schemas-microsoft-com:office:excel\" xmlns=\"http://www.w3.org/TR/REC-html40\/\"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>'
                    , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
                    , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) };
                    tr = tr.replace(/<input.+>/g,'');
                    var ctx = { worksheet: '', table: tr };
                    $('#ExcelDownload').attr('href', uri + base64(format(template, ctx)));
                    document.getElementById('ExcelDownload').download = 'export.xls';
                    document.getElementById('ExcelDownload').click();
                    $('#ExcelDownload').remove();
                }else{
                    var printWindow = window.open('','','width=1200,height=800,scrollbars=1');
                    printWindow.document.writeln("<html><head><link rel='stylesheet' type='text/css' href='../css/print.table.css'></head><body onload='window.print();'>" + tr + "</body></html>");
                    printWindow.document.close();
                }
            }
        });
    };

    $.showIkInfo = function() {
        var ikIdAndType;
        $("#grid tr td.ikLink").click(function(){
            $('#alertmodHistory .ui-jqdialog-title').html($(this).html());
            $.jgrid.viewModal("#alertmodHistory",{});
            $("#historyDialog").html('<img src="../css/images/ajax-loader.gif">');
            ikIdAndType = $(this).parents('tr:first').find('td[aria-describedby="grid_m_ik_id"]').html().split('_');

            $.ajax({
                type:"GET",
                url:"php/POPUPS.INFO/tbl.IK.INFO.php",
                dataType:"html",
                data:{tblName: ikIdAndType[0], ikId: ikIdAndType[2]},
                success:function (tr) {
                    $('#historyDialog').html(tr).find('.button').button();
                    $("#alertmodHistory div.ui-jqdialog-content").css("height", "auto");
                    $("#alertmodHistory div.ui-jqdialog-content").css("overflow", "auto");
//                    $("div.ui-jqdialog-content").css("height", "auto");
//                    $("div.ui-jqdialog-content").css("overflow", "auto");

                    $('#historyDialog .button').click(function(){

                    });
                }
            });
        });

        $("#alertmodHistory").attr("style",$("#alertmod").attr("style"));
        $("#alertmodHistory").css({left: ($(document).width() - $("#alertmodHistory").width())/2});
    };

    $.showFractionInfo = function() {
        $("#grid td .fractionLink").click(function(){
            $('#alertmodHistory .ui-jqdialog-title').html($(this).html());
            $.jgrid.viewModal("#alertmodHistory",{});
            $("#historyDialog").html('<img src="../css/images/ajax-loader.gif">');

            var zs_id = -1, fr_id = -1;
            if($(this).hasClass('zsLink'))
                zs_id = $(this).attr('zs_id');
            else
                fr_id = $(this).attr('fr_id');

            $.ajax({
                type:"GET",
                url:"php/POPUPS.INFO/tbl.FRACTIONS.INFO.php",
                dataType:"html",
                data:{zs_id: zs_id, fr_id: fr_id},
                success:function (tr) {
                    $('#historyDialog').html(tr).find('.button').button();
                    $("#alertmodHistory div.ui-jqdialog-content").css("height", "auto");
                    $("#alertmodHistory div.ui-jqdialog-content").css("overflow", "auto");
//                    $("div.ui-jqdialog-content").css("height", "auto");
//                    $("div.ui-jqdialog-content").css("overflow", "auto");
                }
            });
        });

        $("#alertmodHistory").attr("style",$("#alertmod").attr("style"));
        $("#alertmodHistory").css({left: ($(document).width() - $("#alertmodHistory").width())/2});
    };

    $.editFractionInfo = function() {
        var currRowId = $('#grid').jqGrid('getGridParam', 'selrow');
        $(document).off('click').on('click', '#editmodgrid .fraction_action', function(){
            var frdp_id = $(this).data('frdp_id') ? $(this).data('frdp_id') : null,
                checkedDepType = $(this).parent().attr('zs_type'),
                _this = $(this),
                fr_names;
            $.jgrid.info_dialog(); //hack o_0
            $.jgrid.info_dialog(
                $(this).text(),
                $('#fraction_form_tmpl').html(),
                $.jgrid.edit.bClose,
                {
                    width: 600,
                    zIndex: 1500,
                    buttonalign:'left',
                    buttons:[{id: 'fraction_form_save', text: 'Выбрать', onClick: function() {
                        if(!$('#zs_fraction_selector').val() || !$('#dep_fraction_selector').val() || !$('#frdp_post').val()) {
                            return $('#fraction_form .ui-state-error').show().text('Указаны не все необходимые данные.');
                        } else {
                            $('#fraction_form .ui-state-error').hide();
                        }
                        var postdata = {
                            'memb_edit': true,
                            'frdp_id': frdp_id,
                            'frdp_zs_id': $('#zs_fraction_selector').val(),
                            'frdp_fr_id': $('#dep_fraction_selector').val(),
                            'frdp_m_id': currRowId,
                            'frdp_surname': $('#m_surname').val(),
                            'frdp_name': $('#m_name').val(),
                            'frdp_middlename': $('#m_middlename').val(),
                            'frdp_post': $('#frdp_post').val(),
                            'frdp_admin_center_head': $('#frdp_admin_center_head').prop('checked') ? 'Yes' : 'No',
                            'frdp_deputy_assoc_head': $('#frdp_deputy_assoc_head').prop('checked') ? 'Yes' : 'No',
                            'frdp_representative': $('#frdp_representative').prop('checked') ? 'Yes' : 'No',
                            'frdp_zs_head': $('#frdp_zs_head').prop('checked') ? 't' : 'f'
                        };
                        $.ajax({
                            type:'POST',
                            url:'php/tbl.FRACTIONS.DEP.php',
                            dataType:'json',
                            async: false,
                            data:{
                                oper: 'validate_data',
                                rowid: postdata.frdp_fr_id,
                                id: frdp_id,
                                postdata: postdata,
                                subgrid: 'zsid_'+postdata.frdp_zs_id
                            },
                            success: function(tr){
                                $('#fraction_form_save').hide();
                                return $('#fraction_form .ui-state-error').show().html(tr.error);
                            },
                            error: function () {
                                // т.к. обращение к файлу, генерирующему грид, то в случае успешной проверки возврат html
                                postdata.oper = (frdp_id ? 'edit' : 'add');
                                var m_fr_name = '';
                                for (var fr in fr_names) {
                                    if (fr_names[fr].fr_id == $('#dep_fraction_selector').val()) {
                                        m_fr_name = fr_names[fr].fr_name;
                                        break;
                                    }
                                }
                                _this.parent().find('.m_fr_name').html(m_fr_name);

                                var fr_type = _this.parent().attr('zs_type');
                                if (fr_type === 'zs') {
                                    fr_type = 'ЗС';
                                } else if (fr_type === 'ac') {
                                    fr_type = 'АЦ';
                                } else if (fr_type === 'gomp') {
                                    fr_type = 'ГО/МР';
                                } else if (fr_type === 'gpsp') {
                                    fr_type = 'ГП/СП';
                                }
                                _this.html('Фракция ' + fr_type + ' (изменить)');

                                _this.parent().find('.fr_deputy_data').remove();
                                _this.after('<span class="hidden fr_deputy_data">' + JSON.stringify(postdata) + '</span>');
                                $('#closedialog').click();
                            }
                        });
                    }}]
                }
            );
            $('#fraction_form_save').addClass('f-right');

            var getZSList = function (cb) {
                $('#fraction_form .ui-state-error').hide();
                var rikId = parseInt($('#m_election_rik_id').val()),
                    mo_id = 0;
                    // mo_id = $('#m_election_mo_id').val();
                if(rikId){
                    var zsType = '';
                    if (checkedDepType === 'zs') {
                        zsType = 'Законодательный орган гос.власти субъектов РФ';
                    } else if (checkedDepType === 'ac') {
                        zsType = 'Представительный орган админ.центров субъектов РФ';
                    } else if (checkedDepType === 'gomp') {
                        zsType = 'Орган местного самоуправления ГО/МР';
                    } else if (checkedDepType === 'gpsp') {
                        zsType = 'Орган местного самоуправления гп/сп';
                    }
                    var url = '/php/tbl.FRACTIONS.ZS.php?oper=grid&_search=true&rows=999&page=1&sidx=frzs_id&sord=desc&filters={"groupOp":"AND","rules":[{"field":"frzs_authority","op":"eq","data":"'+zsType+'"}';
                    if ([83, 86, 89, 72, 29].includes(rikId) && $('#m_zs_deputy').prop('checked')) {
                        url += '],"groups":[{"groupOp":"OR","rules":[';
                        if ([86, 89].includes(rikId)) {
                            url += '{"field":"r_id","op":"eq","data":72},';
                        } else if (rikId === 83) {
                            url += '{"field":"r_id","op":"eq","data":29},';
                        }
                        url += '{"field":"r_id","op":"eq","data":'+rikId+'}]}]}&skip_rights=true';
                    } else {
                        url += ',{"field":"r_id","op":"eq","data":'+rikId+'}' + (mo_id ? ',{"field":"mo_id","op":"eq","data":'+mo_id+'}' : '') + ']}';
                    }
                    $.ajax({
                        type: 'GET',
                        url: url,
                        dataType: 'json',
                        success: function (tr) {
                            var zs_opt = '<option value="">Наименование органа:</option>';
                            for(var i = 0; i < tr.rows.length; i++){
                                zs_opt += '<option value="'+tr.rows[i].frzs_id+'">'+tr.rows[i].frzs_name+'</option>';
                            }
                            $('#zs_fraction_selector').html(zs_opt).parent().animateHighlight('#FAF000', 1000);
                            $('#dep_fraction_selector').html('<option value="">выберите ЗС</option>').parent().animateHighlight('#FAF000', 1000);
                            setFractionDepInfo({fld: 'zs_fraction_selector'});
                        }
                    });
                } else {
                    $('#fraction_form .ui-state-error').show().text('Не выбран регион избрания депутата.');
                    return false;
                }
            };

            var setFractionDepInfo = function(setData) {
                var on_success = function (tr) {
                    var depFrInitFlag = +$('#fraction_selector_init').val();
                    for (var fr in tr.data) {
                        if (frdp_id == tr.data[fr].frdp_id || _this.parent().find('.fr_deputy_data').length) {
                            var frdp = tr.data[fr];
                            if (!depFrInitFlag) {
                                $('#zs_fraction_selector').val(frdp.frdp_zs_id).change();
                                $('#dep_fraction_selector').val(frdp.frdp_fr_id);
                                $('#frdp_post').val(frdp.frdp_post);
                                $('#frdp_representative').prop('checked', frdp.frdp_representative == 'Yes');
                                $('#frdp_admin_center_head').prop('checked', frdp.frdp_admin_center_head == 'Yes');
                                $('#frdp_deputy_assoc_head').prop('checked', frdp.frdp_deputy_assoc_head == 'Yes');
                                $('#frdp_zs_head').prop('checked', frdp.frdp_zs_head == 't');
                                $('#fraction_selector_init').val(1);
                                getZSList();
                            } else if (setData.fld == 'zs_fraction_selector') {
                                $('#zs_fraction_selector').val(frdp.frdp_zs_id).change();
                            } else if (setData.fld == 'dep_fraction_selector') {
                                $('#dep_fraction_selector').val(frdp.frdp_fr_id ? frdp.frdp_fr_id : -1);
                            }
                        }
                    }
                };
                if (_this.parent().find('.fr_deputy_data').length) {
                    var data = [JSON.parse(_this.parent().find('.fr_deputy_data').html())];
                    on_success({data: data});
                    return false;
                }
                $.ajax({
                    type: 'POST',
                    url: 'php/getData.php',
                    dataType: 'json',
                    data: {
                        qryType: 'getDeputyForFraction',
                        frdp_m_id: currRowId
                    },
                    success: function (tr) {
                        on_success(tr);
                    }
                });
            };

            $('#zs_fraction_selector').change(function() {
                $('#fraction_form_save').show();
                var zsId = $(this).val();
                if (zsId) {
                    $.ajax({
                        type: 'GET',
                        url: '/php/tbl.FRACTIONS.php?rowid=' + zsId + '&oper=grid&rows=99&page=1&sidx=fr_order&sord=asc',
                        dataType: 'json',
                        success: function (tr) {
                            var fr_opt = '<option value="">Фракция:</option>',
                                fr_id = 0;
                            fr_names = [];
                            for (var i = 0; i < tr.rows.length; i++) {
                                fr_id = tr.rows[i].fr_id > 0 ? tr.rows[i].fr_id : -1;
                                fr_names.push({
                                    fr_id: fr_id,
                                    fr_name: tr.rows[i].fr_name ? tr.rows[i].fr_name : tr.rows[i].fr_status
                                });
                                fr_opt +=
                                    '<option value="' + fr_id + '">' +
                                        tr.rows[i].fr_status +
                                        (tr.rows[i].fr_name ? ': ' + tr.rows[i].fr_name : '') +
                                    '</option>';
                            }
                            $('#dep_fraction_selector').html(fr_opt).parent().animateHighlight('#FAF000', 1000);
                            setFractionDepInfo({fld: 'dep_fraction_selector'});
                        }
                    });
                }
            });
            $('#dep_fraction_selector').change(function() {
                $('#fraction_form_save').show();
            });
            if (frdp_id || _this.parent().find('.fr_deputy_data').length) {
                setFractionDepInfo({});
            } else {
                getZSList();
            }
        });
    };

    $.showPsDepInfo = function() {
        $("#grid td.psLink").click(function(){
            $('#alertmodHistory .ui-jqdialog-title').html($(this).html());
            $.jgrid.viewModal("#alertmodHistory",{});
            $("#historyDialog").html('<img src="../css/images/ajax-loader.gif">');
            var mID = $(this).parents('tr:first').attr('id');

            $.ajax({
                type:"GET",
                url:"php/POPUPS.INFO/tbl.PS.DEP.INFO.php",
                dataType:"html",
                data:{mID: mID, ps_dep: $(this).html()},
                success:function (tr) {
                    checkSession(tr);
                    $('#historyDialog').html(tr);
                    $("#alertmodHistory div.ui-jqdialog-content").css("height", "auto");
                    $("#alertmodHistory div.ui-jqdialog-content").css("overflow", "auto");
                }
            });
        });

        $("#alertmodHistory").attr("style",$("#alertmod").attr("style"));
        $("#alertmodHistory").css({left: ($(document).width() - $("#alertmodHistory").width())/2});
    };

    $.getEvtChangedMembersBtn = function(rowId) {
        $('#alertmodHistory .ui-jqdialog-title').html('История изменений');
        $("#alertmodHistory").css("width", "400px");
        $.jgrid.viewModal("#alertmodHistory",{});
        $("#alertmodHistory div.ui-jqdialog-content").css("height", "auto");
        $("#alertmodHistory div.ui-jqdialog-content").css("overflow", "auto");
        $("#alertmodHistory").css({left: ($(document).width() - $("#alertmodHistory").width())/2});
        $('#historyDialog').html('<div>Выберите даты:</div><div style="float: left"><label for="dateFrom">От: </label><input type="text" id="dateFrom"></div><div style="float: left; padding-left: 30px"><label for="dateTo">До: </label><input type="text" id="dateTo"></div><div style="clear: left; padding-top: 15px; padding-right: 10px; text-align: right"><span class="buttons"><input type="button" value="Показать" class="button submit"></span></div>');
        $('#historyDialog').find('input[type=text]').datepicker({dateFormat:'dd.mm.yy', maxDate: 0});
        var now = new Date();
        $('#dateTo').val(now.getDate() + '.' + (now.getMonth() + 1) + '.' + now.getFullYear());
        now.setDate(now.getDate() - 7);
        $('#dateFrom').val(now.getDate() + '.' + (now.getMonth() + 1) + '.' + now.getFullYear());
        $('#historyDialog .button').click(function() {
            var dateFrom = $('#dateFrom').val();
            var dateTo = $('#dateTo').val();
            $("#historyDialog").html('<img src="../css/images/ajax-loader.gif">');
            $.ajax({
                type:"GET",
                url:"php/tbl.EVENTS.MEMBERS.CHANGED.php",
                dataType:"html",
                data:{id: rowId, dateFrom: dateFrom, dateTo: dateTo},
                success:function (tr) {
                    checkSession(tr);
                    $('#historyDialog').html(tr);
                    $("#alertmodHistory").css("width", "720px");
                    $("#alertmodHistory").css({left: ($(document).width() - $("#alertmodHistory").width())/2});
                    $("#alertmodHistory div.ui-jqdialog-content").css("height", "400px");
                    $("#alertmodHistory div.ui-jqdialog-content").css("overflow", "auto");
                }
            })
        })
    };

    $.showIkReserveInfo = function() {
        var ikIdAndType;
        $("#grid td.ikReserveLink").click(function(){
            $('#alertmodHistory .ui-jqdialog-title').html($(this).html());
            $.jgrid.viewModal("#alertmodHistory",{});
            $("#historyDialog").html('<img src="../css/images/ajax-loader.gif">');
            ikIdAndType = $(this).parents('tr:first').find('td[aria-describedby="grid_m_ik_reserve_id"]').html().split('_');

            $.ajax({
                type:"GET",
                url:"php/POPUPS.INFO/tbl.IK.RESERVE.INFO.php",
                dataType:"html",
                data:{idType: ikIdAndType[0], isGroup: ikIdAndType[1] == 'gr' ? true : false, Id: ikIdAndType[2]},
                success:function (tr) {
                    checkSession(tr);
                    $('#historyDialog').html(tr).find('.button').button();
                    $("#alertmodHistory div.ui-jqdialog-content").css("height", "auto");
                    $("#alertmodHistory div.ui-jqdialog-content").css("overflow", "auto");
//                    $("div.ui-jqdialog-content").css("height", "auto");
//                    $("div.ui-jqdialog-content").css("overflow", "auto");
                }
            });
        });

        $("#alertmodHistory").attr("style",$("#alertmod").attr("style"));
        $("#alertmodHistory").css({left: ($(document).width() - $("#alertmodHistory").width())/2});
    };

    $.showPoInfo = function(tblName) {
        $('#grid tr td.poLink').on('click', function(){
            $('#alertmodHistory .ui-jqdialog-title').html("Первичное отделение");
            $.jgrid.viewModal("#alertmodHistory",{});
            $('#historyDialog').html('<img src="../css/images/ajax-loader.gif">');

            var poId = tblName == 'memb' ? $(this).parent('tr:first').find('td[aria-describedby="grid_po_id_secretary"]').html() : $(this).parent('tr:first').find('td[aria-describedby="grid_po_id"]').html()

            $.ajax({
                type:"GET",
                url:"php/POPUPS.INFO/tbl.PO.INFO.php",
                dataType:"html",
                data:{poId: poId, tbl: tblName},
                success:function (tr) {
                    checkSession(tr);
                    $('#historyDialog').html(tr).find('.button').button();

                    $("#alertmodHistory div.ui-jqdialog-content").css("height", "auto");
                    $("#alertmodHistory div.ui-jqdialog-content").css("overflow", "auto");
//                    $("div.ui-jqdialog-content").css("height", "auto");
//                    $("div.ui-jqdialog-content").css("overflow", "auto");
                }
            });
        });

        $("#alertmodHistory").attr("style",$("#alertmod").attr("style"));
        $("#alertmodHistory").css({left: ($(document).width() - $("#alertmodHistory").width())/2});
    };

    var memb_photo_load = function(src, no_photo){
        var img = $('#empl_full_size_photo img');

        showAjaxLoading();
        var load_complete = function(){
            hideAjaxLoading();
            $('#empl_full_size_photo').removeAttr('style');
            var documentWidth = $(document).width(),
                documentHeight = $(document).height();

            $.jgrid.viewModal("#empl_full_size_photo",{});

            var popupWidth = img.width() + 15,
                popupHeight = $('#empl_full_size_photo').height();

            $('#empl_full_size_photo').css({width : popupWidth});
            $('#empl_full_size_photo').css({left: (popupWidth > documentWidth ? 10 : (documentWidth - popupWidth) / 2) });

            $('#empl_full_size_photo').css({'top': (popupHeight > documentHeight ? 10 : (documentHeight - popupHeight) / 3 )});
            $('.full_size_image_download').attr('href', img.attr('src'));
        };

        img.unbind().load(function(){
            load_complete();
        }).error(function(){
            if(no_photo)
                img.attr('src', no_photo)
        });

        img.attr('src', src);
    };

    $.showEmployeeInfo = function() {
        $("#grid .empl_addit_info").click(function(){
            $("#alertmodHistory .ui-jqdialog-title").html('Персональные данные сотрудника');
            $.jgrid.viewModal("#alertmodHistory",{});
            $("#historyDialog").html('<img src="../css/images/ajax-loader.gif">');
            var emplID = $(this).parents('tr:first').find('td[aria-describedby="grid_m_id"]').html();

            $.ajax({
                type:"GET",
                url:"../php/tbl.EMPL.DTL.php",
                dataType:"html",
                data:{ keyVal: emplID, 'cikFlag' : $('#addRights').length ? false : true },
                success:function (tr) {
                    checkSession(tr);
                    $("#historyDialog").html(tr);
                    $("#alertmodHistory div.ui-jqdialog-content").css("height", "auto");
                    $("#alertmodHistory div.ui-jqdialog-content").css("overflow", "auto");

                    $('#historyDialog .photo_big').click(function(){
                        memb_photo_load($(this).attr('src').split('?')[0] + '?' + Math.random());
                    });
                }
            });
        });

        $("#alertmodHistory").attr("style",$("#alertmod").attr("style"));
        $("#alertmodHistory").css({left: ($(document).width() - $("#alertmodHistory").width())/2});
    };

    $.showPopupListAppeals = function() {
        $("#grid .showPopupListAppeals").click(function(){
            var ap_id = $(this).parents('tr:first').find('td[aria-describedby=\"grid_ap_id\"]').html();
            $.ajax({
                url: 'php/getData2.php',
                type: "POST",
                data: {qryType: 'GetDataAppeals', ap_id: ap_id},
                dataType: 'json',
                success: function (tr) {
                    var $dialog = $('<div id="ListAppeals"></div>')
                    .html(tr['template'])
                        .dialog({
                                autoOpen: false,
                                title: 'Обжалования',
                                modal: true,
                                width: 500,
                                resizable: false,
                                zIndex : 3001,
                                close: function(ev, ui) {
                                    $(this).dialog('destroy');
                                    $('#ListAppeals').remove();
                                },
                                buttons: [
                                    {
                                        text: 'Закрыть',
                                        click: function() {
                                            $(this).dialog('close');
                                        }
                                    }
                                ]
                        });
                    $dialog.dialog('open');
                    $('.ui-dialog-buttonset :button').blur();
                }
            });
        });
    };

    $.showPopupAgreementFalse = function() {
        $("#grid .showPopupAgreementFalse").click(function(){
            var sms_cnt = $(this).parents('tr:first').find('td[aria-describedby=\"grid_nf_sms_cnt\"]').html();
            var nf_id   = $(this).parents('tr:first').find('td[aria-describedby=\"grid_nf_id\"]').html();
            var $dialog = $('<div id="agreedFalse"></div>')
                .html('Согласовать отправку рассылки на '+sms_cnt+ ' СМС')
                    .dialog({
                        autoOpen: false,
                        title: 'Согласование',
                        modal: true,
                        resizable: false,
                        zIndex : 3001,
                        close: function(ev, ui) {
                            $(this).dialog('destroy');
                            $('#agreedFalse').remove();
                        },
                        buttons: [
                            {
                                text: 'Да',
                                click: function() {
                                    $.ajax({
                                        type: "POST",
                                        url: "php/getData2.php",
                                        dataType: 'json',
                                        data: {qryType: 'UpdateStatusAgreement', nf_id: nf_id},
                                        success: function (tr) {
                                            if (checkSession(tr)) {
                                                $('#grid').trigger('reloadGrid');
                                            }
                                        }
                                    });
                                    $(this).dialog('close');
                                }
                            },
                            {
                                text: 'Нет',
                                click: function() {
                                    $(this).dialog('close');
                                }
                            }
                        ]
                    });
                    $dialog.dialog('open');
                    $('.ui-dialog-buttonset :button').blur();

            return;
        });
    };

    $.showPopupAgreementTrue = function() {
        $("#grid .showPopupAgreementTrue").click(function(){
            var nf_id   = $(this).parents('tr:first').find('td[aria-describedby=\"grid_nf_id\"]').html();
            $.ajax({
                url: 'php/getData2.php',
                type: "POST",
                data: {qryType: 'GetDataAgreement', nf_id: nf_id},
                dataType: 'json',
                success: function (tr) {

                    var datetime = tr.date.split(' ');
                    var date = datetime[0].split('.');
                    var time = datetime[1].split(',');
                    var str_time = time.join('');
                    var time_without_sec = str_time.slice(0, -6)

                    var $dialog = $('<div id="agreedTrue"></div>')
                    .html('Согласовано '+ date +' в '+ time_without_sec + '. <br>' + tr.memb)
                        .dialog({
                                autoOpen: false,
                                title: 'Согласование',
                                modal: true,
                                resizable: false,
                                zIndex : 3001,
                                close: function(ev, ui) {
                                    $(this).dialog('destroy');
                                    $('#agreedTrue').remove();
                                },
                                buttons: [
                                    {
                                        text: 'Закрыть',
                                        click: function() {
                                            $(this).dialog('close');
                                        }
                                    }
                                ]
                        });
                    $dialog.dialog('open');
                    $('.ui-dialog-buttonset :button').blur();
                }
            });

            return;
        });
    };


    $.showErMemberInfo = function(tblName, target, unbind) {
        if(!target){
            if(tblName == 'ik')
                target = '#grid .er-member span';
            else if($.inArray(tblName, ['department', 'ps_memb', 'staffs', 'projects_federal', 'projects_regional', 'cik_pass']) != -1)
                target = '#grid .member_link';
        }

        if(!unbind) {
            $(document).unbind('click');
        }
        $(document).on('click', target, function(){
            var title = 'Персональные данные';
            if(tblName == 'deputies_meetings'){
                title = 'Депутат ГД РФ ' + $(this).html();
            }
            $("#alertmodHistory .ui-jqdialog-title").html(title);
            $.jgrid.viewModal("#alertmodHistory",{});
            $("#historyDialog").html('<img src="'+dirUp+'css/images/ajax-loader.gif">');



            var memberID;
            if(tblName == 'ik')
                memberID = $(this).parents('tr:first').find('.er-member-id').val();
            else if(tblName == 'department')
                memberID = $(this).parents('tr:first').find('td[aria-describedby="'+$(this).attr('aria-describedby')+'_id"]').html();
            else if(tblName == 'staffs')
                memberID = $(this).find('.member_ids').val();
            else if(tblName == 'dep_fractions')
                memberID = $(this).parents('tr:first').find('.m_id').html();
            else if(['ps_memb', 'deputies_meetings', 'cik_pass'].indexOf(tblName) !== -1)
                memberID = $(this).prev().html();
            else if(['projects_federal', 'projects_regional'].indexOf(tblName) !== -1) {
                memberID = $(this).attr('m_id');
            }
            $.ajax({
                type:"GET",
                url:dirUp+"php/tbl.tbl.DTL.php",
                dataType:"html",
                data:{ keyVal: memberID, tblName: tblName },
                success:function (tr) {
                    checkSession(tr);
                    $("#historyDialog").html(tr);
                    if($('#member_link_pager').length > 0){
                        $('#member_link_pager div').click(function(){
                            $('#member_link_pager').find('.active').removeClass('active');
                            $(this).addClass('active');
                            $('#historyDialog .commission_data, #historyDialog img').remove();
                            $("#member_link_pager").after('<img src="'+dirUp+'css/images/ajax-loader.gif">');
                            memberID = $(this).find('span').attr('class');

                            $.ajax({
                                type:"GET",
                                url:dirUp+"php/tbl.tbl.DTL.php",
                                dataType:"html",
                                data:{ keyVal: memberID },
                                success:function (tr) {
                                    $('#member_link_pager').after(tr);
                                    $('#historyDialog img').remove();

                                }
                            });
                        });
                    }

//                    $("div.ui-jqdialog-content").css("height", "400px");
//                    $("div.ui-jqdialog-content").css("overflow", "auto");
                    $("#alertmodHistory div.ui-jqdialog-content").css("max-height", "800px");
                    $("#alertmodHistory div.ui-jqdialog-content").css("overflow", "auto");
                    $("#alertmodHistory ").css("top", "3%");
                    $("#alertmodHistory").resizable({alsoResize:'.ui-jqdialog-content'});

                }
            });
        });

        $("#alertmodHistory").attr("style",$("#alertmod").attr("style"));
        $('#alertmodHistory').css({maxWidth: '800px', top: '40%'});
        $("#alertmodHistory").css({left: ($(document).width() - $("#alertmodHistory").width())/2});
    };

    $.jqGridShowMap = function(jqGId){
        $(jqGId+" .ui-inline-save").parent().append('<div class="ui-pg-div ui-inline-map" title="Переход к карте"><span class="ui-icon ui-icon-circle-arrow-e"></span></div>');

        $(jqGId+" .ui-inline-map").each(function(){

            var href = '<iframe id="er_map_iframe" src="https://regionmap.edinros.ru/?';
            href += 'rik=' + $(this).parents('tr').find('td[aria-describedby="grid_r_id"]').html();
            if(document.URL.split('#')[1] == 'mo_list')
                href += '&mik=' + $(this).parents('tr').attr('id');
            href += '"></iframe>';

            $(this).click(function(){
                // $('#er_map').attr('goto','rik='+rikId).trigger('hashChange');
                $('<div id="map_dialog" />')
                    .html(href)
                    .dialog({
                        autoOpen: true,
                        title: 'карта присутствия ер',
                        modal: true,
                        resizable: true,
                        zIndex : 3001,
                        width: $('#work_panel_wrap').width(),
                        position: ['middle', 50],
                        height:800,
                        close: function(ev, ui) { $('#map_dialog').parent().remove(); $('#map_dialog').remove(); },
                        open: function(ev, ui){ },
                        create: function(ev, ui){ }
                    }
                );
            });
        });
        $(jqGId+" .ui-inline-map").hover(function(){
            $(this).addClass('ui-state-hover');
        }, function(){
            $(this).removeClass('ui-state-hover');
        });
    };

    $.jqGridMasquerade = function(jqGId){
        $(jqGId+" .ui-inline-save").parent().append('<div class="ui-pg-div ui-inline-mask" title="masked auth"><span class="ui-icon ui-icon-person"></span></div>');
        $(jqGId+" .ui-inline-mask").click(function(){
            var m_id = $(this).parents('tr').attr('id');
            $.ajax({
                type:"POST",
                url:"php/getData.php",
                data: {qryType: 'mask_auth', maskUserId: m_id},
                dataType: 'json',
                success:function (tr) {
                    window.location.reload();
                }
            });
        });

        $(jqGId+" .ui-inline-mask").hover(function(){
            $(this).addClass('ui-state-hover');
        }, function(){
            $(this).removeClass('ui-state-hover');
        });
    };
    $.jqGridEmployeeLink = function(jqGId, tblName){
        $(document).unbind('click');
        $(document).on("click", "#grid .empl_info", function(){
            $("#alertmodHistory .ui-jqdialog-title").html('Персональные данные сотрудника');
            $.jgrid.viewModal("#alertmodHistory",{});
            $("#historyDialog").html('<img src="../css/images/ajax-loader.gif">');
            var emplID;
            if(tblName == 'oper') emplID = $(this).parents('tr:first').attr('id');
            else if(tblName == 'sd') emplID = $(this).parents('tr:first').find('td[aria-describedby="grid_sd_head"]').html();

            showAjaxLoading();
            $.ajax({
                type:"GET",
                url:"php/tbl.LINK.EMPL.php",
                dataType:"html",
                data:{ emplID: emplID },
                success:function (tr) {
                    hideAjaxLoading();
                    checkSession(tr);
                    $("#historyDialog").html(tr);
                    $("#alertmodHistory div.ui-jqdialog-content").css("height", "auto");
                    $("#alertmodHistory div.ui-jqdialog-content").css("overflow", "auto");
//                    $("div.ui-jqdialog-content").css("height", "auto");
//                    $("div.ui-jqdialog-content").css("overflow", "auto");
                }
            });

            $("#alertmodHistory").css({width: '780px', top: '15%'});
            $("#alertmodHistory").css({left: ($(document).width() - $("#alertmodHistory").width())/2});
        });
    };

    $.showFilesInfo = function(jqGId, file_fld){
        $(jqGId + ' .m_files_cnt .link-simple').click(function(){
            var rowid = $(this).parents('tr:first').attr('id'),
                files = '<div id="files_info_data" class="hidden">'+
                            $('#'+rowid).find(file_fld).html()+
                        '</div>';

            var $dialog = $('<div id=\"files_info_form\"></div>')
                .html(files)
                .dialog({
                    autoOpen: true,
                    title: 'Просмотр файлов',
                    closeoverlay: true,
                    modal: true,
                    position: ['middle', 150],
                    width: 'auto',
                    zIndex : 3001,
                    close: function( ev, ui ) { $(this).dialog('destroy'); $('#files_info_form').remove();},
                    open: function( ev, ui) {
                        $('.ui-dialog-buttonset :button').blur();

                        $('body .ui-widget-overlay:last').click(function(){
                            $('#files_info').find('a.ui-dialog-titlebar-close').click();
                        });
                    },
                    create: function( event, ui ) {
                        $(this).parent().attr('id', 'files_info');
                        $('#files_info_data').after(
                            '<table class="popup_info_table" style="min-width: 600px;">'+
                                '<tr style="text-align: center;">'+
                                    '<td><b>Файл</b></td>'+
                                    '<td><b>Тип файла</b></td>'+
                                    '<td><b>Комментарий</b></td>'+
                                '</tr>'+
                            '</table>'
                        );

                        $.each($('#files_info_data a'), function(k, v){
                            $('#files_info_form .popup_info_table').append(
                                '<tr>'+
                                    '<td class="file_link"></td>'+
                                    '<td>'+$('#m_file_types option[value="'+$(this).next().next().next().html()+'"]').html()+'</td>'+
                                    '<td>'+$(this).next().next().html()+'</td>'+
                                '</tr>'
                            );
                            $(this).clone().appendTo($('#files_info_form .popup_info_table .file_link:last'));
                        });
                    },
                    buttons: [
                        {
                            text: 'Ок',
                            class: 'fm-button f-right',
                            click: function() { $(this).dialog('destroy'); $('#files_info_form').remove();}
                        }
                    ]
                });
        });
    };

    $.jqGridChangePass = function(jqGId, tblName){
        $(jqGId+" .ui-inline-save").parent().append('<div class="ui-pg-div ui-inline-pass" title="Смена пароля"><span class="ui-icon ui-icon-key"></span></div>');
        $(jqGId+" .ui-inline-pass").click(function(){
            var $dialog = $('<div></div>')
                .html('Сменить пароль на случайный ?')
                .dialog({
                    autoOpen: false,
                    title: 'Автоматическая смена пароля',
                    modal: true,
                    zIndex : 3001,
                    close: function(ev, ui) {
                        $(this).dialog('destroy');
                        $(this).remove();
                    },
                    buttons: [
                        {
                            text: "Да",
                            click: function(){
                                showAjaxLoading();
                                var data = [], currStr = $("#grid tr.ui-state-highlight");
                                data.push({name: 'qryType', value: 'changePass'});

                                if(tblName == 'OPER'){
                                    data.push({name: 'm_id', value: currStr.attr('id')});
                                } else if(tblName == 'FP.OPER'){
                                    data.push({name: 'u_id', value: currStr.attr('id')});
                                    data.push({name: 'd_name', value: currStr.find('td[aria-describedby="grid_d_id"]').attr('title')});
                                    data.push({name: 'r_name', value: currStr.find('td[aria-describedby="grid_r_id"]').attr('title')});
                                    data.push({name: 'mo_name', value: currStr.find('td[aria-describedby="grid_mo_id"]').attr('title')});
                                } else if(tblName == 'CARDFILE'){
                                    data.push({name: 'm_id', value: currStr.attr('id').split('_')[0]});
                                }
                                data.push({name: 'oper', value: 'edit'});
                                var that = $(this);
                                $.ajax({
                                    type:"POST",
                                    url:'php/tbl.'+tblName+'.php',
                                    dataType:'json',
                                    data:data,
                                    success: function(tr){
                                        hideAjaxLoading();
                                        if (tr.error) {
                                            $.create_popup_dialog(`<span class="error-msg">${tr.error}</span>`, 'Ошибка');
                                        }
                                        else {
                                            that.parent().find('button:eq(0)').remove();
                                            that.parent().find('button span').html('Ок');
                                            that.html("Пароль успешно обновлен.<br><b>Пользователь:</b> "+currStr.find('td[aria-describedby="grid_'+(tblName == 'OPER' || tblName == 'CARDFILE' ? 'em_email' : 'u_login')+'"]').attr('title')+"<br><b>Новый пароль:</b> "+tr);
                                        }
                                    }
                                });
                            }
                        },
                        {
                            text: "Нет",
                            click: function() { $(this).dialog("close");}
                        }]
                });
            $dialog.dialog('open');
            $('.ui-dialog-buttonset :button').blur();
        });

        $(jqGId+" .ui-inline-pass").hover(function(){
            $(this).addClass('ui-state-hover');
        }, function(){
            $(this).removeClass('ui-state-hover');
        });
    };

    $.jqGridSoftDel = function(jqGId, url){
        $(jqGId+" .ui-inline-save").parent().append('<div class="ui-pg-div ui-inline-soft-del" title="Пометить на удаление"><span class="ui-icon ui-icon-closethick"></span></div>');
        $(jqGId+" .ui-inline-soft-del").click(function(){
            var $dialog = $('<div id="soft_del_popup"></div>')
                .html('Пометить запись на удаление ?')
                .dialog({
                    autoOpen: false,
                    title: 'Пометить на удаление',
                    modal: true,
                    zIndex : 3001,
                    close: function(ev, ui) { $(this).dialog("destroy"); $('#soft_del_popup').remove(); },
                    buttons: [
                        {
                            text: "Да",
                            click: function(){
                                showAjaxLoading();
                                var data = [];
                                data.push({name: 'oper', value: 'soft_del'});
                                data.push({name: 'rowid', value: $(jqGId).jqGrid('getGridParam', 'selrow')});
                                var that = $(this);
                                $.ajax({
                                    type:"POST",
                                    url:url,
                                    dataType:'html',
                                    data:data,
                                    success: function(tr){
                                        that.dialog("close");
                                        $(jqGId).trigger('reloadGrid');
                                    }
                                });
                            }
                        },
                        {
                            text: "Нет",
                            click: function() { $(this).dialog("close");}
                        }]
                });
            $dialog.dialog('open');
            $('.ui-dialog-buttonset :button').blur();
        });

        $(jqGId+" .ui-inline-soft-del").hover(function(){
            $(this).addClass('ui-state-hover');
        }, function(){
            $(this).removeClass('ui-state-hover');
        });
    };

    $.jqGridHidePencil = function(xhr){
        var that = {};
        var nextIteration = false;
        var mikFlag = ['tblRik', 'tblCosts', 'tblStaffs', 'tblFinplans', 'tblIKS', 'tblOffense', 'tblCampaigns', 'fractions_zs', 'tblDepMeets', 'tblMergeElectDistricts', 'tblTerritorialGroups'].indexOf(xhr.tableName) === -1;

        $('#del_grid_top, #del_grid').click(function(){
            if (!$("#grid tr.ui-state-highlight .ui-inline-del").length && !$("#grid tr.ui-state-highlight .ui-inline-soft-del").length){
                $('#dData, .delmsg').hide();
                $('#DelError').show().find('td').html('Нет прав для удаления данной записи.');
            } else {
                $('#dData, .delmsg').show();
                $('#DelError').hide();
            }
        });

        $.each($('#grid tr'), function(){
            nextIteration = false;
            that = this;

            if(xhr.protected_member !=  2 && $(that).find('td[aria-describedby="grid_m_protected_member"] input').prop('checked')){
                $(this).find('.ui-inline-edit, .ui-inline-pass, .ui-inline-del').remove();
                return true;
            }

            $.each(xhr.districts, function(k, v){
                if(v == $(that).find('td[aria-describedby="grid_d_id"]').html()){
                    nextIteration = true;
                    return false;
                }
            });

            if(nextIteration) return true;
            if($.isNumeric($(that).find('td[aria-describedby="grid_r_id"]').html())){
                $.each(xhr.riks, function(k, v){
                    if(v == $(that).find('td[aria-describedby="grid_r_id"]').html()){
                        nextIteration = true;
                        return false;
                    }
                });
            }

            if(nextIteration) return true;
            if(mikFlag && $.isNumeric($(that).find('td[aria-describedby="grid_mo_id"]').html())){
                $.each(xhr.miks, function(k, v){
                    if(v == $(that).find('td[aria-describedby="grid_mo_id"]').html()){
                        nextIteration = true;
                        return false;
                    }
                });
            }

            if (!nextIteration){
                $(this).find('.ui-inline-edit, .ui-inline-pass, .ui-inline-del, .ui-inline-soft-del').remove();
                if (['tblMemb', 'ikReserve'].includes(xhr.tableName)) {
                    $(this).find('.ui-inline-reserve').remove();
                }
            }
        });
    };

    $.erdbColumnChooser = function(gridID){
        var me = this,
            colMdl = $(gridID).jqGrid('getGridParam', 'colModel'),
            line_text,
            i;

        var html_text = '<select id="column_selector" class="multiselect" multiple="multiple" style="width: 500px; margin: 0 auto; height: 340px; ">\n';
        for (i = 0 ; i < colMdl.length; i++) {
            if (colMdl[i].hidedlg) {
                continue;
            }
            var label = colMdl[i].label ? colMdl[i].label : colMdl[i].name;
            if (colMdl[i].hidden) {
                line_text = '<option value="'+i+'">'+label+'</option>\n';
            } else {
                line_text = '<option value="'+i+'" selected="selected">'+label+'</option>\n';
            }
            html_text += line_text;
        }
        html_text += '</select>';

        $("#dlg_choose_columns").html(html_text);
        $(".multiselect").multiselect({
            sortable: true,
            searchable: true,
            hide: 'explode',
            show: 'blind',
            dividerLocation: 0.5
        });
        $("#dlg_choose_columns").dialog({
            width: 535,
            height: 550,
            modal: true,
            title: 'Показать/скрыть столбцы',
            hide: 'explode',
            open: function(){
                $.colChooserToDefault(gridID);
            },
            close: function () {
                $(this)
                    .html('')
                    .dialog('destroy');
            },
            buttons: {
                "Сохранить": function() {
                    var selected_values = $(".multiselect").val();
                    for ( i = 0; i < colMdl.length; i++ ) {
                        colMdl[i].hidden = true;
                    }
                    for ( i = 0; i < selected_values.length; i++ ) {
                        delete colMdl[selected_values[i]].hidden;
                    }
                    $("#dlg_choose_columns").dialog("close");
                    $.saveGridColModel(gridID, true);
//                    me.unload_jqgrid();
//                    me.create_grid(null, me.is_tree, me.need_plot);
                },
                "Отмена": function() {
                    $('#dlg_choose_columns').dialog('close');
                },
                "default_state":{
                    text: "По умолчанию",
                    id: 'colChooserToDefault',
                    click:function() {}
                }
            }
        });
    };

    $.saveGridColModel = function(gridID, reloadFlag){
        var colModel = {},
            colModelObj = {},
            jqGridUrl = $(gridID).jqGrid('getGridParam', 'url')
                .replace('php/', '')
                .replace('php-local/', '');

        $.each($(gridID).jqGrid('getGridParam', 'colModel'), function(k, v){
            if(v.name != "rn"){
                colModel[v.name] = ''+v.hidden+'';
            }
        });
        colModelObj[''+jqGridUrl+''] = colModel;

        $.ajax({
            type:"POST",
            url:dirUp+"php/getData.php",
            dataType:'json',
            data:{
                qryType: 'saveGridColModel',
                colModel: JSON.stringify(colModelObj)
            },
            success: function(tr){
                if(reloadFlag){
                    fullGridReload();
                }
            }
        });
    };
    $.colChooserToDefault = function(gridID, addButton){
        if ($(gridID).length == 0) {
            gridID ='#grid';
        }
        if (addButton) {
            $('#colchooser_grid').parents('.ui-dialog:first').find(' .ui-dialog-buttonset')
                .append('<button id="colChooserToDefault" aria-disabled="false" role="button" class="ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only" type="button"><span class="ui-button-text">По умолчанию</span></button>');
            $('#colChooserToDefault').hover(
                function() {
                    $(this).addClass('ui-state-hover');
                },
                function() {
                    $(this).removeClass('ui-state-hover');
                }
            );
        }
        $('#colChooserToDefault').click(function() {
            showAjaxLoading();
            $.ajax({
                type:"POST",
                url:dirUp+"php/getData.php",
                dataType:'json',
                data:{
                    qryType: 'clearGridColModel',
                    grid: $(gridID).jqGrid('getGridParam', 'url').split(/php[-local]*\//)[1]
                },
                success: function(tr){
                    if(checkSession(tr)){
                        fullGridReload();
                    }
                }
            });
        });
    };

    $.tipTipMy = function(selector, hintMsg){
        $(selector).tipTip({
//            keepAlive:true,
            maxWidth:"auto",
            defaultPosition:"right",
            delay:0,
            content:hintMsg
//            ,edgeOffset: -$('#menu_panel').offset().left+10
        });
    };

    $.inputHints = function(selector, diffVal, tipTipFlag) {
        $(selector).val(diffVal);//.prop('title',diffVal);
        if(typeof tipTipFlag == 'undefined' || tipTipFlag == true)
            $.tipTipMy(selector,diffVal.split(':')[0]);
        $(selector).focusin(function () {
            $(this).removeClass('grey');
            if ($(this).val() == diffVal) {
                $(this).val('');
            }
        });

        $(selector).focusout(function () {
            var inputEl = $(this),
                timeout = 1;

            if(inputEl.hasClass('hasDatepicker')){ //datepicker hack
                timeout = 300;
                inputEl.change(function(){
                    if(inputEl.val() != diffVal){
                        inputEl.removeClass('grey');
                    }
                });
            }

            setTimeout(function(){
                if (inputEl.val() == ''){
                    inputEl.val(diffVal);
                    inputEl.addClass('grey');
                }
            }, timeout);
        });
    };

    $.updateToolbarFilterWithAlias = function(selector, data, selectedVal)
    {
        selectedVal = strip_tags_custom(selectedVal);
        if(typeof data === "object" && data.length){

            $(selector).prop('disabled', false).parents('.opacity-0_7').removeClass('opacity-0_7');

            var optionsHtml = '<option value="">Все</option>';
            var selectedFlag = '';

            $.each(data, function(index, value)
            {
                var key = Object.keys(value)[0];
                var filter = value[key];

                selectedFlag = strip_tags_custom(key) == selectedVal ? 'selected' : '';
                optionsHtml += '<option value="'+key+'" '+selectedFlag+'>'+filter+'</option>';
            });

            $(selector).html(optionsHtml);

        } else {
            $(selector).prop('disabled', true).parent().addClass('opacity-0_7');
        }
    };

    $.updateToolbarFilter = function(selector, data, selectedVal) {
        selectedVal = strip_tags_custom(selectedVal);
        if(data != '' && typeof data != "undefined"){
            $(selector).prop('disabled', false).parents('.opacity-0_7').removeClass('opacity-0_7');
            var dataArr = data.split(','),
                dataArrLen = dataArr.length,
                optionsHtml = '<option value="">Все</option>',
                selectedFlag = '';
            for(var i = 0; i < dataArrLen; i++){
                selectedFlag = strip_tags_custom(dataArr[i]) == selectedVal ? 'selected' : '';
                optionsHtml += '<option value="'+dataArr[i]+'" '+selectedFlag+'>'+dataArr[i]+'</option>';
            }
            $(selector).html(optionsHtml);
        } else {
            $(selector).prop('disabled', true).parent().addClass('opacity-0_7');
        }
    };

    $.selectRowWarning = function(grid_id, func, alert_text){
        var rowId = $(grid_id).jqGrid('getGridParam', 'selrow');

        if(!$.isNumeric(rowId) || alert_text){
            if(!alert_text) alert_text = 'Пожалуйста, выберите запись';

            var dialog = $('<div id="select_row_warning"></div>')
                .html('<div>' + alert_text + '</div>')
                .dialog({
                    autoOpen: true,
                    title: 'ВНИМАНИЕ',
                    modal: true,
                    resizable: true,
                    zIndex : 3001,
                    width: 'auto',
                    height: 80,
                    position: { my: 'center', mx: 'center', of: window },
                    close: function(ev, ui) {
                        $(this).dialog('destroy'); $('#select_row_warning').remove();
                    },
                    buttons: []
                });
            dialog.dialog('open');
        } else if(typeof func == 'function'){
            func(rowId);
        }
    };

    $.selectRowAndStatusWarning = function(func){
        var rowId = $('#grid').jqGrid('getGridParam', 'selrow');
        var status = $('#'+rowId + ' td[aria-describedby=grid_si_accepted]').html();
        var sstatus = $('#'+rowId + ' td[aria-describedby=grid_ss_accepted]').html();
        if(!$.isNumeric(rowId)){
            var dialog = $('<div id="select_row_warning"></div>')
                .html('<div>Пожалуйста, выберите запись</div>')
                .dialog({
                    autoOpen: true,
                    title: 'ВНИМАНИЕ',
                    modal: true,
                    resizable: true,
                    zIndex : 3001,
                    width: 'auto',
                    height: 80,
                    position: { my: 'center', mx: 'center', of: window },
                    close: function(ev, ui) {
                        $(this).dialog('destroy'); $('#select_row_warning').remove();
                    },
                    buttons: []
                });
            dialog.dialog('open');
        } else if(status == 'Подтвержден' || sstatus == 'Принят' || sstatus == 'Отказано') {
            dialog = $('<div id="select_row_warning"></div>')
                .html('<div>Этот сторонник уже подтвержден</div>')
                .dialog({
                    autoOpen: true,
                    title: 'ВНИМАНИЕ',
                    modal: true,
                    resizable: true,
                    zIndex : 3001,
                    width: 'auto',
                    height: 80,
                    position: { my: 'center', mx: 'center', of: window },
                    close: function(ev, ui) {
                        $(this).dialog('destroy'); $('#select_row_warning').remove();
                    },
                    buttons: []
                });
            dialog.dialog('open');
        } else {
            func(rowId);
        }
    };

    $.nameSpcTmp = function(popup_id, i){
        if(!i) i = '';

        $('#grid').attr('id','grid_tmp'+i);
        $('#gs_r_name').attr('id', 'gs_r_name_tmp'+i);
        $('#gbox_grid').attr('id','gbox_grid_tmp'+i);
        $('#gview_grid').attr('id','gview_grid_tmp'+i);
        $('#grid_toppager').attr('id','grid_toppager_tmp'+i);
        $('#grid_toppager_center').attr('id','grid_toppager_center_tmp'+i);
        $('#grid_toppager_right').attr('id','grid_toppager_right_tmp'+i);
        $('#pager_center').attr('id','pager_center_tmp'+i);
        $('#pager_right').attr('id','pager_right_tmp'+i);
        $('#pg_grid_toppager').attr('id','pg_grid_toppager_tmp'+i);
        $('#add_grid_top').attr('id','add_grid_top_tmp'+i);
        $('#edit_grid_top').attr('id','edit_grid_top_tmp'+i);
        $('#del_grid_top').attr('id','del_grid_top_tmp'+i);
        $('#view_grid_top').attr('id','view_grid_top_tmp'+i);
        $('#search_grid_top').attr('id','search_grid_top_tmp'+i);
        $('#refresh_grid_top').attr('id','refresh_grid_top_tmp'+i);
        $('#sp_1_grid_toppager').attr('id','sp_1_grid_toppager_tmp'+i);
        $('#'+popup_id).parent().scroll(function(){ $.jqGridInitHeader(); });
        $('#'+popup_id).parent().parent().resize(function(){ $.jqGridInitHeader(); });
    };
    $.nameSpcReturn = function(popup_id, i){
        if(!i) i = '';

        $('#grid_tmp'+i).attr('id','grid');
        $('#gs_r_name_tmp'+i).attr('id', 'gs_r_name');
        $('#gbox_grid_tmp'+i).attr('id','gbox_grid');
        $('#gview_grid_tmp'+i).attr('id','gview_grid');
        $('#grid_toppager_tmp'+i).attr('id','grid_toppager');
        $('#grid_toppager_center_tmp'+i).attr('id','grid_toppager_center');
        $('#grid_toppager_right_tmp'+i).attr('id','grid_toppager_right');
        $('#pager_center_tmp'+i).attr('id','pager_center');
        $('#pager_right_tmp'+i).attr('id','pager_right');
        $('#pg_grid_toppager_tmp'+i).attr('id','pg_grid_toppager');
        $('#add_grid_top_tmp'+i).attr('id','add_grid_top');
        $('#edit_grid_top_tmp'+i).attr('id','edit_grid_top');
        $('#del_grid_top_tmp'+i).attr('id','del_grid_top');
        $('#view_grid_top_tmp'+i).attr('id','view_grid_top');
        $('#search_grid_top_tmp'+i).attr('id','search_grid_top');
        $('#refresh_grid_top_tmp'+i).attr('id','refresh_grid_top');
        $('#sp_1_grid_toppager_tmp'+i).attr('id','sp_1_grid_toppager');
        $('#'+popup_id).parent().unbind();
        $('#'+popup_id).parent().parent().unbind('resize');
    };

    $.jqAddMemberFunc = async function(url){
        for (const script of [
            'js/jquery.tinymce.js',
            'php/scripts/memb_grid/grid.js',
            'php/scripts/memb_grid/gridSubmissionEventsFunctions.js'
        ]) {
            await $.getScript(script);
        }

        if (!url) {
            url = 'php/tbl.MEMB.php?popup=true';
        }
        var buttons = [];

        buttons[buttons.length] = {
            text: "Закрыть",
            class: "fm-button f-left",
            style: "color: #bdbdbd;",
            click: function () {
                $(this).dialog("close");
            }
        };

        var tmpl_id = 'adding_member';
        var dialog = $('<div id="addMemberForm_main"></div>')
            .html('<div id="addMemberForm"></div>')
            .dialog({
                autoOpen: false,
                title: '',
                modal: true,
                resizable: true,
                zIndex : 10,
                width: '1000px',
                position: {
                    my: "center",
                    at: "top",
                    of: window
                },
                create: function( event, ui ) {
                    $.nameSpcTmp('addMemberForm', tmpl_id);
                    simpleGetDataGrid(url, "#addMemberForm");
                    $(this).dialog('open');
                    $('#addMemberForm_main').parent().css({'opacity': 0});
                },
                close: function( event, ui ) {
                    $.nameSpcReturn('addMemberForm', tmpl_id);
                    $(this).dialog("destroy");
                    $("#addMemberForm_main").remove();
                    $("#addMemberForm").remove();
                },
                buttons: buttons
            });
    };

    $.eventHotels = function(rowid){
        $("#eventHotelsGrid").remove();

        var buttons = [];

        buttons[buttons.length] = {
            text: "Закрыть",
            class: "fm-button f-left",
            style: "color: #bdbdbd;",
            click: function () {
                $(this).dialog("close");
            }
        };

        var dialog = $('<div id="eventHotelsGrid_main"></div>')
                .html('<div id="eventHotelsGrid"></div>')
                .dialog({
                    autoOpen: false,
                    title: 'Гостиницы: ' + $('#'+rowid+' td[aria-describedby="grid_ev_name"]').html(),
                    modal: true,
                    resizable: true,
                    zIndex : 10,
                    width: '95%',
                    position: { my: "center", at: "top", of: window },
                    create: function( event, ui ) {
                        $.nameSpcTmp('eventHotelsGrid', 1);

                        $(this).dialog('open');
                        simpleGetDataGrid('php/tbl.EVENTS.HOTELS.php?ev_id=' + rowid, "#eventHotelsGrid");
                    },
                    close: function( event, ui ) {
                        $.nameSpcReturn('eventHotelsGrid', 1);
                        $(this).dialog("destroy");
                        $("#eventHotelsGrid_main").remove();
                        $('#grid').trigger('reloadGrid');

                        $.ajax({
                            type:'GET',
                            url:'php/getData.php',
                            dataType:'json',
                            data:{qryType: 'getHotels', ev_id: rowid},
                            success: function(tr){
                                if(checkSession(tr)) {
                                    $('#gs_ep_hotel_name').html('<option value="">Все</option>');

                                    for(var i = 0; i < tr.data.length; i ++){
                                        $('#gs_ep_hotel_name').append('<option value="'+tr.data[i].ep_hotel_name+'">'+tr.data[i].ep_hotel_name+'</option>');
                                    }


                                }
                            }
                        });
                    },
                    buttons: buttons
                })
            ;
    };

    $.eventPlacements = function(rowid){
        $("#eventPlacementsGrid").remove();

        var buttons = [];

        buttons[buttons.length] = {
            text: "Закрыть",
            class: "fm-button f-left",
            style: "color: #bdbdbd;",
            click: function () {
                $(this).dialog("close");
            }
        };

        var dialog = $('<div id="eventPlacementsGrid_main"></div>')
            .html('<div id="eventPlacementsGrid"></div>')
            .dialog({
                autoOpen: false,
                title: $('#'+rowid+' td[aria-describedby="grid_ev_name"]').html(),
                modal: true,
                resizable: true,
                zIndex : 10,
                width: '95%',
                position: { my: "center", at: "top", of: window },
                create: function( event, ui ) {
                    $.nameSpcTmp('eventPlacementsGrid');

                    $(this).dialog('open');
                    simpleGetDataGrid('php/tbl.EVENTS.PLACEMENTS.php?ev_id=' + rowid, "#eventPlacementsGrid");
                },
                close: function( event, ui ) {
                    $.nameSpcReturn('eventPlacementsGrid');
                    $(this).dialog("destroy");
                    $("#eventPlacementsGrid_main").remove();
                    $('#grid_'+rowid+'_t').trigger('reloadGrid');
                },
                buttons: buttons
            })
        ;
    };

    $.eventNoPlacements = function(rowid){
        $("#eventNoPlacementsGrid").remove();

        var buttons = [
            {
                text: "Закрыть",
                class: "fm-button f-left",
                style: "color: #bdbdbd;",
                click: function () {
                    $(this).dialog("close");
                }
            },
            {
                text: "Добавить",
                class: "submit fm-button f-right",
                click: function(){
                    var eml_ids = $('#grid').jqGrid('getGridParam', 'selarrrow');

                    $('#tr_members_num .DataTD').html(eml_ids.length).attr('eml_ids', eml_ids.join(','));
                    $(this).dialog("close");
                }
            }
        ];

        var dialog = $('<div id="eventNoPlacementsGrid_main"></div>')
                .html('<div id="eventNoPlacementsGrid"></div>')
                .dialog({
                    autoOpen: false,
                    title: 'Выбор участников',
                    modal: true,
                    resizable: true,
                    zIndex : 10,
                    width: '95%',
                    position: { my: "center", at: "top", of: window },
                    create: function( event, ui ) {
                        $.nameSpcTmp('eventNoPlacementsGrid', 1);

                        $(this).dialog('open');
                        simpleGetDataGrid('php/tbl.EVENTS.PLACEMENTS.php?ev_id=' + rowid + '&no_placement=true', "#eventNoPlacementsGrid");
                    },
                    close: function( event, ui ) {
                        $.nameSpcReturn('eventNoPlacementsGrid', 1);
                        $(this).dialog("destroy");
                        $("#eventNoPlacementsGrid_main").remove();
                        if($('#tr_members_num .DataTD').html() === '0'){
                            $('#editmodgrid .ui-icon-closethick').click();
                        } else {
                            $('#editmodgrid').css({opacity: 1});
                        }
                    },
                    buttons: buttons
                })
            ;
    };

    $.offenseSelector = function(data){
        $('#offenseSelector').remove();

        var buttons = [];
        if (data.edit) {
            buttons = [
                {
                    text: 'Выбрать',
                    class: 'submit fm-button f-right',
                    click: function () {
                        var of_id = $('#grid').jqGrid('getGridParam', 'selrow');
                        if (of_id > 0) {
                            data.btn.attr('of_id', of_id).html('нарушение...');
                            $(this).dialog("close");
                        }
                    }
                },
                {
                    text: 'Снять выбор',
                    class: 'submit fm-button f-right',
                    click: function () {
                        data.btn.attr('of_id', '').html('выбрать нарушение...');
                        $(this).dialog('close');
                    }
                }
            ];
        }

        buttons[buttons.length] = {
            text: 'Отмена',
            class: 'fm-button f-left',
            style: 'color: #bdbdbd;',
            click: function () {
                $(this).dialog('close');
            }
        };
        var dialog = $('<div id="offenseSelector_main"></div>')
            .html('<div id="offenseSelector"></div>')
            .dialog({
                autoOpen: true,
                title: 'Выборы - нарушения',
                modal: true,
                resizable: true,
                zIndex: 1111,
                width: $(window).width() - 200,
                minHeight: 0,
                // height: 'auto',
                position: {
                    my: 'center',
                    at: 'top',
                    of: window
                },
                create: function( event, ui ) {
                    $('#offenseSelector_main').append(
                        '<input type="hidden" id="ofId" value="">'+
                        '<input type="hidden" id="ofCellVal" value="">'+
                        '<input type="hidden" id="infoType" value="">'
                    );
                    $(this).css('maxHeight', $(window).height() - 150);
                    $.nameSpcTmp('offenseSelector');
                    simpleGetDataGrid((typeof dirUp == 'string' ? dirUp : '') + 'php/tbl.OFFENSE.php?popup=true&r_id=' + data.r_id + '&of_id=' + data.of_id, '#offenseSelector');
                },
                open: function(event, ui){
                    $('#offenseSelector_main').focus();
                },
                close: function( event, ui ) {
                    $.nameSpcReturn('offenseSelector');
                    $(this).dialog('destroy');
                    $('#offenseSelector_main').remove();
                },
                buttons: buttons
            });
        dialog.dialog('open');
    };

    //data: json {grid_id: 'grid_3', members_linker_field: evml_mc_id}
    //script: php-file to send datas
    $.membersSelector = function(data, script){
        var grid_id = data.grid_id,
            otherCtrg = data.otherCtrg === true ? true : false,
            membLinkerFld = '', membLinkerFldVal = '';
        $.each(data, function(k,v){
            if(k != 'grid_id' && k != 'otherCtrg') {
                membLinkerFld = k;
                membLinkerFldVal = v;
            }
        });

        $("#membersSelector").remove();

        var buttons = [
            {
                text: "Добавить выбранных",
                class: "submit fm-button f-right",
                click: function(){
                    var selMemArr = $('#grid').jqGrid('getGridParam', 'selarrrow'),
                        sendData = {"membList": encodeURI(JSON.stringify(selMemArr))};
                    sendData[membLinkerFld] = membLinkerFldVal;
                    sendData['oper'] = 'add';

                    if(otherCtrg && $('#evml_comment').hasClass('grey')){
                        $('#evml_comment').addClass('error');
                        return;
                    } else {
                        $('#evml_comment').removeClass('error');
                        sendData['evml_comment'] = $('#evml_comment').val();
                    }

                    if(selMemArr.length > 0) {
                        showAjaxLoading();
                        $.ajax({
                            type: "POST",
                            url: script,
                            dataType: 'json',
                            data: sendData,
                            success: function(tr){
                                hideAjaxLoading();
                                // $('#grid').trigger('reloadGrid');
                                $('#grid').jqGrid('resetSelection');
                                $('#grid').find('#' + selMemArr.join(', #')).remove();
                                $('#'+grid_id+' .fa-refresh:first').click();
                            }
                        });
                    }
                }
            }
        ];

        if(membLinkerFld != 'nfld_nfl_id'){
            buttons[buttons.length] = {
                text: "Внести новых",
                class: "submit fm-button f-right",
                click: function(){
                    $.jqAddMemberFunc();
                }
            }
        }

        buttons[buttons.length] = {
            text: "Отмена",
            class: "fm-button f-left",
            style: "color: #bdbdbd;",
            click: function() {
                $(this).dialog("close");
            }
        };

        var dialog = $('<div id="membersSelector_main"></div>')
            .html('<div id="membersSelector"></div>')
            .dialog({
                autoOpen: true,
                title: "Выбор персоналий",
                modal: true,
                resizable: true,
                zIndex : 301,
                width: '1000px',
                position: { my: "center", at: "top", of: window },
                create: function( event, ui ) {
                    $.nameSpcTmp('membersSelector');
                    data = encodeURI(JSON.stringify(data));
                    getDataGridWithScripts({
                        scripts: [
                            'js/jquery.tinymce.js',
                            'php/scripts/memb_grid/grid.js',
                            'php/scripts/memb_grid/gridSubmissionEventsFunctions.js'
                        ],
                        grid: "php/tbl.MEMB.SELECTOR.php?data="+data,
                        work_panel_wrap: "membersSelector"
                    });

                    if(otherCtrg){
                        $('#membersSelector').parent().parent().find('.ui-dialog-buttonset').before(
                            '<span class="field">'+
                                '<textarea id="evml_comment" name="evml_comment" class="grey required form-input-style"></textarea>'+
                            '</span>'
                        );
                        $.inputHints('#evml_comment','Комментарии (должность и т.д.):');
                    }

                },
                open: function(event, ui){
                    $('#evml_comment').focusout().blur();
                },
                close: function( event, ui ) {
                    $.nameSpcReturn('membersSelector');
                    $(this).dialog("destroy");
                    $("#membersSelector_main").remove();
                },
                buttons: buttons
            });
        dialog.dialog('open');
    };

    $.addSMSNotify = function(updFlag){
        $('#add_sms_notify').parent().remove();

        if (window.location.hash !== '#memb_notifies' && !updFlag) {
            var dialog = $('<div></div>')
                .html('<div id="add_sms_notify_msg">Для создания рассылки необходимо перейти в список Членов/Секретарей.<br><b>В меню: Списки -> Персоналии -> Выборка для рассылки</b></div>')
                .dialog({
                    autoOpen: true,
                    title: 'ПРЕДУПРЕЖДЕНИЕ',
                    modal: true,
                    resizable: false,
                    zIndex : 3001,
                    width: 'auto',
                    close: function () {
                        $(this).dialog('destroy');
                        $(this).remove();
                    },
                    buttons: [
                        {
                            text: 'Перейти',
                            class: 'submit fm-button f-right',
                            click: function(){
                                $(this).dialog("close");
                                $("#menu_first a[dir='list']").click();
                                setTimeout(function(){
                                    location.hash = '#memb_notifies';
                                }, 300);
                            }
                        }, {
                            text: "Отмена",
                            class: "fm-button f-left",
                            style: "color: #bdbdbd;",
                            click: function() {
                                $(this).dialog("close");
                            }
                        }]
                });
            dialog.dialog('open');
        } else {

            var postData = $('#grid').jqGrid('getGridParam', 'postData');
            var nfId = -1,
                nfData = null;
            if (updFlag) {
                nfId = $('#grid').jqGrid('getGridParam', 'selrow');
                nfData = $('#grid').jqGrid('getRowData', nfId);
                nfData.nf_text_email  = $('#'+nfId + ' td[aria-describedby="grid_nf_text_email"] span').attr('originalvalue');
            }
            $('.smsNotifyForm, .emailNotifyForm, .digestNotifyForm').hide();

            var nf_list = '';
            var setNotifyList = function () {

                $('#set_notify_list_tip').val('');

                var digestNotifyAddChecked = $('.digestNotifyAdd').prop('checked');
                var dynamicListChecked = $('.dynamic_list_check').length && $('.dynamic_list_check').prop('checked') ? true : false;
                var nfl_option = '';

                $.each(nf_list, function()
                {
                    if (this.nfl_id)
                    {
                        var id       = this.nfl_id,
                            recivers = this.receiver_cnt,
                            digest   = this.nfl_digest === 't',
                            name     = this.nfl_name,
                            user     = this.nfl_user,
                            type     = this.nfl_type,
                            dynamic  = $.isNumeric(this.nfl_dynamic),
                            add_opt = false;

                        if (digestNotifyAddChecked) {
                            add_opt = digest;
                        } else if (!digest) {
                            add_opt = dynamicListChecked === dynamic;
                        }

                        if (add_opt)
                        {
                            nfl_option +=
                                '<option receiver_cnt="'+recivers+'" nfl_dynamic="'+dynamic+'" value="'+id+'">' +
                                    name + ' (' + (dynamic ? 'Системный администратор' : type + ' - ' + user) + ')' +
                                '</option>';
                        }
                    }
                });

                var optionEmpty = dynamicListChecked ? '<option value="">Динамические руппы рассылок:</option>'
                                                     : '<option value="">Группы рассылок:</option>';

                $('#set_notify_list').html(optionEmpty + nfl_option);
                $('#set_notify_list_tip').focusout();
            };
            var dialog = $('<div></div>')
                .html('<div id="add_sms_notify">' + $('#add_sms_notify_tmpl').html().replace(/\{TMPL\}/g, '') + '</div>')
                .dialog({
                    autoOpen: false,
                    title: (updFlag ? 'Редактирование рассылки' : 'Создание рассылки'),
                    modal: true,
                    resizable: false,
                    zIndex : 3001,
                    width: 'auto',
                    position: {
                        my: 'center',
                        at: 'top',
                        of: window
                    },
                    open: function () {
                        $('#add_sms_notify').parents('.ui-dialog').css('opacity', 0);
                    },
                    create: function( event, ui ) {
                        if (updFlag) {
                            $('.dynamic_list_check').parent().parent().remove();
                            const nf_sms_provider = $('#' + nfId + ' td[aria-describedby="grid_nf_sms_provider"]')?.text()?.trim();
                            if (nf_sms_provider) {
                                $('#add_sms_notify .nf_sms_provider').val(nf_sms_provider);
                            }
                            var nf_priority = $('#' + nfId + ' td[aria-describedby="grid_nf_priority"]').attr('originalvalue');
                            if ($.isNumeric(nf_priority)) {
                                $('#add_sms_notify .nf_priority').val(nf_priority);
                            }
                        } else {
                            $('#set_notify_list').combobox({
                                selected: function (event, ui) {
                                    $('#set_notify_list').change();
                                }
                            });

                            $('#set_notify_list').parent().find('span.ui-combobox a.ui-combobox-toggle').removeClass('ui-button');
                            $('#set_notify_list').parent().find('input.ui-combobox-input').attr('id', 'set_notify_list_tip');

                            $.inputHints('#set_notify_list_tip', 'Группы рассылок:');
                        }
                        if (!$('.smsNotifyAdd').length && !$('.emailNotifyAdd').length) {
                            $('#add_sms_notify')
                                .html('<span class="color-red">У вас нет прав на создание рассылок</span>')
                                .parents('.ui-dialog').css('opacity', 1);
                            return;
                        }
                        showAjaxLoading();
                        $.ajax({
                            type: 'POST',
                            url: 'php/getData.php',
                            dataType: 'json',
                            data: {
                                qryType: 'getNotifyList',
                                nf_id: updFlag ? $('#grid').jqGrid('getGridParam', 'selrow') : null
                            },
                            success: function(tr){
                                checkSession(tr);
                                if (updFlag) {
                                    if (tr.data.nf_type === 1) {
                                        $('#add_sms_notify').find('.sendOnPartEmail, .sendOnPersonalEmail').parent().parent().hide();
                                    }
                                    if (tr.data.read_only) {
                                        hideAjaxLoading();
                                        $('#add_sms_notify')
                                            .html('<span class="color-red">Нельзя редактировать - до рассылки меньше часа</span>')
                                            .parents('.ui-dialog').css('opacity', 1);
                                        return;
                                    }
                                    $('.sms_left_title').html('*Остаток смс у отправителя в месяце рассылки:');
                                }
                                $('#add_sms_notify').parents('.ui-dialog').css('opacity', 1);
                                $('#sms_left').html(tr.data.sms_left);
                                if (tr.data.sms_left > 0) {
                                    $('#sms_left').addClass('color-green');
                                } else {
                                    $('#sms_left').addClass('color-red');
                                }

                                nf_list = tr.data.nf_list;
                                tr.data = null;

                                if (updFlag || __userRole__ != 'sys-admin') {
                                    setNotifyList();
                                } else {
                                    $('.dynamic_list_check').on('change', function () {
                                        if ($(this).prop('checked')) {
                                            $('#set_notify_list').append('<option value="">Динамические руппы рассылок:</option>');
                                        } else {
                                            $('#set_notify_list').append('<option value="">Группы рассылок:</option>');
                                        }
                                        setNotifyList();
                                    }).change();
                                }

                                if ($('.emailNotifyAdd').length) {
                                    $.getScript('js/jquery.tinymce.js', function(){
                                        const tinyMceSettings = Object.assign(getTinyMceDefaultSettings('multiple'), {
                                            oninit: function(){
                                                if (updFlag) {
                                                    $('#add_sms_notify .sn_text_email').tinymce().execCommand('mceInsertContent', false, nfData.nf_text_email);
                                                    $('#set_notify_list').val(nfData.nf_nfl_id).prop('disabled', true);
                                                    hideAjaxLoading();
                                                } else {
                                                    $.sms_templates(true);
                                                }
                                            }
                                        });
                                        $('#add_sms_notify .sn_text_email').tinymce(tinyMceSettings);
                                    });
                                } else if (updFlag) {
                                    hideAjaxLoading();
                                } else {
                                    $.sms_templates(true);
                                }
                            }
                        });
                    },
                    close: function () {
                        if ($('#add_sms_notify .sn_text_email').length) {
                            $('#add_sms_notify .sn_text_email').tinymce().remove();
                        }
                        $(this).dialog('destroy');
                        $(this).remove();
                    },
                    buttons: [
                        {
                            text: (updFlag ? 'Сохранить' : 'Создать'),
                            class: 'submit fm-button f-right',
                            click: function(){
                                $('#add_sms_notify .ui-dialog-buttonpane .error-msg').slideUp(function(){
                                    $(this).remove();
                                });
                            }
                        },
                        {
                            text: 'Отмена',
                            class: 'fm-button f-left',
                            style: 'color: #bdbdbd;',
                            click: function() {
                                $(this).dialog('close');
                            }
                        },
                        {
                            text: 'Шаблоны',
                            class: 'fm-button f-left',
                            style: 'color: #ababab',
                            click: function(){
                                $.sms_templates();
                            }
                        }]
                });
            dialog.dialog('open');
            $('#add_sms_notify').parent().next().appendTo('#add_sms_notify');
            $.wrapSubmit('#add_sms_notify');

            $('#add_sms_notify .sn_datetime')
                .datetimepicker({
                    dateFormat: "dd.mm.yy",
                    timeFormat: "hh:mm"
                })
                .blur();
            if (updFlag) {
                var dlgEl = $("#add_sms_notify");
                var datetime = nfData.nf_datetime.split(' '),
                    date = datetime[0].split('.'),
                    time = datetime[1].split(':');
                dlgEl.find('.sn_datetime').removeClass('grey').datetimepicker('setDate', (new Date(date[2], date[1]-1, date[0], time[0], time[1])) );
            }

            $('#add_sms_notify .button').button();

            $('.smsNotifyAdd, .emailNotifyAdd').on('change', function () {
                if (!$(this).prop('checked') || $('.smsNotifyAdd').prop('checked') && $('.emailNotifyAdd').prop('checked') && !$('.digestNotifyAdd').prop('checked')) {
                    return false;
                }
                if ($('.digestNotifyAdd').prop('checked')) {
                    $('.digestNotifyAdd').prop('checked', false).change();
                }
                setNotifyList();
            });
            $('.smsNotifyAdd').change(function(){
                if ($(this).prop('checked')) {
                    $('.smsNotifyForm').slideDown(300);
                } else {
                    $('.smsNotifyForm').slideUp(300);
                }
            });
            $('.emailNotifyAdd').change(function(){
                if ($(this).prop('checked')) {
                    $('.emailNotifyForm').slideDown(300);
                } else {
                    $('.emailNotifyForm').slideUp(300);
                }
            });
            $('.digestNotifyAdd').on('change', function () {
                if ($(this).prop('checked')) {
                    /*
                     * Если дайджест, то устанавливать минимальный приоритет
                     * Устанавливать приоритет рассылки могут только sys-admin
                     * */
                    if (__userRole__ === 'sys-admin') {
                        $('#add_sms_notify .nf_priority').val(0);
                    }
                    $('.emailNotifyForm').slideDown(300);
                    $('.smsNotifyAdd, .emailNotifyAdd').prop('checked', false);
                    $('.smsNotifyForm').slideUp(300);
                    setNotifyList();
                } else {
                    $('.emailNotifyForm').slideUp(300);
                }
            });

            $('#add_sms_notify .sn_text')
                .keyup(function(){
                    var msgEl = $("#add_sms_notify .sn_text"),
                        msgText = msgEl.val(),
                        msgTextLen = msgText.length;

                    /*
                    * Перенос строки в javascript - 1 символ
                    * */
                    const addLineBreak = msgText.match(/\n/g);
                    if (addLineBreak) {
                        msgTextLen += addLineBreak.length;
                    }

                    msgEl.next().html('Символов: '+msgTextLen+' (смс: '+calcSmsCnt(msgTextLen)+')');
                }).
                focus(function(){
                    $(this)
                        .keyup()
                        .next().animate({opacity:1},200)
                });
            $.tipTipMy('#add_sms_notify .nf_sms_provider','СМС-провайдер');
            $.tipTipMy('#add_sms_notify .nf_priority','Приоритет рассылки');
            $.inputHints('#add_sms_notify .sn_text','Текст смс-сообщения:');
            $.inputHints('#add_sms_notify .sn_email_subj', 'Тема email');

            $('#add_sms_notify .sn_from').mask('*?***********');
            $.tipTipMy('#add_sms_notify .sn_from','От кого (латиница)');

            var getCurrMembCnt = 0;
            var set_recievers_cnt = function(){
                if (__userRole__ == 'sys-admin' && $('#set_notify_list').val() == '') {
                    if ($('.dynamic_list_check').is(":checked")) {
                        $.inputHints('#set_notify_list_tip', 'Динамические группы рассылок:');
                    } else {
                        $.inputHints('#set_notify_list_tip', 'Группы рассылок:');
                    }
                }

                if ($('#set_notify_list').val() == '') {
                    getCurrMembCnt = $("#grid").jqGrid('getGridParam', 'records');
                } else {
                    getCurrMembCnt = $('#set_notify_list option:selected').attr('receiver_cnt');
                }
                $('#add_sms_notify .sn_resivers').html($.number_format(getCurrMembCnt, 0, ',', ' '));
            };

            $('#set_notify_list_tip').focusout(function(){
                $('#set_notify_list').val('');

                for (i = 1; i < $('#set_notify_list option').length; i++) {
                    if ($('#set_notify_list_tip').val() == $('#set_notify_list option').eq(i).html()) {
                        $('#set_notify_list option:selected').prop('selected', false);
                        $('#set_notify_list option').eq(i).prop('selected', true);
                        break;
                    }
                }

                if ($('#set_notify_list').val() == '') {
                    $(this).val('');
                }

                set_recievers_cnt();
            });

            $('#set_notify_list').change(function(){
                if ($('#set_notify_list option:selected').attr('nfl_dynamic') === 'true') {
                    var dynamic_val = $('#set_notify_list').val();

                    if ($.isNumeric(dynamic_val)) {
                        showAjaxLoading();
                        $.ajax({
                            type: "POST",
                            url: "../php/getData.php",
                            dataType: "json",
                            data: {
                                qryType: 'refreshNotifyList',
                                dynamicNotifyList: dynamic_val
                            },
                            success: function (tr) {
                                hideAjaxLoading();
                                checkSession(tr);
                                $('#set_notify_list option:selected').attr('receiver_cnt', tr.data.cnt);
                                set_recievers_cnt();
                            }
                        });
                    }
                } else {
                    set_recievers_cnt();
                }
            }).change();

            $('#tmplDirName').val(__userId__ + '_' +new Date().getTime());

            $("#add_sms_notify .add_file").on('click', function(e){
                $('input#filesToUpload').click();
            });

            $('input#filesToUpload').change(function() {
                var formData = new FormData(),
                    currentFiles =[];
                $('#ulListFiles li').map(function(){ currentFiles.push($(this).text());});

                for (var i = 0, file; file = this.files[i]; ++i) {
                    if(currentFiles.indexOf(file.name) != -1){
                        $('ul#ulListFiles li:contains(\"'+file.name+'\")').remove();
                    }
                    $('ul#ulListFiles').append($( '<li class="attachment newFile"  title="Новый файл"><i class="fa fa-file color-orange"></i>'+file.name+'</li>'));
                    formData.append('file-'+i, file);
                }
                formData.append('qryType','multiupload');
                formData.append('tmplDirName',$('#tmplDirName').val());

                $.ajax({
                    type:'POST',
                    url:'/php/getData.php',
                    cache: false,
                    processData: false,
                    contentType: false,
                    data: formData,
                    success: function(tr){
                        if( checkSession(tr) ){
                            $('#ulListFiles i.fa-file').removeClass('color-orange').addClass('color-green');
                            $('#ulListFiles li.newFile').append('<i class="color-red fa fa-times"></i>').removeClass('newFile');

                            $('#ulListFiles i.fa-times').click(function(){
                                $(this).parent().remove();
                            });

                        }
                    }
                });
            });

            if (updFlag) {
                if (nfData.nf_sms == 'Yes') {
                    dlgEl.find('.smsNotifyAdd').click();
                    dlgEl.find('.sn_from').val(nfData.nf_from);
                    dlgEl.find('.sn_text').val(nfData.nf_text).keyup().focus().removeClass('grey');
                }

                if (nfData.nf_email == 'Yes') {
                    dlgEl.find('.emailNotifyAdd').click();
                    dlgEl.find('.sn_email_subj').val(nfData.nf_email_subj).removeClass('grey');
                }

                if (nfData.nf_digest == 'Yes') {
                    dlgEl.find('.digestNotifyAdd').click();
                    dlgEl.find('.sn_email_subj').val(nfData.nf_email_subj).removeClass('grey');
                }

                var filesInGrid = $.each($('#'+nfId+' td[aria-describedby="grid_nf_email_attach"] a'),function(){return this;});
                if (filesInGrid.length){
                    for (var i = 0, len = filesInGrid.length; i<len; i++){
                        $('#ulListFiles').append($( '<li class="attachment inAttach" title="Загрузить файл"><i class = "fa fa-file color-blue"></i><a target="_blank" href=\"'+filesInGrid[i].href+'\">'+filesInGrid[i].text+'</a><i class="color-red fa fa-times"></i></li>'));
                    }
                    $('li.inAttach .fa-times').click(function(){
                        var fName = $(this).prev().text();
                        $(this).parent().remove();
                        $.ajax({
                            type: 'POST',
                            url: 'php/getData.php',
                            dataType: 'json',
                            data: {
                                qryType: 'removeAttachFile',
                                fileName: fName,
                                nfId: nfId
                            },
                            success: function(tr){
                                checkSession(tr);
                            }
                        });
                    });
                }

                if (nfData.nf_email_value == 2) {
                    $("#add_sms_notify .sendOnPersonalEmail").prop("checked",false);
                } else if(nfData.nf_email_value == 3) {
                    $("#add_sms_notify .sendOnPartEmail").prop("checked",false);
                }

                dlgEl.find('.sn_resivers').html(nfData.nf_receivers);
            }

            $('#add_sms_notify form').validate({
                keyup: true,
                ignoreTitle: true,
                focusInvalid: false,
                focusCleanup: true,
                rules: {
                    sn_from:{maxlength: 11}
                },
                showErrors: function(errorMap, errorList) {
                    for(var i = 0; i < errorList.length; i++){
                        if($(errorList[i].element).hasClass('sn_text_email')){
                            if($.trim($('#add_sms_notify .sn_text_email').tinymce().getContent()) == '') {
                                errorList[i].element = $('.mceLayout');
                                $('.mceLayout').css({border: '1px solid red'});
                            } else {
                                errorList.splice(i,1);
                                $('.mceLayout').removeAttr('style');
                            }
                        }
                    }
                    this.defaultShowErrors();
                },
                submitHandler:function (form) {
                    if (!$('#add_sms_notify .smsNotifyAdd').prop('checked') && !$('#add_sms_notify .emailNotifyAdd').prop('checked') && !$('#add_sms_notify .digestNotifyAdd').prop('checked')) {
                        $('#add_sms_notify .result').html('<hr><span class="color-red">Выберите тип рассылки - sms и/или email или дайджест</span>');
                    } else if (parseInt(getCurrMembCnt) == 0) {
                        $('#add_sms_notify .result').html('<hr><span class="color-red">Получатели не найдены: проверьте параметры фильтрации грида</span>');
                    } else if (($('#add_sms_notify .emailNotifyAdd').prop('checked') || $('#add_sms_notify .digestNotifyAdd').prop('checked'))&& !$('#add_sms_notify .sendOnPartEmail').prop('checked') && !$('#add_sms_notify .sendOnPersonalEmail').prop('checked')) {
                        $('#add_sms_notify .result').html('<hr><span class="color-red">Укажите на какой тип e-mail осуществить рассылку</span>');
                    } else {
                        var sms_cnt = $("#add_sms_notify .sn_text").length ? parseInt(getCurrMembCnt) * calcSmsCnt($("#add_sms_notify .sn_text").val().length) : 0;
                        var msg_notice =  '';
                        if(__userRole__ == 'sys-admin'){
                            msg_notice = '<span class="color-red">Рассылка более '+$('.sms_limit_without_agreement').val()+' СМС'+'</span>'
                        } else {
                            msg_notice = '<span class="color-red">Рассылка более '+$('.sms_limit_without_agreement').val()+' СМС стартует только после согласования технической поддержкой'+'</span>'
                        }
                        var confirmDialog = $('<div></div>')
                            .html(
                                '<span style="font-size: 20px;"><b>Количество получателей:</b> ' + $('#add_sms_notify .sn_resivers').html() + '</span>' +
                                ($('#add_sms_notify .smsNotifyAdd').prop('checked') && $('#add_sms_notify .sn_from').length ? '<br><b>Смс от:</b> ' + $('#add_sms_notify .sn_from').val() : '') +
                                ($('#add_sms_notify .emailNotifyAdd').prop('checked') || $('#add_sms_notify .digestNotifyAdd').prop('checked') ? '<br><b>Тема email:</b> ' + $('#add_sms_notify .sn_email_subj').val() : '') +
                                '<br><br>' +
                                'Точно ' + (updFlag ? 'редактировать' : 'добавить') + ' рассылку ?' +
                                '<br><br>' +
                                ($('#add_sms_notify .smsNotifyAdd').prop('checked') && sms_cnt  > $('.sms_limit_without_agreement').val() ? msg_notice +'</span>' : '')
                            )
                            .dialog({
                                autoOpen: false,
                                title: 'Подтверждение',
                                modal: true,
                                resizable: false,
                                width: 'auto',
                                zIndex : 3001,
                                close: function(ev, ui) {
                                    $(this).dialog('destroy');
                                    $(this).remove();
                                },
                                buttons: [
                                    {
                                        text: 'Ок',
                                        class: 'submit fm-button f-right',
                                        click: function() {
                                            showAjaxLoading();

                                            var data = $('#add_sms_notify form').serializeArray();
                                            data.push({name: 'qryType', value: 'addSMSNotify'});
                                            if (updFlag) {
                                                data.push({name: 'nf_id', value: nfId});
                                            }
                                            if ($('.smsNotifyAdd').length) {
                                                data.push({name: 'sms', value: $('#add_sms_notify .smsNotifyAdd').prop('checked')});
                                            }
                                            if ($('.emailNotifyAdd').length) {
                                                data.push({name: 'email', value: $('#add_sms_notify .emailNotifyAdd').prop('checked')});
                                                data.push({name: 'digest', value: $('#add_sms_notify .digestNotifyAdd').prop('checked')});
                                                data.push({name: 'emailPart', value: $('#add_sms_notify .sendOnPartEmail').prop('checked')});
                                                data.push({name: 'emailPersonal', value: $('#add_sms_notify .sendOnPersonalEmail').prop('checked')});
                                                data.push({name: 'add_logo', value: $('#add_sms_notify .nfEmailAddLogo').prop('checked')});
                                                data.push({name: 'sn_text_email', value: $('#add_sms_notify .sn_text_email').tinymce().getContent()});
                                                data.push({name: 'sn_email_attach', value: $("#tmplDirName").val()});
                                                var filesList = [];
                                                $('#ulListFiles li').each(function(){
                                                    filesList.push($(this).text());
                                                });
                                                data.push({name: 'files', value: JSON.stringify(filesList)});
                                            }

                                            if (postData.filters)
                                                data.push({name: 'filters', value: postData.filters });

                                            if (postData.memberBDay)
                                                data.push({name: 'memberBDay', value: postData.memberBDay });

                                            $(this).dialog('close');

                                            $.ajax({
                                                type: 'POST',
                                                url: 'php/Smser/handler.php',
                                                dataType: 'json',
                                                data: data,
                                                success: function (tr) {
                                                    hideAjaxLoading();
                                                    if (tr.auth == -1) {
                                                        tr.error = '<b>Время сессии истекло.</b>';
                                                    }
                                                    if (tr.error != '') {
                                                        $('#add_sms_notify .result').html('<hr><span class="color-red">' + tr.error + '</span>');
                                                    } else {
                                                        dialog.dialog('close');

                                                        $('#grid').trigger('reloadGrid');

                                                        var succDialog = $('<div id="notify_popup"></div>')
                                                            .html('Рассылка успешно ' + (updFlag ? 'отредактирована' : 'добавлена'))
                                                            .dialog({
                                                                autoOpen: false,
                                                                title: (updFlag ? 'Редактирование рассылки' : 'Создание рассылки'),
                                                                modal: true,
                                                                resizable: false,
                                                                zIndex : 3001,
                                                                close: function (ev, ui) {
                                                                    $(this).dialog('destroy');
                                                                    $(this).remove();
                                                                },
                                                                buttons: [
                                                                    {
                                                                        text: 'Ок',
                                                                        click: function() {
                                                                            $(this).dialog('close');
                                                                        }
                                                                    }
                                                                ]
                                                            });
                                                        succDialog.dialog('open');
                                                        $('.ui-dialog-buttonset :button').blur();
                                                        setTimeout(function(){
                                                            if ($('#notify_popup').length) {
                                                                succDialog.dialog('close');
                                                            }
                                                        }, 3000);
                                                    }
                                                }
                                            });
                                        }
                                    },
                                    {
                                        text: 'Отмена',
                                        class: 'fm-button f-left',
                                        style: 'color: #bdbdbd;',
                                        click: function() {
                                            $(this).dialog('close');
                                        }
                                    }
                                ]
                            });

                        confirmDialog.dialog('open');
                        $('.ui-dialog-buttonset :button').blur();
                    }
                }
            });
        }
    };

    $.formatJson = function(cellValue, options, rowObject) {
        var rowid = options.rowId;

        try
        {
            JSON.parse(cellValue);
        }
        catch(err) { return cellValue; }

        if (!cellValue) return '&nbsp;';


        var title = '', cellEl = '', cellValuePrs;
        var html = '<a href="javascript:void(0)" class="link-simple show-more">подробности...</a>'+
                    '<span class=\"hidden parsed_data\">';

        cellValuePrs = JSON.parse(cellValue);

        if (cellValuePrs && cellValuePrs[0] && cellValuePrs[0][0]) {
            if(cellValuePrs[0][0].name.substr(0,4) == 'mpp_'){
                html += '<table class="width-400"><thead><tr><th class="width-200">Специальность по диплому</th><th class="action hidden"><a href="javascript:void(0)" class="add_record">добавить</a></th></tr></thead>';
                cellEl = '#'+rowid+' td[aria-describedby="grid_m_personal_profession"]';
                title = 'Специальность';
            } else if(cellValuePrs[0][0].name.substr(0,4) == 'mpe_'){
                html += '<table class="width-400"><thead><tr><th class="width-200">Уч.заведение</th><th class="width-100x">Поступление&nbsp;</th><th class="width-100x">Окончание&nbsp;</th><th class="width-200">Специальность</th><th class="action hidden"><a href="javascript:void(0)" class="add_record">добавить</a></th></tr></thead>';
                cellEl = '#'+rowid+' td[aria-describedby="grid_m_personal_education"]';
                title = 'Детализация образования';
            } else if(cellValuePrs[0][0].name.substr(0,4) == 'mpla') {
                html += '<table class="width-400"><thead><tr><th class="width-200">Должность и место работы</th><th class="width-100x">Поступления&nbsp;</th><th class="width-100x">Увольнения&nbsp;</th><th class="action hidden"><a href="javascript:void(0)" class="add_record">добавить</a></th></tr></thead>';
                cellEl = '#'+rowid+' td[aria-describedby="grid_m_personal_labor_activity"]';
                title = 'Трудовая деятельность';
            } else if(cellValuePrs[0][0].name.substr(0,4) == 'mspa') {
                html += '<table class="width-400"><thead><tr><th class="width-200">Деятельность</th><th class="width-100x">Начало&nbsp;</th><th class="width-100x">Окончание&nbsp;</th><th class="action hidden"><a href="javascript:void(0)" class="add_record">добавить</a></th></tr></thead>';
                cellEl = '#'+rowid+' td[aria-describedby="grid_m_socio_political_activities"]';
                title = 'Общественно-политическая деятельность';
            } else if(cellValuePrs[0][0].name.substr(0,4) == 'mpoi') {
                html += '<table class="width-400"><thead><tr><th class="width-200">Вид организации</th><th class="width-200">Название организации</th><th class="width-200">Статус в организации</th><th class="action hidden"><a href="javascript:void(0)" class="add_record">добавить</a></th></tr></thead>';
                cellEl = '#'+rowid+' td[aria-describedby="grid_m_public_organization_info"]';
                title = 'Организации';
            }
        }

        $.each(cellValuePrs, function(k,v){
            html += '<tr class=\"'+(k%2 == 0 ? 'subgridRowAlt' : '')+'\">';
            $.each(v, function(k1, obj){
                html += '<td class="'+obj.name+'">'+obj.value+'</td>';
            });
            html += '<td class=\"hidden action\" align=\"center\">';
            html +=      '<i class=\"fa fa-save link-simple save hidden\" title=\"применить редакции\"></i> <i class=\"fa fa-times-circle link-simple cancel hidden\" title=\"отмена редактирования\"></i>';
            html +=      '<i class=\"fa fa-pencil link-simple edit\" title=\"редактировать запись\"></i> <i class=\"fa fa-trash-o link-simple remove\" title=\"удалить запись\"></i>';
            html += '</td>';
            html += '</tr>';
        });
        html += '<tr class="action"><td colspan="3"><input type="hidden" class="res_json" name="res_json" value="'+encodeURI(cellValue)+'" /></td></tr>';
        html += '</table></span>';

        $('#grid').on('click', cellEl, function(){
            var prsDataEl = $(this).find('.parsed_data');
            if(prsDataEl.length > 0){
                $('.table-popup').remove();
                $('<div class=\"table-popup\"></div>')
                    .html(prsDataEl.html())
                    .dialog({
                        autoOpen: true,
                        title: title,
                        modal: true,
                        height: 'auto',
                        width: 'auto',
                        open: function(event, ui){
                            $('.ui-dialog-buttonset :button').blur();
                        },
                        buttons: [{
                            text: "Закрыть",
                            class: "button",
                            click: function() { $(this).dialog("destroy"); }
                        }]
                    });
            }
        });
        return html;
    };

    $.editJsonCell = function(elm){
        var datePickerOpt = {
            dateFormat: 'dd.mm.yy',
            changeMonth: true,
            changeYear: true,
            showAnim: 'slideDown',
            yearRange: "c-70:c+1"
        };

        $.each($(elm).find('th').not('.action').find('input'), function(k,v){
            var title = $(this).attr('title'),
                name = $(this).attr('name');
            setTimeout(function(){
                $.inputHints('.customelement input[name='+name+']',title,false);
            }, 200);

            if($(this).attr('name').search('date') > 0) {
                $(this).datepicker(datePickerOpt);
            }
        });

        $(elm).on('click', '.add_record', function(){
            var prntEl = $(this).parents('table:first'),
                resHtml = '<tr>',
                errFl = false;
            $.each(prntEl.find('.data'), function(){
				// класс .grey - говорит о том, что в поле не введено значение
                if(($(this)[0].nodeName == 'SELECT' && !$(this).val()) ||
					($(this).hasClass('grey') && $.inArray($(this).attr('name'), ['mpe_date_from', 'mpe_date_to', 'mpla_date_from', 'mpla_date_to', 'mspa_date_from', 'mspa_date_to', 'mpe_profession']) === -1))
				{
                    $(this).addClass('error');
                    errFl = true;
                } else {
                    $(this).removeClass('error');
                    resHtml += '<td class=\"'+$(this).attr('name')+'\">'+($(this).hasClass('grey') ? '' : $(this).val())+'</td>';
                }
            });
            resHtml += '<td class=\"action\" align=\"center\">';
            resHtml +=      '<i class=\"fa fa-save link-simple save hidden\" title=\"применить редакции\"></i> <i class=\"fa fa-times-circle link-simple cancel hidden\" title=\"отмена редактирования\"></i>';
            resHtml +=      '<i class=\"fa fa-pencil link-simple edit\" title=\"редактировать запись\"></i> <i class=\"fa fa-trash-o link-simple remove\" title=\"удалить запись\"></i>';
            resHtml += '</td>';
            resHtml += '</tr>';
            if(!errFl){
                prntEl.find('tbody').append(resHtml);
                prntEl.find('.data').val('').focusout();
                recalcJson(prntEl);
            }
        });

        $(elm).on('click', '.edit', function(){
            var prntEl = $(this).parents('table:first'),
                prntTr = $(this).parents('tr:first');
            $.each(prntTr.find('td').not('.action'), function(k,v){
                var prntSrcEl = prntEl.find('thead th:eq('+k+')').find('input, select'),
					elClass = $(this).attr('class'),
                    elWidth = prntSrcEl.width(),
                    somestr;
                if($.inArray(elClass, ['mpoi_org_type', 'mpoi_org_status']) > -1) {
					var editElmVal = $(this).text(),
						editElm = prntSrcEl.clone().val(editElmVal).attr('prev-value', editElmVal);
                    $(this).html('').append(editElm);
                } else if(elClass.search('date') > 0) {
                    $(this).html('<input type="text" value="'+$(this).html()+'" style="width:'+elWidth+'px" prev-value="'+$(this).html()+'" />');
                    prntTr.find('td:eq('+k+') input').datepicker(datePickerOpt);
                } else {
                    somestr = $(this).html();
                    $(this).html('<input type="text" value="" style="width:'+elWidth+'px" prev-value="" />');
                    $(this).find('input').first().val(somestr).attr('prev-value',somestr);
                }
            });
            prntTr.find('td.action i').hide();
            prntTr.find('td.action i.hidden').show();
        });

        $(elm).on('click', '.remove', function(){
            var prntEl = $(this).parents('table:first');
            $(this).parents('tr:first').remove();
            recalcJson(prntEl);
        });

        $(elm).on('click', '.save', function(){
            var prntEl = $(this).parents('table:first'),
                prntTr = $(this).parents('tr:first');
            $.each(prntTr.find('td').not('.action'), function(k,v){
                $(this).html($(this).find('input,select').val());
            });
            prntTr.find('td.action i').hide();
            prntTr.find('td.action i').not('.hidden').show();
            recalcJson(prntEl);
        });

        $(elm).on('click', '.cancel', function(){
            var prntTr = $(this).parents('tr:first');
            $.each(prntTr.find('td').not('.action'), function(k,v){
                $(this).html($(this).find('input,select').attr('prev-value'));
            });
            prntTr.find('td.action i').hide();
            prntTr.find('td.action i').not('.hidden').show();
        });

        var recalcJson = function(tbl){
            var resData = [];
            $.each($(tbl).find('tbody tr').not('.action'), function(){
                var currData = [];
                $.each($(this).find('td').not('.action'), function(){
                    currData.push({name: $(this).attr('class'), value: $(this).text().trim()});
                });
                resData.push(currData);
            });
            $(tbl).find('.res_json').val(resData.length != 0 ? encodeURI(JSON.stringify(resData)) : null);
        }
    };

    // ************ DATAGRID FILES ADD/EDIT/REMOVE METHODS ************ //
    $.addOrEditFilesCell = function(elm, path, several_flds, one_file){
        setTimeout(function(){
            $(elm).on('click', '.remove_file', function(){
                var fileInpEl = $(this).prev();
                if(fileInpEl.hasClass('line-through')) {
                    fileInpEl.removeClass('line-through');
                    $(this).text('удалить');
                } else {
                    fileInpEl.addClass('line-through');
                    $(this).text('восстановить');
                }
            });

            $(elm).on('click', '.add_file', function(){
                $('#m_file_types option').removeAttr('selected');
                var filesCnt = (several_flds ? $(elm).parents('table:first').find('.attachment').length : $(elm).find('.attachment').length),
                    m_files = $(elm).parents('tr:first').attr('id') == 'tr_m_files',
                    rps_files = $(elm).parents('tr:first').attr('id') == 'tr_rps_files',
                    rppp_files = $(elm).parents('tr:first').attr('id') == 'tr_rppp_files',
                    rpr_files = $(elm).parents('tr:first').attr('id') == 'tr_rpr_files',
                    rpmb_files = $(elm).parents('tr:first').attr('id') == 'tr_rpmb_files',
                    rppma_files = $(elm).parents('tr:first').attr('id') == 'tr_rppma_files',
                    rppsr_files = $(elm).parents('tr:first').attr('id') == 'tr_rppsr_files',
                    rpw_files = $(elm).parents('tr:first').attr('id') == 'tr_rpw_files',
                    cl_files = $(elm).parents('tr:first').attr('id') == 'tr_cl_files',
                    penalty_scans = $(elm).parents('tr:first').attr('id') == 'tr_penalty_scans',
                    ap_documents = $(elm).parents('tr:first').attr('id') == 'tr_ap_documents',
                    inputHtml =
                        '<span class="attach-wrap marg-bot-5 display-block"><span>'+
                            '<input type="file" class="attachment_input" id="attachment_input_'+filesCnt+'" name="attachment_input_'+filesCnt+'" file-cnt="'+filesCnt+'">'+
                            '<input class="attachment width-210 hidden new-file" id="attachment_'+filesCnt+'" name="attachment_'+filesCnt+'" disabled="disabled" value="">'+
                            '&nbsp;<a href="javascript:void(0)" class="remove_file hidden">удалить</a>'+
                            (m_files ?
                                '<div class="hidden file_type" style="margin-top: 5px;">'+
                                    '<select id="file_type_'+filesCnt+'" name="file_type_'+filesCnt+'" file-cnt="'+filesCnt+'">'+$('#m_file_types').html()+'</select>'+
                                '</div>'+
                                '<div class="hidden file_comment" style="margin-top: 5px;">'+
                                    '<textarea class="grey" id="file_comment_'+filesCnt+'" name="file_comment_'+filesCnt+'" file-cnt="'+filesCnt+'"></textarea>'+
                                '</div>'
                            : '')+
                            (rpr_files ?
                                '<br><input type="text" name="file_name_'+filesCnt+'" class="file_name file_name_'+filesCnt+' FormElement ui-widget-content ui-corner-all grey" style="margin-top: 5px;">'
                            : '') +
                            (rpmb_files ?
                                '<br><input type="text" name="file_name_'+filesCnt+'" class="file_name file_name_'+filesCnt+' FormElement ui-widget-content ui-corner-all grey" style="margin-top: 5px;">'
                            : '') +
                            (rppma_files ?
                                '<br><input type="text" name="file_name_'+filesCnt+'" class="file_name file_name_'+filesCnt+' FormElement ui-widget-content ui-corner-all grey" style="margin-top: 5px;">'
                            : '') +
                            (rppsr_files ?
                                '<br><input type="text" name="file_name_'+filesCnt+'" class="file_name file_name_'+filesCnt+' FormElement ui-widget-content ui-corner-all grey" style="margin-top: 5px;">'
                            : '') +
                            (rpw_files ?
                                '<br><input type="text" name="file_name_'+filesCnt+'" class="file_name file_name_'+filesCnt+' FormElement ui-widget-content ui-corner-all grey" style="margin-top: 5px;">'
                            : '') +
                            (cl_files ?
                                '<br><input type="text" name="file_name_'+filesCnt+'" class="file_name file_name_'+filesCnt+' FormElement ui-widget-content ui-corner-all grey" style="margin-top: 5px;">'
                            : '') +
                            (rppp_files ?
                                '<br><input type="text" name="file_name_'+filesCnt+'" class="file_name file_name_'+filesCnt+' FormElement ui-widget-content ui-corner-all grey" style="margin-top: 5px;">'
                            : '') +
                            (penalty_scans ?
                                '<br><input type="text" name="file_name_'+filesCnt+'" class="file_name file_name_'+filesCnt+' FormElement ui-widget-content ui-corner-all grey" style="margin-top: 5px;">'
                            : '') +
                            (rps_files ?
                                '<br><input type="text" name="file_name_'+filesCnt+'" class="file_name file_name_'+filesCnt+' FormElement ui-widget-content ui-corner-all grey" style="margin-top: 5px;">'
                            : '') +
                            (ap_documents ?
                                '<br><input type="text" name="file_name_'+filesCnt+'" class="file_name file_name_'+filesCnt+' FormElement ui-widget-content ui-corner-all grey" style="margin-top: 5px;">'
                            : '') +
                            '</span>'+((m_files || rps_files || rppp_files || rpr_files || rpmb_files || rppma_files || rppsr_files || rpw_files || cl_files || penalty_scans || ap_documents) ? '<hr>' : '')+'</span>';
                $(elm).find('.add-wrap').before(inputHtml);
                if(one_file) {
                    $(elm).find('.add-wrap').hide();
                } else {
                    $(elm).find('.add-wrap').show();
                }
                $('#file_type_'+filesCnt).combobox();
                $.inputHints('#file_comment_'+filesCnt,'Комментарий:', false);
                $.inputHints('#m_files .ui-combobox-input:last','Тип файла:', false);
                $('#m_files .ui-combobox-input:last').addClass('grey');
                $.inputHints('#rps_files .file_name_'+filesCnt,'Название файла:');
                $.inputHints('#rppp_files .file_name_'+filesCnt,'Название файла:');
                $.inputHints('#rpr_files .file_name_'+filesCnt,'Название файла:');
                $.inputHints('#rpmb_files .file_name_'+filesCnt,'Название файла:');
                $.inputHints('#rppma_files .file_name_'+filesCnt,'Название файла:');
                $.inputHints('#rppsr_files .file_name_'+filesCnt,'Название файла:');
                $.inputHints('#rpw_files .file_name_'+filesCnt,'Название файла:');
                $.inputHints('#cl_files .file_name_'+filesCnt,'Название файла:');
                $.inputHints('#penalty_scans .file_name_'+filesCnt,'Название файла:');
                $.inputHints('#ap_documents .file_name_'+filesCnt,'Название файла:');
            });

            $(elm).on('change', '.attachment_input', function(){
                var _thisPrnt = $(this).parent();
                uploadFile($(this).attr('id'), path, function(fileName){
                    $(_thisPrnt).find('.remove_file, .file_comment, .file_type').removeClass('hidden').show();
                    $(_thisPrnt).find('.attachment').val(fileName).show();
                });
            });

            var currVal = '';
            $.each($('#m_files .file_comment textarea'), function(){
                currVal = $(this).val();
                $.inputHints('#'+$(this).attr('id'), 'Комментарий:', false);
                $(this).val(currVal).focusout();
            });

            $.each($('#m_files .file_type'), function(k,v){
                $(this).find('select').combobox();
                $.inputHints('#m_files .file_type:eq('+k+') .ui-combobox-input', 'Тип файла:', false);
                $(this).find('.ui-combobox-input').val($(this).find('select option:selected').html());
            });

            $.each($('#rps_files .file_name'), function () {
                currVal = $(this).val();
                $.inputHints('#'+$(this).attr('id'), 'Название файла:');
                $(this).val(currVal).focusout();
            });

            $.each($('#rppp_files .file_name'), function () {
                currVal = $(this).val();
                $.inputHints('#'+$(this).attr('id'), 'Название файла:');
                $(this).val(currVal).focusout();
            });

            $.each($('#rpr_files .file_name'), function () {
                currVal = $(this).val();
                $.inputHints('#'+$(this).attr('id'), 'Название файла:');
                $(this).val(currVal).focusout();
            });

            $.each($('#rpmb_files .file_name'), function () {
                currVal = $(this).val();
                $.inputHints('#'+$(this).attr('id'), 'Название файла:');
                $(this).val(currVal).focusout();
            });

            $.each($('#rppma_files .file_name'), function () {
                currVal = $(this).val();
                $.inputHints('#'+$(this).attr('id'), 'Название файла:');
                $(this).val(currVal).focusout();
            });

            $.each($('#rppsr_files .file_name'), function () {
                currVal = $(this).val();
                $.inputHints('#'+$(this).attr('id'), 'Название файла:');
                $(this).val(currVal).focusout();
            });

            $.each($('#rpw_files .file_name'), function () {
                currVal = $(this).val();
                $.inputHints('#'+$(this).attr('id'), 'Название файла:');
                $(this).val(currVal).focusout();
            });

            $.each($('#cl_files .file_name'), function () {
                currVal = $(this).val();
                $.inputHints('#'+$(this).attr('id'), 'Название файла:');
                $(this).val(currVal).focusout();
            });

            $.each($('#penalty_scans .file_name'), function () {
                currVal = $(this).val();
                $.inputHints('#'+$(this).attr('id'), 'Название файла:');
                $(this).val(currVal).focusout();
            });

            $.each($('#ap_documents .file_name'), function () {
                currVal = $(this).val();
                $.inputHints('#'+$(this).attr('id'), 'Название файла:');
                $(this).val(currVal).focusout();
            });

        }, 200);

    };
    $.customElementFilesCell = function(value, options){
        var elm = document.createElement('span'),
            randVal = __userId__ + '_' +new Date().getTime() + '_' + (Math.random() * (100000 - 0) + 0),
            fileList = $.genFilesList(value);
        fileList +=
            '<div class="add-wrap">'+
                '&nbsp;<a href="javascript:void(0)" class="add_file">добавить файл</a>'+
                '</div>'+
                '<input type="hidden" id="tmplDirName" name="tmplDirName" value="'+randVal+'" />';

        elm.innerHTML = fileList;
        return elm;
    };
    $.customValueFilesCell = function(elm, operation, value){
        if(operation === 'get') {
            var data = [],
                new_data = {},
                oper = '';
            $.each($(elm).find('.attachment'), function(){
                if($(this).hasClass('line-through'))
                    oper = 'del';
                else if($(this).hasClass('new-file'))
                    oper = 'add';
                else oper = 'no-chng';

                new_data = {"fname": encodeURI($(this).val()), "fnameUpl": $(this).attr('id'), "oper": oper};
                if(oper != 'del'){
                    if($(this).parent().find('.file_comment').length){
                        new_data.fcomment = $(this).parent().find('.file_comment textarea').hasClass('grey') ? '' : $(this).parent().find('.file_comment textarea').val();
                    }
                    if($(this).parent().find('.file_type').length){
                        new_data.ftype = $(this).parent().find('.file_type .ui-combobox-input').val();
                    }
                    if($(this).parent().find('.file_name').length){
                        new_data.file_name = $(this).parent().find('.file_name').hasClass('grey') ? '' : $(this).parent().find('.file_name').val();
                    }
                }

                data.push(new_data);
            });
            return {"tmplDirName": $('#tmplDirName').val(), "files": data};
        } else if(operation === 'set') {
            $(elm).find('.attach-wrap').remove();
            $(elm).find('.add-wrap').before($.genFilesList(value));

            var currVal = '';
            $.each($('#m_files .file_comment textarea'), function(){
                currVal = $(this).val();
                $.inputHints('#'+$(this).attr('id'), 'Комментарий:', false);
                $(this).val(currVal).focusout();
            });

            $.each($('#m_files .file_type'), function(k,v){
                $(this).find('select').combobox();
                $.inputHints('#m_files .file_type:eq('+k+') .ui-combobox-input', 'Тип файла:', false);
                $(this).find('.ui-combobox-input').val($(this).find('select option:selected').html());
            });

            $.each($('#rps_files .file_name'), function (k,v) {
                currVal = $(this).val();
                $.inputHints('#rps_files .file_name:eq('+k+')', 'Название файла:', false);
                $(this).val(currVal).focusout();
            });

            $.each($('#rppp_files .file_name'), function (k,v) {
                currVal = $(this).val();
                $.inputHints('#rppp_files .file_name:eq('+k+')', 'Название файла:', false);
                $(this).val(currVal).focusout();
            });

            $.each($('#rpr_files .file_name'), function (k,v) {
                currVal = $(this).val();
                $.inputHints('#rpr_files .file_name:eq('+k+')', 'Название файла:', false);
                $(this).val(currVal).focusout();
            });

            $.each($('#rpmb_files .file_name'), function (k,v) {
                currVal = $(this).val();
                $.inputHints('#rpmb_files .file_name:eq('+k+')', 'Название файла:', false);
                $(this).val(currVal).focusout();
            });

            $.each($('#rppma_files .file_name'), function (k,v) {
                currVal = $(this).val();
                $.inputHints('#rppma_files .file_name:eq('+k+')', 'Название файла:', false);
                $(this).val(currVal).focusout();
            });

            $.each($('#rppsr_files .file_name'), function (k,v) {
                currVal = $(this).val();
                $.inputHints('#rppsr_files .file_name:eq('+k+')', 'Название файла:', false);
                $(this).val(currVal).focusout();
            });

            $.each($('#rpw_files .file_name'), function (k,v) {
                currVal = $(this).val();
                $.inputHints('#rpw_files .file_name:eq('+k+')', 'Название файла:', false);
                $(this).val(currVal).focusout();
            });

            $.each($('#cl_files .file_name'), function (k,v) {
                currVal = $(this).val();
                $.inputHints('#cl_files .file_name:eq('+k+')', 'Название файла:', false);
                $(this).val(currVal).focusout();
            });

            $.each($('#penalty_scans .file_name'), function (k,v) {
                currVal = $(this).val();
                $.inputHints('#penalty_scans .file_name:eq('+k+')', 'Название файла:', false);
                $(this).val(currVal).focusout();
            });

            $.each($('#ap_documents .file_name'), function (k,v) {
                currVal = $(this).val();
                $.inputHints('#ap_documents .file_name:eq('+k+')', 'Название файла:', false);
                $(this).val(currVal).focusout();
            });
        }
    };
    $.genFilesList = function(value){
        var elmTmp = document.createElement('span'),
            filesList = '';
        elmTmp.innerHTML = value;
        $.each($(elmTmp).find('a'), function(k,v){
            $('#m_file_types option').removeAttr('selected');
            $('#m_file_types option[value="'+$(elmTmp).find('.file_type:eq('+k+')').text()+'"]').attr('selected', 'selected');
            filesList +=
                '<span class="attach-wrap marg-bot-5 display-block">'+
                    '<input class="attachment width-210" id="attachment_'+k+'" name="attachment_'+k+'" disabled="disabled" value="'+$(this).attr('href').split('/').slice(-1)[0]+'">'+
                    '&nbsp;<a href="javascript:void(0)" class="remove_file">удалить</a>'+
                    ($(elmTmp).find('.file_comment:eq('+k+')').length ?
                        '<div class="file_type" style="margin-top: 5px;">'+
                            '<select id="file_type_'+k+'" name="file_type_'+k+'" file-cnt="'+k+'">'+$('#m_file_types').html()+'</select>'+
                        '</div>'+
                        '<div class="file_comment" style="margin-top: 5px;">'+
                            '<textarea id="file_comment_'+k+'" file-cnt="'+k+'" name="file_comment_'+k+'">'+
                                $(elmTmp).find('.file_comment:eq('+k+')').text()+
                            '</textarea>'+
                        '</div>'+
                        '<hr>'
                    : '')+
                    ($(elmTmp).find('.file_name:eq('+k+')').length ?
                        '<br><input type="text" name="file_name_'+k+'" class="file_name file_name_'+k+' FormElement ui-widget-content ui-corner-all" style="margin-top: 5px;" value="'+$(elmTmp).find('.file_name:eq('+k+')').html()+'">' +
                        '<hr>'
                    : '') +
                '</span>';
        });

        return filesList;
    };
    // ************ END OF DATAGRID FILES ADD/EDIT/REMOVE METHODS ************ //
    $.expandShortened = function(elm, shrink)
    {
        var srcEl = $(elm).parent();
        var originalValue = srcEl.attr('originalvalue');


        if (shrink)
        {
            srcEl.replaceWith(truncateLongText(originalValue))
        }
        else
        {
            srcEl.html(originalValue);
            $('<small class="link-simple detail_link" onclick="$.expandShortened(this, true)">свернуть...</small>').appendTo(srcEl);
        }

    };

    $.subgridToolPanelPos = function(elID){
        if($("#"+elID+" .ui-pg-table.navtable").css('position') != 'absolute') {
            var offsetLeft = $("#gview_"+elID+"_t").offset().left,
                subgridWidth = $("#"+elID).width();
            $("#"+elID+"_t_p_left .navtable, #"+elID+"_t_toppager_left .navtable").removeAttr('style').css({position: 'absolute', left: 0, top: 0});
            $("#"+elID+"_t_p_center .ui-pg-table, #"+elID+"_t_toppager_center .ui-pg-table").removeAttr('style').css({position: 'absolute', left: (subgridWidth/2)-70, top: 0});
            $("#"+elID+"_t_p_right .ui-paging-info, #"+elID+"_t_toppager_right .ui-paging-info").removeAttr('style').css({position: 'absolute', left: subgridWidth-130, top: 0});
            $("#"+elID).scroll(function(){
                var currOffsetLeft = $("#gview_"+elID+"_t").offset().left;
                $("#"+elID+"_t_p_left .navtable").css({left: offsetLeft-currOffsetLeft});
                $("#"+elID+"_t_p_center .ui-pg-table").css({left: offsetLeft+(subgridWidth/2)-currOffsetLeft-70});
                $("#"+elID+"_t_p_right .ui-paging-info").css({left: offsetLeft+subgridWidth-currOffsetLeft-130});
                if($('#'+elID+'_t_toppager').css('position') != 'fixed') {
                    $("#"+elID+"_t_toppager_left .navtable").css({left: offsetLeft-currOffsetLeft});
                    $("#"+elID+"_t_toppager_center .ui-pg-table").css({left: offsetLeft+(subgridWidth/2)-currOffsetLeft-70});
                    $("#"+elID+"_t_toppager_right .ui-paging-info").css({left: offsetLeft+subgridWidth-currOffsetLeft-130});
                }
            });

            var relEl = $('#grid_toppager'),
                topPos = relEl.position().top +
                    relEl.height() +
                    parseInt(relEl.css('padding-top')) + parseInt(relEl.css('padding-bottom')) +
                    parseInt(relEl.css('margin-top')) + parseInt(relEl.css('margin-bottom')) +
                    parseInt(relEl.css('border-top-width')) + parseInt(relEl.css('border-bottom-width'));
            if(__pinGridHeader__){
                var headerEl = $('#work_panel_wrap.pin_true #gview_grid > .ui-jqgrid-hdiv'),
                    marginTop = parseInt(headerEl.css('border-bottom-width')) + parseInt(headerEl.css('border-top-width')) +
                                parseInt(headerEl.css('margin-top')) + parseInt(headerEl.css('margin-bottom'));
                topPos += marginTop+headerEl.height();
            }



            $('#work_panel')
                .scroll(function(){
                    var trgEl = $('#'+elID+'_t_toppager');
                    if(trgEl.length > 0){
                        var wrapEl = $('#gview_'+elID+'_t'),
                            wrapElNext = wrapEl.parents('tr.ui-subgrid:first').next(),
                            wrapElNextOffTop = wrapElNext.length > 0 ? wrapElNext.offset().top : $("#grid").height() + topPos;

                        if(wrapEl.offset().top > topPos || wrapElNextOffTop < topPos) {
                            trgEl.attr('style', 'width: '+trgEl.width()+'px');
                        } else if(trgEl.offset().top < topPos && wrapElNextOffTop-trgEl.height() > topPos) {
                            trgEl.css({position: 'fixed', 'z-index': 9, top: topPos});
                        }
                    }
                });
        }
    };

    $.wrapSubmit = function(selector){
        selector = typeof(selector) === 'undefined' ? "#work_panel" : selector;

        $(selector+" .submit").click(function(){
            $.each($(selector+" .field input.grey, "+selector+" .field textarea.grey"),function(){
                if(!$(this).prop('disabled') && !$(this).hasClass('myTreeView') && !$(this).hasClass('ignore-cleanup-567bc1d2'))
                    $(this).val("");
            });

            $(selector+" form").submit();
            if($(selector+' .add-election-offense-form').length > 0){
                if($('#offense_type_val').val() == ""){
                    $(selector+' .dd').css({"border-color": "red"});
                } else {
                    $(selector+' .dd').removeAttr('style');
                }
            }
            $.each($(selector+" .field input.grey, "+selector+" .field textarea.grey"),function(){
                if($(this).hasClass('myTreeView') && $(this).hasClass('required')){
                    $(this).removeClass('valid').addClass('error');

                    if(!$(this).parent().find('label').length)
                        $(this).parent().append('<label class="error" style="margin-left: -18px;" for="'+$(this).attr('id')+'" generated="true">Заполните это поле</label>');
                    else
                        $(this).parent().find('label').show();
                } else if(!$(this).prop('disabled'))
                    $(this).focusout();
            });
            $.each($(selector+' input.myTreeView'), function(){
                if((!$(this).hasClass('grey') && $(this).val() != '') || !$(this).hasClass('required'))
                    $(this).removeClass('error').addClass('valid');
                else if($(this).parents('form:first').hasClass('add-elections-form')){
                    $(this).parent().find('label.error').css({'position': 'absolute'});
                }
            });
            $("#ui-datepicker-div").hide();

            // goto first error field
            setTimeout(function(){
                $.each($(selector+" .field .error"), function(){
                    if($(this).prop('tagName').toLowerCase() != 'label') {
                        $(this).focus();
                        return false;
                    }
                });
            },10);
        });
    };

    $.number_format = function(number, decimals, dec_point, thousands_sep) {
        number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
        var n = !isFinite(+number) ? 0 : +number,
            prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
            sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
            dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
            s = '',
            toFixedFix = function (n, prec) {
                var k = Math.pow(10, prec);
                return '' + Math.round(n * k) / k;
            };
        // Fix for IE parseFloat(0.55).toFixed(0) = 0;
        s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
        if (s[0].length > 3) {
            s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
        }
        if ((s[1] || '').length < prec) {
            s[1] = s[1] || '';
            s[1] += new Array(prec - s[1].length + 1).join('0');
        }
        return s.join(dec);
    };

    $.widget( "ui.combobox", {
        _create: function() {
            var input,
                that = this,
                select = this.element.hide(),
                selected = select.children( ":selected" ),
                value = selected.val() ? selected.text() : "",
                wrapper = this.wrapper = $( "<span>" )
                    .addClass( "ui-combobox" )
                    .insertBefore( select );

            function removeIfInvalid(element) {
                var value = $( element ).val(),
                    matcher = new RegExp( "^" + $.ui.autocomplete.escapeRegex( value ) + "$", "i" ),
                    valid = false;
                select.children( "option" ).each(function() {
                    if ( $( this ).text().match( matcher ) ) {
                        this.selected = valid = true;
                        return false;
                    }
                });
                if ( !valid ) {
                    // remove invalid value, as it didn't match anything
                    /*$( element )
                     .val( "" )
                     .attr( "title", value + " didn't match any item" );
                     .tooltip( "open" );*/
                    select.val( "" );
                    /*setTimeout(function() {
                     input.tooltip( "close" ).attr( "title", "" );
                     }, 2500 );
                     input.data( "autocomplete" ).term = "";
                     return false;*/
                }
            }

            input = $( "<input>" )
                .appendTo( wrapper )
                .val( value )
                .attr( "title", "" )
                .addClass( "ui-state-default ui-combobox-input" )
                .autocomplete({
                    delay: 0,
                    minLength: 0,
                    appendTo: $(wrapper),
                    source: function( request, response ) {
                        var matcher = new RegExp( $.ui.autocomplete.escapeRegex(request.term), "i" );
                        response( select.children( "option" ).map(function() {
                            var text = $( this ).text();
                            if ( this.value && ( !request.term || matcher.test(text) ) )
                                return {
                                    label: text,
                                    value: text,
                                    option: this
                                };
                        }) );
                    },
                    select: function( event, ui ) {
                        ui.item.option.selected = true;

                        that._trigger( "selected", event, {
                            item: ui.item.option
                        });
                    },
                    change: function( event, ui ) {
                        if ( !ui.item )
                            return removeIfInvalid( this );
                    },
                    close: function( event, ui ){
                        $(this).parent().find('.ui-autocomplete.ui-menu').html('');
                    }
                })
                .addClass( "ui-widget ui-widget-content ui-corner-left" );

            input.data( "autocomplete" )._renderItem = function( ul, item ) {
                return $( "<li>" )
                    .data( "item.autocomplete", item )
                    .append( "<a>" + item.label + "</a>" )
                    .appendTo( ul );
            };

            $( "<a>" )
                .attr( "tabIndex", -1 )
                .attr( "title", "Показать все элементы" )
//                .tooltip()
                .removeClass("ui-corner-all")
                .addClass("ui-corner-right ui-combobox-toggle")
                .appendTo($(wrapper))
                .button({
                    icons: {
                        primary: "ui-icon-triangle-1-s"
                    },
                    text: false
                })
                .click(function() {
//                    close if already visible
                    if ( input.autocomplete( "widget" ).is( ":visible" ) ) {
                        input.autocomplete( "close" );
                        removeIfInvalid( input );
                        return;
                    }

                    // work around a bug (likely same cause as #5265)
                    $( this ).blur();

                    // pass empty string as value to search for, displaying all results
                    input.autocomplete( "search", "" );
                    input.focus();
                });

            /*input
             .tooltip({
             position: {
             of: this.button
             },
             tooltipClass: "ui-state-highlight"
             });*/
        },

        destroy: function() {
            this.wrapper.remove();
            this.element.show();
            $.Widget.prototype.destroy.call( this );
        }
    });

    $.setFilters = function () {
        var helpMessages = function (n) {
            var text = '';
            var elem = '#filtershelp';
            var name = "";
            switch (n) {
                case 1:
                    text = 'Для того чтобы создать предустановку фильтров, необходимо</br>' +
                        'выставить настройки отображения записей в таблице "Персоналии".</br>';
                    break;
                case 2:
                    text = 'В основной таблице фильтров не найдено';
                    break;
                case 3:
                    if ('filters' in $('#grid').getGridParam('postData')) {
                        var json = JSON.parse($('#grid').getGridParam('postData').filters);
                        var fieldName;
                        for (var i in json.rules) {
                            fieldName = $('#jqgh_grid_' + json.rules[i].field).text().trim();
                            text = text + fieldName + ' => ' + json.rules[i].data + '<br>';
                            name = name + fieldName + ',';
                        }
                    }
                    if ($('#grid').getGridParam('postData').memberBDay != "%-%-%") {
                        name = name + "Дата рождения; ";
                        text = text + "Дата рождения => " + $('#grid').getGridParam('postData').memberBDay;
                    }
                    text = text || 'В основной таблице фильтров не найдено';
                    name = name || 'пустой фильтр ' + parseInt(Math.random() * (1000 - 1) + 1);
            }
            $(elem).html(text);
            return name;
        };
        var doSaveFilter = function () {
            var filGridArr = $('#filtersgrid').jqGrid('getRowData');
            var filterName = ($('#filtersgrid').jqGrid('getRowData')[0]['name']).trim(); //edit name
            var filters = $('#grid').getGridParam('postData').filters || false;
            var addDateToJSON = function (json) {
                var json = JSON.parse(json);
                json.memberBDay = $('#grid').getGridParam('postData').memberBDay;
                json = JSON.stringify(json);
                return json;
            };

            var memberBDay = $('#grid').getGridParam('postData').memberBDay;
            if (memberBDay != "%-%-%") {
                if (filters) {
                    filters = addDateToJSON(filters);
                }
                else {
                    filters = '{"groupOp":"AND","rules":[]}';
                    filters = addDateToJSON(filters);
                }
            }
            showAjaxLoading();
            $.ajax({
                type: 'POST',
                url: 'php/getData.php',
                data: {
                    'qryType': 'saveFilter',
                    'filterName': filterName,
                    'filters': filters,
                    'filtertype': $('#filtersgrid').jqGrid('getRowData')[0]['type'] == 'Персональный' ? 0 : 1,
                    'url': $('#grid').jqGrid('getGridParam', 'url').split('php/')[1]
                },
                dataType: 'json',
                success: function (tr) {
                    if (checkSession(tr)) {
                        destroyDialogF();
                        hideAjaxLoading();
                    }
                }
            });
        };
        var getFilterNandT = function () {
            var getCurrFilName = $('#filtersgrid').jqGrid('getCell', $('#filtersgrid').jqGrid('getGridParam', 'selrow'), 'name'),
                getCurrFilType = ($('#filtersgrid').jqGrid('getCell', $('#filtersgrid').jqGrid('getGridParam', 'selrow'), 'type'));
            if (getCurrFilType.length < 12) getCurrFilType = 1;
            return [getCurrFilName, getCurrFilType];
        };
        var destroyDialogF = function () {
            $('#filtersgrid').jqGrid('GridDestroy').remove();
            $('#presetdialog').dialog('destroy').remove();
        };
        var table = $('#grid').jqGrid('getGridParam', 'url').split('php/')[1];

        showAjaxLoading();
        $.ajax({
            type: 'POST',
            url: 'php/getData.php',
            data: {'qryType': 'getFilters', 'url': table},
            dataType: 'json',
            success: function (tr) {
                hideAjaxLoading();

                if (checkSession(tr)) {
                    $('#filtersgrid').jqGrid({
                        datatype: "local",
                        data: tr['data'],
                        loadonce: true,
                        gridview: true,
                        shrinkToFit: false,
                        editurl: tr['data'],
                        multiselect: false,
                        altRows: true,
                        altclass: 'gridRowAlt',
                        height: 250,
                        pager: '#filtersgridpager',
                        rowList: [],
                        idPrefix: 'fil_',
                        pgbuttons: false,
                        pgtext: null,
                        viewrecords: false,
                        emptyrecords: "Nothing to display",
                        colNames: ['   ', ' название фильтра ', ' тип фильтра '],
                        colModel: [
                            {   name: 'id',
                                index: 'id',
                                width: 50,
                                sorttype: "int"
                            },
                            {
                                name: 'name',
                                index: 'name',
                                width: 450,
                                edittype: 'text',
                                editable: true
                            },
                            {
                                name: 'type',
                                index: 'type',
                                editable: (__userRole__ == 'sys-admin' ? true : false),
                                edittype: 'select',
                                formatoptions: {disabled: false},
                                editoptions: {value: "0:Персональный;1:Глобальный"},
                                width: 150
                            }
                        ]
                    });
                    if (tr['data'].length == 0) {
                        helpMessages(1);
                    }
                    $("#filtersgrid").jqGrid('navGrid', "#filtersgridpager", {edit: false, add: false, del: false, search: false, refresh: false })
                        .navButtonAdd('#filtersgridpager', {
                            title: "Добавить фильтр таблицы",
                            caption: 'Добавить',
                            buttonicon: "ui-icon ui-icon-plus",
                            onClickButton: function () {
                                if (!($('#grid').getGridParam('postData').filters || false)) {
                                    helpMessages(2);
                                }

                                if (typeof($('#grid').getGridParam('postData').filters) != 1) {
                                    $('#filtersgrid').jqGrid('addRow', {
                                        rowId: 'new',
                                        initdata: {
                                            'id': 0,
                                            'name': helpMessages(3),
                                            'type': 'Персональный'
                                        },
                                        useDefValues: true,
                                        useFormatter: false,
                                        addRowParams: {
                                            'keys': true,
                                            'url': 'clientArray',
                                            'oneditfunc': function () {
                                                $("#presetdialog .filter_menu").hide();
                                                $("#presetdialog .save_menu .ui-pg-button").show();
                                            },
                                            'aftersavefunc': doSaveFilter
                                        }
                                    });
                                }
                            },
                            position: "first"
                        })
                        .navButtonAdd('#filtersgridpager', {
                            title: "Загрузить выбранный фильтр",
                            caption: 'Применить',
                            buttonicon: "ui-icon ui-icon-check",
                            onClickButton: function () {
                                if ($('#filtersgrid').jqGrid('getGridParam', 'selrow') != null) {
                                    var table = $('#grid').jqGrid('getGridParam', 'url').split('php/')[1],
                                        filterNandT = getFilterNandT();
                                    showAjaxLoading();
                                    $.ajax({
                                        type: 'POST',
                                        url: 'php/getData.php',
                                        data: {
                                            'qryType': 'applyFilter',
                                            'u_id': __userId__,
                                            'filterName': filterNandT[0],
                                            'filtertype': filterNandT[1],
                                            'url': table
                                        },
                                        dataType: 'json',
                                        success: function (tr) {
                                            hideAjaxLoading();

                                            if (checkSession(tr)) {
                                                var filtersvalue = $.parseJSON(tr['data']);
                                                if (filtersvalue) {
                                                    $('#gview_grid .ui-search-toolbar .ui-search-input').find('input, select').val('');
                                                    filtersvalue.memberBDay = filtersvalue.memberBDay || "%-%-%";
                                                    $('#grid').getGridParam('postData').memberBDay = filtersvalue.memberBDay;
                                                    if (filtersvalue.memberBDay != "%-%-%") {
                                                        var dateArray = filtersvalue.memberBDay.split('-');
                                                        $.map(['yy', 'mm', 'dd'], function (field, iter) {
                                                            $('select#gs_m_bday_' + field).val(dateArray[iter]);
                                                        });
                                                    }
                                                    delete filtersvalue.memberBDay;
                                                    if (filtersvalue) {
                                                        for (var i = 0; i < filtersvalue['rules'].length; i++) {
                                                            $('#gs_' + filtersvalue['rules'][i]['field']).val(filtersvalue['rules'][i]['data']);
                                                        }
                                                        $("#grid").jqGrid('setGridParam', { search: true, postData: { "filters": tr['data']} }).trigger("reloadGrid");
                                                    }
                                                    else {
                                                        $("#grid").jqGrid('setGridParam', { search: false, postData: { "filters": []} }).trigger("reloadGrid");
                                                    }
                                                }
                                                destroyDialogF();
                                            }
                                        }
                                    });
                                }
                            },
                            position: "last"
                        })
                        .navButtonAdd('#filtersgridpager', {
                            title: "Удалить выбранный фильтр",
                            caption: 'Удалить',
                            buttonicon: "ui-icon ui-icon-trash",
                            onClickButton: function () {
                                if ($('#filtersgrid').jqGrid('getGridParam', 'selrow') != null) {
                                    var table = $('#grid').jqGrid('getGridParam', 'url').split('php/')[1];
                                    var filterNandT = getFilterNandT();
                                    if (__userRole__ != 'sys-admin' && filterNandT[1] == 1) return;

                                    showAjaxLoading();
                                    $.ajax({
                                        type: 'POST',
                                        url: 'php/getData.php',
                                        data: {
                                            'qryType': 'deleteFilter',
                                            'filterName': filterNandT[0],
                                            'filterType': filterNandT[1],
                                            'url': table
                                        },
                                        dataType: 'json',
                                        success: function (tr) {
                                            if (checkSession(tr)) {
                                                hideAjaxLoading();

                                                if (tr['data']) {
                                                    $('#filtersgrid').jqGrid('delRowData', $('#filtersgrid').jqGrid('getGridParam', 'selrow'));
                                                }
                                                if ($('#filtersgrid').jqGrid('getRowData').length == 0) {
                                                    helpMessages(1);
                                                }
                                            }
                                        }
                                    });
                                }
                            },
                            position: "last"
                        })
                        .navButtonAdd('#filtersgridpager', {
                            title: "Убрать фильтры",
                            caption: 'По умолчанию',
                            buttonicon: "ui-icon ui-icon-refresh",
                            onClickButton: function () {
                                $('#gview_grid .ui-search-toolbar .ui-search-input').find('input, select').val('');
                                destroyDialogF();
                                $("#grid").jqGrid('setGridParam', { search: false, postData: { "filters": []} }).trigger("reloadGrid");
                            },
                            position: "last"
                        })
                        .navButtonAdd('#filtersgridpager', {
                            title: "Сохранить",
                            caption: 'Сохранить',
                            buttonicon: "ui-icon ui-icon-disk",
                            onClickButton: function () {

                                var rowid = $('#filtersgrid').jqGrid('getDataIDs')[0];
                                $('#filtersgrid').jqGrid('saveRow', rowid, {'url': 'clientArray', 'aftersavefunc': doSaveFilter});

                                destroyDialogF();
                            },
                            position: "center"

                        })
                        .navButtonAdd('#filtersgridpager', {
                            title: "Отмена",
                            caption: 'Отменить',
                            buttonicon: "ui-icon ui-icon-arrowreturnthick-1-s",
                            onClickButton: function () {
                                var rowid = $('#filtersgrid').jqGrid('getDataIDs')[0];
                                $("#filtersgrid").restoreRow(rowid);
                                $("#presetdialog .filter_menu").show();
                                $("#presetdialog .save_menu .ui-pg-button").hide();
                            },
                            position: "center"

                        });
                    $('#filtersgridpager_center').remove();
                    $('#filtersgridpager_right').remove();
                    $("#presetdialog .ui-pg-button").slice(-2).wrapAll('<div class="save_menu"></div>').hide();
                    $("#presetdialog .ui-pg-button").slice(0, 4).wrapAll('<div class="filter_menu"></div>');
                }
            }
        });

        $('#main_menu').after('<div id ="presetdialog" title="Предустановки фильтров"><table id="filtersgrid"><div id="filtersgridpager"></div></table><div id="filtershelp"></div></div></div>');

        $('#presetdialog').dialog({
            resizable: false,
            height: 'auto',
            width: 700,
            modal: true,
            beforeClose: function () {
                $('#filtersgrid').jqGrid('GridDestroy').remove();
                $(this).dialog('destroy').remove();
            },
            open: function () {
                $('#filtersgridpager_center').remove();
                $('#filtersgridpager_right').remove();
            }
        });
    };

    $.fn.forceNameInput = function (val, col) {
        var regexp = /^[а-яёА-ЯЁ()\-\s]+$/;
        if (regexp.test(val.trim())) {
            return [true, ''];
        } else {
            return [false, col + ': допускаются только русские буквы, тире, пробелы и круглые скобки'];
        }
    };

    $.setEditTabs = function (form, prefix) {
        var formid = '#' + $(form).attr('id');

        if ($(formid + ' tbody:first').hasClass('editFormTabs')) {
            $.ShowReqFields();
            return;
        }

        var editTabs = $('#grid').getGridParam('editTabs');
        var cols_tabs = {};
        var elem_input = '',
            elem_label = '';

        $(formid + ' tbody:first').addClass('editFormTabs');

        for(var tab in editTabs) {
            const hide_tab_fa_suitcase = tab === 'fa-suitcase' ? 'style="display:none;"' : '';
            elem_input += `<input type="radio" id="${tab}" name="checkers"/>`;
            elem_label +=
                `<label for="${tab}" ${hide_tab_fa_suitcase} >` +
                    `<i class="fa ${tab}"></i> ` +
                    editTabs[tab].title +
                    `<i class="fa ${tab} ui-icon ui-icon-locked" style="display:none;"></i>` +
                `</label>` +
                `<hr ${hide_tab_fa_suitcase} >`;

            for(var col of editTabs[tab].columns) {
                $('#' + prefix + col).addClass('pole_' + tab);
                cols_tabs[col] = tab;
            }
        }
        elem_label = '<span id="tabslabels">' + elem_label + '</span>';

        $('#grid').setGridParam({cols_tabs});
        $(formid + ' tbody:first').prepend(elem_input);
        $(form).before(elem_label);

        $('.editFormTabs > input').on('click', function (e) {
            $('#tabslabels .selected').removeClass('selected');
            $('#tabslabels i.' + e.target.id).parent().addClass('selected');
            $('.editFormTabs .selected').removeClass('selected');
            $('.editFormTabs .pole_' + e.target.id).addClass('selected');
            $.hardcodeForMembershipSuspended(e.target.id);
            $.hardcodeForPartyEntryProtocolNoNumber(e.target.id);
            $.hardCodeForDistrictDG(e.target.id);
        });

        $('.editFormTabs input:first').click();
        $.gotoValidationErrorFieldInEditTabs();
        $.ShowReqFields();
    };

    $.hardcodeForMembershipSuspended = (currentTab) => {
        currentTab = currentTab || $(".editFormTabs > input:checked").attr("id");
        if ($('#m_membership_suspended').prop('checked')) {
            if (currentTab === 'fa-ticket') {
                $('#tr_m_membership_suspended_date, #tr_m_membership_suspended_supporter').addClass('selected').removeClass('hidden');
            }
            else {
                $('#tr_m_membership_suspended_date, #tr_m_membership_suspended_supporter').addClass('hidden');
            }
        }
        else {
            $('#tr_m_membership_suspended_date, #tr_m_membership_suspended_supporter').removeClass('selected').addClass('hidden');
        }
    };

    $.hardcodeForPartyEntryProtocolNoNumber = (currentTab) => {
        currentTab = currentTab || $(".editFormTabs > input:checked").attr("id");
        if (currentTab === 'fa-ticket') {
            $('#tr_m_party_entry_protocol_no_number').addClass('selected').removeClass('hidden');
        }
        else {
            $('#tr_m_party_entry_protocol_no_number').addClass('hidden');
        }
    };

    $.hardCodeForDistrictDG = (tab) => {
        const currentTab = tab || $(".editFormTabs > input:checked").attr("id"),
            $tr_m_subject_districts_gd = $('#tr_m_subject_districts_gd'),
            $tr_m_districts_gd = $('#tr_m_districts_gd');

        if (currentTab === 'fa-plus-square-o' && $('#m_responsible_for_objects_of_national_projects').prop('checked')) {
            $tr_m_subject_districts_gd.addClass('selected').css('display', 'block');
            $tr_m_districts_gd.addClass('selected').css('display', 'block');
        }
        else {
            $tr_m_subject_districts_gd.removeClass('selected').css('display', 'none');
            $tr_m_districts_gd.removeClass('selected').css('display', 'none');
        }
    };

    $.gotoValidationErrorFieldInEditTabs = function() {
        $('#FormError').append('<div class=\"to_possible_error\"><a>..к возможной ошибке</a></div>');
        $('#FormError td').addClass('forShowErrorTabs');

        $('#FormError a').click(() => {
            $('.FillThisField').removeClass('FillThisField');

            var fields = [];
            var text = $('#FormError td').text().split(':')[0];
            if (!text) return true;

            $.each($('#editmodgrid .FormData'), function () {
                if ($(this).find('.CaptionTD').text() === text) {
                    fields.push($(this).find('.FormElement').attr('id'));
                }
            });
            fields.map(function(name){
                $('#tr_' + name + ' .CaptionTD').addClass('FillThisField');
                $('#tabslabels label[for=\"' + $('#grid').getGridParam('cols_tabs')[name] + '\"]').addClass('FillThisField');
            });

            var err_fld = $('#tr_'+ fields[0]);
            if (!err_fld.length) return true;

            var match = err_fld.attr('class').match(/pole_(.*?)\b/);
            if(match && match.length && match[1]) {
                $('.editFormTabs > input#' + match[1]).click();
            }
        })
    };

    $.ShowReqFields = function(){
        $('.FillThisField').removeClass('FillThisField');

        if( $('#m_party_memb').prop('checked')){
            //m_passport_num,m_personal_photo,m_phone_mobile,m_personal_education, m_personal_labor_activity
            var labels = $('#grid').getGridParam('cols_tabs');
            var fields = ['m_passport_series', 'm_passport_num', 'm_passport_issue', 'm_passport_date', 'm_entry_date', 'm_phone_mobile'].filter(function(name){
                return $('#' + name).val() == '';
            });

            if (!$('#m_party_card_number').val() && !$('#m_party_card_is_making').prop('checked')) {
                fields.push('m_party_card_number');
            }
            if (!$('#m_party_entry_protocol').val() && !$('#m_party_entry_protocol_no_number').prop('checked')) {
                fields.push('m_party_entry_protocol');
            }
            if($('#m_personal_photo img').attr('title') == 'нет фото'){
                fields.push('m_personal_photo');
            }
            if(($('#m_personal_labor_activity input').val() == 'Должность и место работы' || $('#m_personal_labor_activity input').val() == '') && $('#m_personal_labor_activity .mpla_pos_n_place').length == 0){
                fields.push('m_personal_labor_activity');
            }
            if(($('#m_personal_education input').val() == 'Учебное заведение' || $('#m_personal_education input').val() == '') && $('#m_personal_education .mpe_institution').length == 0){
                fields.push('m_personal_education');
            }
            fields.map(function(name){
                $('#tr_' + name + ' .CaptionTD').addClass('FillThisField');
                $('#tabslabels label[for="' + labels[name] + '"]').addClass('FillThisField');
            });
        }
    };

    $.ExportRegister = function() {
        if($("#grid").jqGrid("getCol", "mo_id").length){
            var filters = $('#grid').getGridParam('postData').filters || null;
            showAjaxLoading();
            $.ajax({
                type:"POST",
                url:'../php/form.VITAE_register.php',
                data:{'filters':filters},
                dataType:"json",
                success:function (tr) {
                    if (checkSession(tr)) {
                        hideAjaxLoading();
                        window.location = '../php/form.VITAE_register.php';
                    }
                }
            });
        }
    };
    $.ExportPVG = function() {
        $.getScript(dirUp+'js/jquery.dd.js', function(){
            var select_list = ['pvg_r_id', 'pvg_elect_level', 'pvg_elect_dep_or_post', 'pvg_elect_pvg_model'];
            var input_list = ['pvg_elect_assignment_date', 'pvg_elect_date', 'pvg_elect_pvg_rps_decision_date', 'pvg_elect_pvgh_result_protocol_date',
                'pvg_elect_pvgh_conference_date', 'pvg_elect_pvgh_electroal_program_date', 'pvg_elect_pvg_docum_submission_date',
                'pvg_elect_pvg_cand_nomination_end_date', 'pvg_elect_er_proport_reg_date'];

            $('<div id="PVG_excel_export">')
                .html($("#PVG_excel_export_tmpl").html().replace(/\{TMPL\}/g,''))
                .dialog({
                    autoOpen: true,
                    title: 'ПГ экспорт',
                    modal: true,
                    resizable: false,
                    zIndex : 99,
                    width: 650,
                    position: ['middle', 50],
                    height: 900,
                    close: function(ev, ui) { $('#PVG_excel_export').parent().remove(); $('#PVG_excel_export').remove(); },
                    open: function(ev, ui){
                        $('.ui-datepicker-close').click();
                        $('#PVG_button_export').css('float','right');
                    },
                    buttons: {
                        "Отмена" : {
                            text: "Отмена",
                            click: function(){
                                $('#PVG_excel_export').dialog('close');
                            }
                        },
                        'Экспорт' : {
                            text: "Экспорт в excel",
                            id: 'PVG_button_export',
                            click: function(){
                                //get filters
                                var filters = {};
                                filters.select = {};
                                ['pvg_d_id'].concat(select_list).map(function(name){
                                    filters.select[name]=[];
                                    $('#'+name+'_child li.selected').find('input').filter(function(){return this.value !=''}).map(function(){
                                        filters.select[name].push($(this).val());
                                    });
                                });
                                filters.input={};
                                $('#PVG_excel_export_time input').map(function(){
                                    var id = this.id;
                                    id = id.replace(/(_to)?(_from)?$/,'');
                                    if (id in filters.input && id != ''){
                                        filters.input[id]['to'] = $(this).val();
                                    } else {
                                        filters.input[id]={
                                            from : $(this).val()
                                        }
                                    }
                                });

                                showAjaxLoading();
                                $.ajax({
                                    type:"POST",
                                    url:'../php/form.PVG_export.php',
                                    data:{filters: JSON.stringify(filters)},
                                    dataType:"json",
                                    success:function (tr) {
                                        if (checkSession(tr)) {
                                            hideAjaxLoading();
                                            $('#PVG_excel_export').dialog('close');
                                            window.location = '../php/form.PVG_export.php';
                                        }
                                    }
                                }
                            );

                        }
                    }
                },
                create: function(ev, ui){
                    var el,i;
                    var datePickerOpt = {
                            dateFormat:'dd.mm.yy',
                            changeMonth:true,
                            changeYear:true,
                            yearRange: '-10',
                            showButtonPanel:true
                        };
                    input_list.map(function(name){
                        $('#' + name +'_from' ).datepicker(datePickerOpt).change(function(){
                            $('#' + name +'_to').datepicker( "option", "minDate", $(this).val() );
                        });
                        $('#' + name +'_to' ).datepicker(datePickerOpt).change(function(){
                            $('#' + name +'_from').datepicker( "option", "maxDate", $(this).val() );
                        });
                    });

                    $.ajax({
                        type:"POST",
                        url:'../php/getData.php',
                        data:{'qryType':'pvg_export_filters','getSelectors':true},
                        dataType:"json",
                        success:function (tr) {
                            if(checkSession(tr)){
                                var protoDD = {};
                                var el = '';
                                tr = tr['data'];
                                $('#PVG_excel_export select').removeClass('hidden');
                                select_list.concat(['pvg_d_id']).map(function(name){
                                    var el='';
                                    tr[name].map(function(val){
                                        el += '<option value="'+ val['id'] +'">' + val['name'] + '</option>';
                                    });
                                    $('#' + name).append(el);
                                });

                                select_list.map(function(name){
                                    protoDD[name] = $('#' + name ).msDropDown({childWidth:"400px", enableCheckbox:true, animStyle: '', on:{
                                        close: function(){
                                            if(protoDD[name].selectedOptions.length > 0){
                                                //$('#' + name + '_msdd .ddlabel:first').text('нажмите для выборки');
                                            } else{
                                                $('#' + name + '_msdd .ddlabel:first').text('нажмите для выборки');
                                            }
                                        }
                                    }}).data('dd');
                                    $('#' + name + '_child input:first').prop('checked',false);
                                    $('#' + name + '_msdd .ddlabel:first').text('нажмите для выборки');
                                });

                                $('#pvg_d_id').msDropDown({childWidth:"400px", enableCheckbox:true, animStyle: '', on:{
                                    close: function(){
                                        var filters =[];
                                        $('#pvg_d_id_child li.selected')
                                            .find('input')
                                            .filter(function(){return this.value !=''})
                                            .map(function(){ filters.push( this.value) ;
                                        });
                                        $.ajax({
                                            type:'POST',
                                            url:'../php/getData.php',
                                            data:{
                                                qryType:'pvg_export_filters',
                                                filters: JSON.stringify(filters)
                                            },
                                            dataType:'json',
                                            success: function(tr){
                                                protoDD['pvg_r_id'].destory();
                                                tr = tr['data']['pvg_r_id'];
                                                var el = '';
                                                for(var i=0, len = tr.length; i<len; i++){
                                                    el = el + '<option value="'+ tr[i]['id'] +'">' + tr[i]['name'] + '</option>';
                                                }
                                                $('#PVG_excel_export #pvg_r_id').html('').append(el);
                                                protoDD['pvg_r_id'] = $('#pvg_r_id').msDropDown({childWidth:"400px", enableCheckbox:true, animStyle: ''}).data('dd');
                                                $('#pvg_r_id_child input:first').prop('checked',false);

                                                protoDD['pvg_r_id'].set("selectedIndex", -1);
                                                $('#pvg_r_id_msdd .ddlabel:first').text('нажмите для выборки');
                                                $('#pvg_r_id_child li.selected').removeClass('selected')
                                            }
                                        });
                                    }
                                }}).data('dd');
                                $('#pvg_d_id_child input:first').prop('checked',false);
                                $('#pvg_d_id_msdd .ddlabel:first').text('нажмите для выборки');
                                $('#PVG_excel_export li.selected').removeClass('selected');
                            }
                        }
                    });
                }
            });
        });
    };

    $.mobilizationExport = function() {
        var userdata = $("#grid").jqGrid('getGridParam', 'userData'),
            postdata = $("#grid").jqGrid('getGridParam', 'postData');

        var data = {
            qryType:     'mobilizationExport',
            gridType:    userdata.grid_type,
            customRules: userdata.custom_rules,
        }
        if (postdata.filters) data.filters = postdata.filters

        var count = $("#grid").jqGrid('getGridParam', 'records');
        var dialog = $('<div></div>')
            .html('<div style="margin-top: 15px">Вы действительно хотите экспортировать ' + count + ' человек?</div><div style="color: red; margin-top: 10px;" id="export-results"></div>')
            .dialog({
                autoOpen: false,
                title: 'Экспорт активистов',
                modal: true,
                resizable: false,
                zIndex : 3001,
                height: 'auto',
                width: 'auto',
                close: function(ev, ui) {
                    $(this).dialog('destroy');
                    $(this).remove();
                },
                buttons: [
                    {
                        'text': "Экспортировать",
                        'class': "submit button",
                        click: function(){
                            var t = this
                            showAjaxLoading()
                            $.ajax({
                                type: "POST",
                                url: "php/getData.php",
                                dataType: 'json',
                                data: data,
                                success: function (tr) {
                                    if (checkSession(tr)) {
                                        hideAjaxLoading()
                                        $(t).parent().find('#export-results').html(tr.data)
                                        $(t).parent().find('button.submit').hide()
                                    }
                                }
                            });
                        }
                    },{
                        text: "Закрыть",
                        class: "button",
                        click: function() {
                            $(this).dialog("close");
                        }
                    }]
            });
        dialog.dialog('open');
    };

    $.fn.forcePhoneRandomInput = function (event){
        var t = $(this).val().match(/\d+/g) || '';
        if(t){
            t=t.join('');
            var out = '';
            var len = t.length;
            if(len > 4 && len < 7){
                t = t.replace(/(\d{1,2})(\d{2})(\d{2})/, "$1-$2-$3");
            }
            if(len == 7 ){
                t = t.replace(/(\d{3})(\d{2})(\d{2})/, "$1-$2-$3");
            }
            if(len > 7  && len < 11){
                t = t.replace(/(\d{3})(\d{1,3})(\d{2})(\d{2})/, "($1)$2-$3-$4");
            }
            if(len == 11 || len > 11){
                t = t.replace(/(\d{3,5})(\d{3})(\d{2,3})(\d{2,3})/, "($1)$2-$3-$4");
            }
        } else {
            $(this).val('');
            return;
        }
        $(this).val(t);
    };
    $.fn.forcePhoneMobileInput = function (event){
        var t = $(this).val().match(/\d+/g) || '';
        if(t){
            t=t.join('');
            var out = '';
            var len = t.length;
            if(len < 7){
                t = t.replace(/(\d{3,4})(\d{3})/, "($1)$2");
            }
            if(len == 7){
                t = t.replace(/(\d{3})(\d{1,2})(\d{1,2})/, "($1)$2-$3");
            }
            if(len > 7  && len < 11){
                t = t.replace(/(\d{3})(\d{3})(\d{2,4})/, "($1)$2-$3");
            }
            if(len == 11 || len > 11){
                t = t.slice(0,11).replace(/(\d)(\d{3})(\d{3})(\d{2})(\d{1,2})/, "+$1($2)$3-$4-$5");
            }
        } else {
            $(this).val('');
            return;
        }
        $(this).val(t);
    };
    $.fn.passportNumCheck = function (val,colname){
        var checkLen = colname == 'Серия паспорта' ? 4 : 6;
        var valLen = val.length;
        if (valLen == 0 || valLen == checkLen && /^\d+$/.test(val)) {
            return [true, ''];
        } else {
            return [false, colname + ': поле должно содержать ' + (checkLen == 4 ? ' 4 цифры' : ' 6 цифр')];
        }
    };
    $.fn.passportDateValid = function(val, colname){
        var out = [true];

        if(val.length > 0) {
            var re = /^([1-9]|0[1-9]|1[0-9]|2[0-9]|3[0-1])\.([1-9]|0[1-9]|1[0-2])\.(1[9][0-9][0-9]|2[0][0-9][0-9])(\s[\d]{1,2}:[\d]{1,2})?$/;
            if (re.test(val)) {
                var getAge = function () {
                    var y, m, d, today;

                    if($('#mem_bday').length)
                        today = new Date($('#mem_bday').attr('data-current-time'));
                    else{
                        $.ajax({
                            type: "POST",
                            url: "php/getData.php",
                            dataType: 'json',
                            async: false,
                            data: {qryType: 'currDate'},
                            success: function (tr) {
                                today = new Date(tr.data);
                            }
                        });
                    }

                    y = today.getFullYear() - m_bday.getFullYear();
                    m = today.getMonth() - m_bday.getMonth();
                    d = today.getDate() - m_bday.getDate();

                    if (m < 0 || m === 0 && d < 0) {
                        y--;
                    }

                    if (d < 0) {
                        m--;
                        d += 33 - new Date(today.getFullYear(), today.getMonth() - 1, 33).getDate();
                    }

                    if (m < 0) {
                        m += 12;
                    }

                    return [y, m, d];
                };

                var check_passport_date = function (minAge){
                    var minDate = m_bday.setFullYear(m_bday.getFullYear() + minAge);

                    if (minDate > val.valueOf()){
                        minDate = new Date(minDate);
                        return [ false, ( minDate.getDate() > 9 ? minDate.getDate() : '0' + minDate.getDate() ) + '.' + ( minDate.getMonth() + 1 > 9 ? minDate.getMonth() + 1 : '0' + (minDate.getMonth() + 1) ) + '.' + minDate.getFullYear()];
                    } else {
                        return [ true ];
                    }
                };

                var m_bday;
                if($('#mem_bday').length)
                    m_bday = new Date($('#mem_bday').val().split('.').reverse().join('/'));
                else
                    m_bday = new Date($('#m_bday').val().split('.').reverse().join('/'));

                var memberAge = getAge(); // массив. 0-ой элемент - количество лет, 1ый - количество месяцев, 2ой - дней. Дается 1 месяц на замену паспорта при достижении 20 или 45 лет
                var check_res = {};
                var curVal = val;
                if(colname == 'Дата рождения'){
                    if(memberAge[0] < 16){
                        out = [ false, colname + ': Текущий возраст - ' + get_correct_str(memberAge[0], 'год', 'года', 'лет') + ' ' + get_correct_str(memberAge[1], 'месяц', 'месяца', 'месяцев') + ' ' + get_correct_str(memberAge[2], 'день', 'дня', 'дней') + '. Возраст не может быть менее 16 лет' ];
                    } else if( memberAge[0] === 100 && (memberAge[1] > 0 || memberAge[2] > 0) || memberAge[0] > 100 ){
                        out = [ false, colname + ': Текущий возраст - ' + get_correct_str(memberAge[0], 'год', 'года', 'лет') + ' ' + get_correct_str(memberAge[1], 'месяц', 'месяца', 'месяцев') + ' ' + get_correct_str(memberAge[2], 'день', 'дня', 'дней') + '. Введите корректную дату' ];
                    } else {
                        out = [ true ];
                    }
                }else {
                    if(
                        !$('#mem_bday').length && (
                            colname == 'Дата вступления' && !$('#m_party_memb').prop('checked') ||
                            colname == 'Дата зачисления в сторонники' && !$('#m_party_supporter').prop('checked')
                        )
                    ){
                        curVal = '';
                    }
                    val = new Date(curVal.split('.').reverse().join('/'));

                    if (colname == 'Дата вступления' && ($('#m_party_memb').prop('checked') || $('#membership_vis').prop('checked') )){
                        check_res[0] = 18;
                    }else if(colname == 'Дата зачисления в сторонники' && ($('#m_party_supporter').prop('checked') || $('#party_supporter').prop('checked'))){
                        check_res[0] = 16;
                    } else {
                        if (memberAge[0] < 20 || memberAge[0] == 20 && memberAge[1] < 1) {
                            check_res[0] = 14;
                        } else if (memberAge[0] >= 20 && memberAge[0] < 45 || memberAge[0] == 45 && memberAge[1] < 1) {
                            check_res[0] = 20;
                        } else if (memberAge[0] >= 45) {
                            check_res[0] = 45;
                        }
                    }

                    check_res[1] = check_passport_date(check_res[0]);

                    if (!check_res[1][0]) {
                        if (!$('#mem_bday').length) {
                            if (colname == 'Дата вступления' && $('#m_party_memb').prop('checked')) {
                                out = [false, colname + ': Текущий возраст - ' + get_correct_str(memberAge[0], 'год', 'года', 'лет') + ' ' + get_correct_str(memberAge[1], 'месяц', 'месяца', 'месяцев') + ' ' + get_correct_str(memberAge[2], 'день', 'дня', 'дней') + '. Минимальная дата вступления в партию - ' + check_res[1][1]];
                            } else if (colname == 'Дата зачисления в сторонники' && $('#m_party_supporter').prop('checked')) {
                                out = [false, colname + ': Текущий возраст - ' + get_correct_str(memberAge[0], 'год', 'года', 'лет') + ' ' + get_correct_str(memberAge[1], 'месяц', 'месяца', 'месяцев') + ' ' + get_correct_str(memberAge[2], 'день', 'дня', 'дней') + '. Минимальная дата зачисления в сторонники - ' + check_res[1][1]];
                            } else {
                                out = [false, colname + ': Текущий возраст - ' + get_correct_str(memberAge[0], 'год', 'года', 'лет') + ' ' + get_correct_str(memberAge[1], 'месяц', 'месяца', 'месяцев') + ' ' + get_correct_str(memberAge[2], 'день', 'дня', 'дней') + '. Минимальная дата получения паспорта (' + check_res[0] + ' лет) - ' + check_res[1][1]];
                            }
                        } else {
                            if (colname == 'Дата вступления' && $('#membership_vis').prop('checked')) {
                                jQuery.validator.messages.membDate = 'Текущий возраст - ' + get_correct_str(memberAge[0], 'год', 'года', 'лет') + ' ' + get_correct_str(memberAge[1], 'месяц', 'месяца', 'месяцев') + ' ' + get_correct_str(memberAge[2], 'день', 'дня', 'дней') + '. Минимальная дата вступления в партию - ' + check_res[1][1];
                                $('#entry_date').attr('validate', 'false');
                            } else if (colname == 'Дата зачисления в сторонники' && $('#party_supporter').prop('checked')) {
                                jQuery.validator.messages.membDate = 'Текущий возраст - ' + get_correct_str(memberAge[0], 'год', 'года', 'лет') + ' ' + get_correct_str(memberAge[1], 'месяц', 'месяца', 'месяцев') + ' ' + get_correct_str(memberAge[2], 'день', 'дня', 'дней') + '. Минимальная дата зачисления в сторонники - ' + check_res[1][1];
                                $('#supporter_admission_date').attr('validate', 'false');
                            } else if ($.isNumeric($('#passport_date').val().replace(/\./g, ''))) {
                                jQuery.validator.messages.membDate = 'Текущий возраст - ' + get_correct_str(memberAge[0], 'год', 'года', 'лет') + ' ' + get_correct_str(memberAge[1], 'месяц', 'месяца', 'месяцев') + ' ' + get_correct_str(memberAge[2], 'день', 'дня', 'дней') + '. Минимальная дата получения паспорта (' + check_res[0] + ' лет) - ' + check_res[1][1];
                                $('#passport_date').attr('validate', 'false');
                            }
                            out = [false];
                        }
                    } else {
                        if ($('#mem_bday').length) {
                            $('#entry_date, #passport_date, #supporter_admission_date').attr('validate', 'true');
                        }
                    }
                }
            } else {
                out = [ false, colname + ': Пожалуйста, введите правильную дату - d.m.Y' ];
            }
        }

        return out;
    };

    $.sms_templates = function(loadLast){
        var cSmsTemplDialog = function(){
            $('#sms_templates_grid').remove();
            $('#sms_templates').dialog('close');
            $('#sms_templates').remove();
        };
        var templateApply = function(){
            var selrow = $('#sms_templates_grid').jqGrid('getGridParam', 'selrow') || false;
            showAjaxLoading();
            $.ajax({
                type: 'POST',
                url: 'php/getData.php',
                data: {
                    qryType: 'applySmsTemplate',
                    templateName: selrow ? $('#sms_templates_grid').getRowData(selrow).name : ''
                },
                dataType: 'json',
                success: function (tr) {
                    hideAjaxLoading();
                    if (checkSession(tr) && tr['data'] != null) {
                        tr = JSON.parse(tr['data']);
                        tr.text.forEach(function(arr){
                            $('#add_sms_notify .' + arr[0]).val(arr[1]);
                            if (arr[1]) {
                                $('#add_sms_notify .' + arr[0]).removeClass('grey');
                            }
                        });
                        if ($('#add_sms_notify .sn_text_email').length) {
                            $('#add_sms_notify .sn_text_email').tinymce().setContent(tr.eCnt);
                        }
                        if ($('#sms_templates_grid').length) {
                            cSmsTemplDialog();
                        }
                        tr.cBox.forEach(function(arr){
                            if ($('#add_sms_notify .' + arr[0]).prop('checked') != arr[1]) {
                                $('#add_sms_notify .' + arr[0]).click();
                            }
                        });
                        $('#set_notify_list').val(tr.slct);
                        $('#set_notify_list_tip').val($('#set_notify_list option:selected').html()).focusout();
                    }
                }
            });
        };
        if(loadLast){
            templateApply();
            return;
        }

        $('#add_sms_notify').after(
            '<div id="sms_templates" title="шаблоны рассылок">'
                +'<table id="sms_templates_grid"></table>'
                +'<div id="sms_templates_nav"></div>'
            +'</div>'
        );
        showAjaxLoading();
        $.ajax({
            type: 'POST',
            url: 'php/getData.php',
            data: {
                'qryType': 'loadSmsTemplates'
            },
            dataType: 'json',
            success: function (tr) {
                if (checkSession(tr)) {
                    hideAjaxLoading();
                    $('#sms_templates_grid').jqGrid({
                        datatype: "local",
                        loadonce: true,
                        shrinktofit : true,
                        width : 423,
                        data: tr['data'],
                        height: 250,
                        shrinkToFit: false,
                        pager : '#sms_templates_nav',
                        colNames:['№','Название шаблона'],
                        colModel:[
                            {name:'id',index:'id', width:60, hidden: true, sorttype:"int"},
                            {name:'name', index:'name', editable:true, width:400}
                        ],
                        editurl: 'clientArray',
                        multiselect: false,
                        ondblClickRow: templateApply
                    });
                    $('#sms_templates_grid').jqGrid(
                        'navGrid', '#sms_templates_nav', {
                            edit : false,
                            add: false,
                            del: false,
                            search: false,
                            refresh: false
                        }
                    )
                    .navButtonAdd('#sms_templates_nav', {
                        title: 'Сохранить текущий шаблон',
                        caption: 'Сохранить',
                        buttonicon: 'ui-icon ui-icon-plus',
                        position: 'first',
                        onClickButton: function () {
                            var afterSave = function(id){
                                var currentState = {
                                    'cBox': ['smsNotifyAdd', 'emailNotifyAdd', 'digestNotifyAdd', 'sendOnPartEmail', 'sendOnPersonalEmail', 'nfEmailAddLogo', 'dynamic_list_check']
                                        .map(function(n){
                                            return [n,$('#add_sms_notify .'+n).prop('checked')];
                                        }),
                                    'eCnt': $.trim($('#add_sms_notify .sn_text_email').tinymce().getContent()),
                                    'text': ['sn_from', 'sn_text', 'sn_email_subj', 'nf_sms_provider']
                                        .map(function(n){
                                            if (['Текст смс-сообщения:', 'Тема email'].indexOf($('#add_sms_notify .' + n).val()) == -1) {
                                                return [n, $('#add_sms_notify .' + n).val()];
                                            } else {
                                                return [n, ''];
                                            }
                                        }),
                                    'slct': $('#set_notify_list').val()
                                };
                                showAjaxLoading();
                                $.ajax({
                                    type: 'POST',
                                    url: 'php/getData.php',
                                    data: {
                                        'qryType': 'saveSmsTemplate',
                                        'template': JSON.stringify(currentState),
                                        'templateName': $('#sms_templates_grid').getRowData(id).name
                                    },
                                    dataType: 'json',
                                    success: function (tr) {
                                        if (checkSession(tr)) {
                                            cSmsTemplDialog();
                                            hideAjaxLoading();
                                        }
                                    }
                                });
                            };

                            var selrow = $('#sms_templates_grid').jqGrid('getGridParam', 'selrow');
                            if (selrow !== null) {
                                $('#sms_templates_grid').saveRow(selrow);
                                afterSave(selrow);
                                return;
                            }
                            var randomName = ['sn_text', 'sn_email_subj']
                                .map(function(n){
                                    return $('#add_sms_notify .'+n).val()
                                })
                                .filter(function(n){
                                    return /[а-яё]/im.test(n) && n != 'Тема email'
                                })[0] || 'Шаблон рассылки ' + Math.round(Math.random() * 100);

                            randomName = randomName.slice(0,35);
                            $('#sms_templates_grid').jqGrid('addRow', {
                                rowId: 'new',
                                initdata: {
                                    'id': 0,
                                    'name': randomName
                                },
                                addRowParams: {
                                    'keys': true,
                                    'url': 'clientArray',
                                    'aftersavefunc': afterSave
                                }
                            });
                            $('#sms_templates_grid input#jqg'+ selrow +1+'_name').addClass('processing');
                        }
                    })
                    .navButtonAdd('#sms_templates_nav', {
                        title: "Загрузить выбранный шаблон",
                        caption: 'Применить',
                        buttonicon: "ui-icon ui-icon-check",
                        position: "last",
                        onClickButton: templateApply
                    })
                    .navButtonAdd('#sms_templates_nav', {
                        title: "Удалить шаблон",
                        caption: 'Удалить',
                        buttonicon: "ui-icon ui-icon-trash",
                        position: "last",
                        onClickButton: function () {
                            showAjaxLoading();
                            $.ajax({
                                type: 'POST',
                                url: 'php/getData.php',
                                data: {
                                    'qryType' : 'deleteSmsTemplate',
                                    'templateName' : $('#sms_templates_grid').getRowData($('#sms_templates_grid').jqGrid('getGridParam', 'selrow')).name
                                },
                                dataType: 'json',
                                success: function (tr) {
                                    if (checkSession(tr)) {
                                        hideAjaxLoading();
                                        $('#sms_templates_grid').jqGrid('delRowData', $('#sms_templates_grid').jqGrid('getGridParam', 'selrow'));
                                    }
                                }
                            });
                        }
                    });

                    $('#sms_templates_nav_center').remove();
                    $('#sms_templates_nav_right').remove();
                }
            }
        });
        $("#sms_templates").dialog({
            modal: true,
            height: 420,
            width: 450,
            zIndex : 1002,
            close: cSmsTemplDialog,
            buttons: {
                "Закрыть" : cSmsTemplDialog
            }
        });
    };

    $.DocsSearch = function() {
        var select_list = ['docs_archive_district', 'docs_archive_ctgr', 'docs_archive_type'];
        var input_list = ['docs_archive_number', 'docs_archive_name', 'docs_archive_text'];

        $('<div id="docs_archive_search">')
            .html($("#docs_archive_search_tmpl").html().replace(/\{TMPL\}/g,''))
            .dialog({
                autoOpen: true,
                title: 'Поиск по документам',
                modal: true,
                resizable: false,
                zIndex : 99,
                width: 450,
                position: ['middle', 50],
                height: 500,
                close: function(ev, ui) { $('#docs_archive_search').parent().remove(); $('#docs_archive_search').remove(); },
                open: function(ev, ui){
                    $('#docs_archive_text').focus();
                    $('#docs_button_search').css('float','right');

                },
                buttons: {
                    "Отмена" : {
                        text: "Отмена",
                        click: function(){
                            $('#docs_archive_search').dialog('close');
                        }
                    },
                    'Поиск' : {
                        text: "Поиск",
                        id: 'docs_button_search',
                        click: function(){
                            var filters = {};
                            filters.select = {};
                            select_list.map(function(name){
                                filters.select[name] = $('#'+name).val();
                            });
                            filters.input={};
                            filters.input['docs_archive_date'] = {};
                            filters.input['docs_archive_date']['to'] = $('#docs_archive_date_to').val();
                            filters.input['docs_archive_date']['from'] = $('#docs_archive_date_from').val();

                            input_list.map(function(name) {
                                filters.input[name] = $('#'+name).val();
                            });

                            $('#docs_archive_search').dialog('close');
                            $('#grid').jqGrid('setGridParam', { postData: {advancedSearch: filters} }).trigger('reloadGrid');
                        }
                    }
                },
                create: function(ev, ui){
                    var el,i;
                    var datePickerOpt = {
                        dateFormat:'dd.mm.yy',
                        changeMonth:true,
                        changeYear:true,
                        yearRange: '-10',
                        showButtonPanel:true
                    };
                    $('#docs_archive_date_from').datepicker(datePickerOpt).change(function(){
                        $('#docs_archive_date_to').datepicker( "option", "minDate", $(this).val() );
                    });
                    $('#docs_archive_date_to').datepicker(datePickerOpt).change(function(){
                        $('#docs_archive_date_from').datepicker( "option", "maxDate", $(this).val() );
                    });

                    $.ajax({
                        type:"GET",
                        url:'../php/getData.php',
                        data:{'qryType':'getDocsArchiveSearchFilters'},
                        dataType:"json",
                        success:function (tr) {
                            if(checkSession(tr)){
                                tr = tr['data'];
                                $('#docs_archive_search select').removeClass('hidden');
                                select_list.map(function(name){
                                    var el='<option value="-1">нажмите для выбора</option>';
                                    tr[name].map(function(val){
                                        el += '<option value="'+ val['id'] +'">' + val['name'] + '</option>';
                                    });
                                    $('#' + name).html('').append(el);
                                });
                            }
                        }
                    })
                }
            });
    };
    $.MarkSupporterAsRead = function(rowId, site) {
        if(site) {
            var dialog = $('<div></div>')
                .html('<div id="sup_decline"><textarea id="decline_reason" rows="3" style="width: 350px"></textarea></div>')
                .dialog({
                    autoOpen: false,
                    title: 'Причина отказа',
                    modal: true,
                    resizable: false,
                    zIndex : 3001,
                    height: 'auto',
                    width: 'auto',
                    close: function(ev, ui) {
                        $(this).dialog('destroy');
                        $(this).remove();
                    },
                    buttons: [
                        {
                            'text': "Отклонить",
                            'class': "submit button",
                            click: function(){
                                var t = this
                                $.ajax({
                                    type: "POST",
                                    url: "php/getData.php",
                                    dataType: 'json',
                                    data: {qryType: 'markSupporterAsRead', supId: rowId, supporterSite: true, reason: $('#decline_reason').val()},
                                    success: function (tr) {
                                        if (checkSession(tr)) {
                                            $('tr#' + rowId + ' td[aria-describedby="grid_ss_accepted"]').html('Отказано');
                                            $(t).dialog("close");
                                        }
                                    }
                                });
                            }
                        },{
                            text: "Закрыть",
                            class: "button",
                            click: function() {
                                $(this).dialog("close");
                            }
                        }]
                });
            dialog.dialog('open');
        } else {
            $.ajax({
                type: "POST",
                url: "php/getData.php",
                dataType: 'json',
                data: {qryType: 'markSupporterAsRead', supId: rowId},
                success: function (tr) {
                    if (checkSession(tr)) {
                        $('tr#' + rowId + ' td[aria-describedby="grid_si_accepted"]').html('Запись обработана');
                    }
                }
            });
        }
    };

    $.jqGridResumePopup = function(jqGId, party){
        $(jqGId+" .ui-inline-resume").html('');
        $(jqGId+" .ui-inline-resume").append('<div class="ui-pg-div ui-resume" title="Анкета"><span class="ui-icon ui-icon-script"></span></div>');
        $(jqGId+" .ui-resume").click(function(){
            var gridId = jqGId.substring(1, jqGId.length)+'_';
            $("#alertmodHistory .ui-jqdialog-title").html('Анкетирование - ответы');
            var path = (budgetFlag ? '../' : '');
            $("#alertmodHistory .ui-jqdialog-content").removeAttr('style');
            $("#alertmodHistory").css({width: '780px', top: '15%'});
            $("#alertmodHistory").css({left: ($(document).width() - $("#alertmodHistory").width())/2});
            $.jgrid.viewModal("#alertmodHistory",{});
            $("#historyDialog").html('<img src="'+path+'css/images/ajax-loader.gif">');
            var tr = $(this).parents('tr:first'),
                keyVal = tr.attr('id');

            if(keyVal.indexOf('_') != -1)
                keyVal = keyVal.split('_')[0];
            var qryType = "getTestResume"
            if(party) qryType = "getPartyTestResume"
            $.ajax({
                type:"GET",
                url:"../php/getData.php",
                dataType:"json",
                data:{id: keyVal, qryType: qryType},
                success:function (tr) {
                    $("#historyDialog").html(tr.data);
                }
            });
        });

        $(jqGId+" .ui-resume").hover(function(){
            $(this).addClass('ui-state-hover');
        }, function(){
            $(this).removeClass('ui-state-hover');
        });
    };
    $.ClearIkTestResult = function(rowId, ik) {
        if(confirm('Вы уверены, что хотите очистить резльтутаты теста?')) {
            $.ajax({
                type: "POST",
                url: "../php/getData.php",
                dataType: "json",
                data: {id: rowId, ik: ik, qryType: "clearIkTestResult"},
                success: function(tr) {
                    if(ik) {
                        $('#ik_test').trigger('hashChange');
                    } else {
                        $('#party_test').trigger('hashChange');
                    }
                }
            });
        }
    };
    $.ReplyIkTestNotify = function(rowId, ik) {
        if(confirm('Вы уверены, что хотите повторить рассылку?')) {
            $.ajax({
                type: "POST",
                url: "../php/getData.php",
                dataType: "json",
                data: {id: rowId, ik: ik, qryType: "replyIkTestNotify"},
                success: function(tr) {
                    $('#ik_test').trigger('hashChange');
                }
            });
        }
    };
    $.getMembersCalls = function(elem, mId) {
        $.ajax({
            type: "GET",
            url: "../php/getData.php",
            dataType: "json",
            data: {id: mId, qryType: "getMembersCalls"},
            success: function(tr) {
                var html = "<td colspan=\"2\" align=\"right\"><table class=\"memberCalls\">";
                html += "<tr><td>Оператор</td><td>Дата</td><td>Проект</td><td>Статус</td><td>Комментарий</td></tr>";
                $.each(tr.data.calls, function(){
                    var pr = this.project == null ? '' : this.project;
                    html += "<tr><td>" + this.fio + "</td><td>" + this.mc_datetime.split('.')[0] + "</td><td>" + pr + "</td><td>" + this.status + "</td><td>" + this.mc_comment + "</td></tr>";
                });
                html += "</table>";
                html += "<input type=\"button\" name=\"addCall\" value=\"Добавить звонок\" class=\"button\" ></td>";
                $('#' + elem).html(html);

                $('input[name=addCall]').click(function(){
                    var project = "<select id=\"call_project\"><option value=\"-1\"></option>";
                    $.each(tr.data.projects, function(){
                        project += "<option value=\"" + this.mcp_id + "\">" + this.mcp_name + "</option>";
                    });
                    project += "</select>";
                    var status = "<select id=\"call_status\">";
                    $.each(tr.data.status, function(){
                        status += "<option value=\"" + this.id + "\">" + this.name + "</option>";
                    });
                    status += "</select>";
                    $('.memberCalls tr:last').after("<tr><td colspan=\"5\">Новый звонок:</td></tr><tr><td>Проект:</td><td colspan=\"4\">" + project + "</td></tr><tr><td>Статус:</td><td colspan=\"4\">" + status + "</td></tr><tr><td>Комментарий:</td><td colspan=\"4\"><input type=\"text\" id=\"call_text\" name=\"calls\" role=\"textbox\" class=\"FormElement ui-widget-content ui-corner-all\"/></td></tr>");
                    $(this).hide();
                })
            }
        });
    };
    $.jqPrintGrid =  function(id){
        var table = '<b>' + $(id).getGridParam('caption')+ '</b>' + '<table id="tbl"><tr>';
        var columns = [];

        $(id).getGridParam('colModel').map(function(header){
            if(header.hidden == false && (header.label || false) && (header.index || false)) {
                table += '<th>' + header.label + '</th>';
                columns.push(header.index);
            }
        });

        var colLen = columns.length;
        $(id).getRowData().map(function(row){
            table += '<tr>';
            for(var j=0; j < colLen; j++){
                table += '<td>' + row[columns[j]] + '</td>';
            }
            table += '</tr>';
        });
        table += '</tr></table>';
        table = table.replace(/Yes|No/ig, function(str){
            if(str == 'Yes' )
                return '&#10003;';
            else
                return '&#10007;';
        });

        var script = "document.getElementById('tbl').style.visibility = 'hidden'; var f = 0.5, s = 0.01, len = document.getElementsByTagName('table').length, set = function(f){for (var i = 0;i<len;i++){document.getElementsByTagName('table')[i].style.fontSize = f + 'em'; } }; set(f); e = setInterval(function(){w = document.getElementById('tbl').offsetWidth; if(w < 1180) f += s; else f -= s; set(f); if((w<1200 && w> 1150)){clearInterval(e); document.getElementById('tbl').style.visibility = 'visible'; } } , 0.0001); setTimeout(function(){clearInterval(e); document.getElementById('tbl').style.visibility = 'visible';},5000);";
        var printWindow=window.open('','','width=1200,height=800,scrollbars=1');
        printWindow.document.writeln("<html><head><link rel='stylesheet' type='text/css' href='../css/print.table.css'><script>function font(){" + script + "}</script></head>");
        printWindow.document.writeln("<body><div class='noprint'><input type='button' value='Печать' onclick='window.print();' /><input type='button' value='Шрифт по ширине страницы' onclick='font()' /></div>");
        printWindow.document.writeln('<div>' + table + '</body></div></html>');
        printWindow.document.close();
    };

    $.setDataRangeSelect = function(ids, prefix){
        ids.map(function(id){
            var idSel = '#' + prefix + id;
            if( !$(idSel).parent().hasClass(id +'_single') ){
                $(idSel).closest('div').addClass('hasdaterange');
                $("#work_panel " + idSel).parent().addClass(id + '_single');
                $("#work_panel " + idSel).parent().after('<td id="' + id + '_interval" class="' + id + '_interval daterange_interval hidethis"><input id="' + id + '_from"></input>&ndash;<input id="' + id + '_to"></input></td><td class="date_interval_icon" id="' +id + '_icon" title="точная дата/интервал дат"><i class="fa fa-calendar"></td>');

                $('#' + id + '_icon').click(function(){
                    var reloadGrid = false;

                    if( $('.' + id + '_interval').hasClass('hidethis') ){
                        reloadGrid = $('.' + id + '_single input').eq(0).val() !== '';
                        $('.' + id + '_interval').removeClass('hidethis');
                        $('.' + id + '_single').addClass('hidethis').find('input').val('');
                    } else{
                        reloadGrid = $('.' + id + '_interval input').eq(0).val() !== '' || $('.' + id + '_interval input').eq(1).val() !== '';
                        $('.' + id + '_interval').addClass('hidethis').find('input').val('');
                        $('#' + id + '_from').datepicker( "option", "maxDate", '' );
                        $('#' + id + 'to').datepicker( "option", "minDate", '' );
                        $('.' + id + '_single').removeClass('hidethis');
                    }

                    if(reloadGrid){
                        $(idSel).keydown();
                    }
                });

                $(idSel)
                    .datepicker({
                        dateFormat:'dd.mm.yy',
                        changeMonth:true,
                        changeYear:true,
                        showAnim:'slideDown',
                        yearRange: '-100',
                        showButtonPanel:true
                    })
                    .change(function(){ $(idSel).keydown()});

                [{'suf':'_from', 'rev':'_to', 'opt':'maxDate'}, {'suf':'_to', 'rev':'_from', 'opt':'minDate'}].map(function(obj){
                    $('#' + id + obj.rev).datepicker({
                        dateFormat:'dd.mm.yy',
                        changeMonth:true,
                        changeYear:true,
                        showAnim:'slideDown',
                        yearRange: '-100',
                        showButtonPanel:true,
                        onClose: function( selectedDate ) {
                            $('#' + id + obj.suf ).datepicker( "option", obj.opt, selectedDate );
                        }
                    });
                    $('#' + id + obj.suf).change(function(){
                        $(this).val() == '' || /^\d{1,2}\.\d{1,2}.\d{4}$/.test($(this).val()) ? $(idSel).keydown() : false;
                    });
                });
                $('.ui-datepicker').css({'font-size':'75%'});
            }
        });
    };
    $.serializeDataRange = function(postData){
        if(postData.filters || false){
            var filters = JSON.parse(postData.filters);
            $('.daterange_interval').map(function(){
                var id =  this.id.replace('_interval','');
                [{'sel':'#' + id + '_from', 'op':'ge'}, {'sel':'#' + id + '_to', 'op':'le'}].map(function(obj){
                    if($(obj.sel).val().length>0){
                        filters['rules'].push({data: $(obj.sel).val().replace(/^(\d{1,2})\.(\d{1,2}).(\d{4})$/, '$3-$2-$1'), field: id, op: obj.op});
                        postData._search = true;
                    }
                });

            },this);
            postData.filters = JSON.stringify(filters);
        }

        return postData;
    };

    $.getPersonWrongData = function(local_machine){
        var m_id = $('#grid').jqGrid('getGridParam', 'selrow'),
            m_acc_wrong_data = $('#' + m_id + ' .m_acc_wrong_data').html().split(',');

        $('.m_acc_wrong, .wrong_fld').remove();
        $('.wrong_col').removeClass('wrong_col').removeClass('color-red');
        if(m_acc_wrong_data[0] !== '&nbsp;'){
            $.ajax({
                type: 'GET',
                url: 'php/getData.php',
                data: {qryType: 'account_view', m_id: m_id},
                dataType: 'json',
                success: function(tr){
                    checkSession(tr);

                    if(tr.error != '') {
                        return;
                    }

                    var wrong_title = '<i class=\"m_acc_wrong color-red\">&nbsp;&nbsp;неверно</i>';
                    var wrong_title_2 = '<i class=\"m_acc_wrong color-red\">неверно -></i>';
                    var wrong_flds = '';

                    for(var i = 0; i < m_acc_wrong_data.length; i++){
                        if(m_acc_wrong_data[i] == 'm_party_memb'){
                            $('#editmodgrid .fa-ticket').parent().addClass('color-red').addClass('wrong_col');
                            $('#m_party_memb').after(wrong_title);
                            $('#m_party_memb').next().css({position: 'relative', top: '-2px'});
                        } else if(m_acc_wrong_data[i] == 'm_party_support'){
                            $('#editmodgrid .fa-users').parent().addClass('color-red').addClass('wrong_col');
                            $('#m_party_supporter').after(wrong_title);
                            $('#m_party_supporter').next().css({position: 'relative', top: '-2px'});
                        } else if(m_acc_wrong_data[i] == 'm_party_memb_dep' || m_acc_wrong_data[i] == 'm_party_support_dep'){
                            $('#editmodgrid .fa-globe').parent().addClass('color-red').addClass('wrong_col');
                            $('#d_name, #r_name, #mo_name, #po_name').after(wrong_title);
                        } else {
                            if(['m_mps_memb', 'm_mps_memb_dep', 'm_mps_mun_memb', 'm_mps_mun_memb_dep',
                                    'm_rps_memb', 'm_rps_memb_dep', 'm_po_secretary', 'm_po_secretary_dep',
                                    'm_mo_secretary', 'm_mo_secretary_dep', 'm_mo_mun_secretary', 'm_mo_mun_secretary_dep',
                                    'm_rik_secretary', 'm_rik_secretary_dep'
                                ].indexOf(m_acc_wrong_data[i]) != -1){
                                wrong_flds +=
                                    '<tr class="FormData pole_fa-gavel wrong_fld">' +
                                        '<td class="CaptionTD">'+tr.data[m_acc_wrong_data[i] + '_colname']+'</td>' +
                                        '<td class="DataTD">' +
                                            tr.data[m_acc_wrong_data[i]] + (
                                                tr.data[m_acc_wrong_data[i] + '_link'] ?
                                                    '&nbsp;&nbsp;' +
                                                    '<a style="color: red;" title="Переход к редактированию" target="_blank" href="' + tr.data[m_acc_wrong_data[i] + '_link'] + '">' +
                                                        wrong_title_2 +
                                                    '</a>'
                                                :
                                                    wrong_title
                                            ) +
                                        '</td>' +
                                    '</tr>';
                            }
                        }
                    }

                    if(wrong_flds){
                        $('#editmodgrid .fa-gavel').parent().addClass('color-red').addClass('wrong_col');
                        $('.pole_fa-gavel:last').after(wrong_flds);
                    }
                }
            });
        }
    };

    $.customColumns = function () {
        var multiajax = function (qry, func) {
            func = func || function(tr){
                checkSession(tr);
            };
            $.ajax({
                type: 'POST',
                url: 'php/getData.php',
                data: qry,
                success: func
            })
            .done(function () {
                hideAjaxLoading();
            });
        };
        var addRow = function (data) {
            var el;
            if (data || false) {
                el = '<tr class="cust">';
                ['num', 'name'].map(function (n) {
                    el += '<td id = "' + data.mf_id + '" class="' + n + '">' + data.mf_field_name + '</td>';
                });
            } else {
                el = '<tr class="cust new">';
                ['num', 'name'].map(function (n) {
                    el += '<td class="' + n + '"></td>';
                });
            }
            el += '<td class = "del"><i class="fa fa-times-circle"></i></td>';
            el += '</tr>';
            $('#cTbl-list tbody').after(el);
        };
        var stView = function () {
            $('.editable .name').blur().text($('.editable input').val());
            $('#cTbl-list .editable').removeClass('editable');

        };
        var enumirate = function () {
            for (var i = 0, len = $('#cTbl-list tr').length; i < len; i++) {
                $($('#cTbl-list .num')[i]).text(i + 1 + '.');
            }
            $('#cTbl-list .del').unbind();
            $('#cTbl-list .del').click(function () {
                if ($(this).parent().hasClass('delete')) {
                    $(this).parent().removeClass('delete');
                } else {
                    if ($(this).parent().find('.name').attr('id') % 1 == 0) {
                        stView();
                        $(this).parent().addClass('delete');
                    } else {
                        $(this).parent().remove();
                        enumirate();
                    }
                }
                if( $('#cTbl-list .delete').length >0 ){
                    $('#cSave-button').parent().addClass('warning-delete');
                } else {
                    $('#cSave-button').parent().removeClass('warning-delete');
                }
            });
            $('#cTbl-list .name').click(function () {
                if ($(this).parent().hasClass('editable') || $(this).parent().hasClass('delete')) {
                    return;
                }
                if ($('#cTbl-list .editable').length > 0) {
                    stView();
                }
                $(this).parent().addClass('editable');
                if( !$(this).parent().hasClass('changed') && !$(this).parent().hasClass('new') ){
                    $(this).parent().addClass('changed');
                }
                $('.editable .name').html('<input value = "' + $('.editable .name').text() + '" />').children('input').focus().keyup(function(e) {
                    if(e.keyCode == 13){
                        stView();
                    }
                });
            });
        };
        var gather = function () {
            stView();
            var data = {
                r_id: $('#cRiks_list option:selected').val(),
                add: [],
                rename: [],
                del: []
            };
            $('#cTbl-list .cust').filter(function () {
                return $(this).find('.name').text() != '';
            }).map(function () {
                if ($(this).hasClass('delete')) {
                    data.del.push({
                        name: $(this).find('.name').text(),
                        id: $(this).find('.name').attr('id')
                    });
                }
                if ($(this).hasClass('changed')) {
                    data.rename.push({
                        name: $(this).find('.name').text(),
                        id: $(this).find('.name').attr('id')
                    });
                }
                if($(this).hasClass('new')) {
                    data.add.push({
                        name: $(this).find('.name').text()
                    });
                }
            });
            return JSON.stringify(data);
        };
        var updateSelectors = function(districts, riks){
            if(districts){
                $('#cDistrict_list').empty();
                $('#cDistrict_list').append('<option>Выберите ФО</option>');
                districts.map(function(n){
                    $('#cDistrict_list').append('<option value="' + n.d_id + '">' + n.d_name + '</option>');
                });
            }
            if(riks){
                $('#cRiks_list').empty();
                $('#cRiks_list').append('<option>Выберите РО</option>');
                riks.map(function(n){
                    $('#cRiks_list').append('<option value="' + n.r_id + '">' + n.r_name + '</option>');
                });
            }
        };
        $('<div id="custColDialog" />').html('<div id = "pane"></div>').dialog({
            autoOpen: true,
            title: 'Дополнительные поля',
            modal: true,
            resizable: true,
            zIndex: 99,
            width: 1024,
            position: ['middle', 50],
            height: 600,
            close: function (ev, ui) {
                $('#custColDialog').parent().remove();
                $('#custColDialog').remove();
            },
            open: function (ev, ui) {
                $('#pane').append($("#cTbl-list_tmpl").html().replace(/_tmpl/g, ''));

                showAjaxLoading();
                multiajax({'qryType': 'districts', 'childLvl': 'rik'}, function(tr){
                    checkSession(tr);
                    tr = JSON.parse(tr).data;
                    updateSelectors(tr);

                    $('#cDistrict_list').change(function(){
                        if($('#cDistrict_list').val() % 1 == 0){
                            multiajax({'qryType': 'rikListByDisctrict', 'districtId': $('#cDistrict_list').val()}, function(tr){
                                checkSession(tr);

                                tr = (JSON.parse(tr)).data;
                                updateSelectors(false, tr);
                                var  mf_r_id = tr.mf_id;

                                $('#cRiks_list').change(function () {
                                    if ($('#cRiks_list').val() % 1 == 0) {
                                        showAjaxLoading();
                                        multiajax({
                                            'qryType': 'cLoadColumnsList',
                                            'r_id': $('#cRiks_list').val(),
                                            'd_id': $('#cDistrict_list').val()
                                        }, function (tr) {
                                            checkSession(tr);
                                            hideAjaxLoading();

                                            $('#cTbl-list tr.cust').remove();
                                            tr = JSON.parse(tr).data;
                                            for (var i = 0; i < tr.length; i++) {
                                                addRow(tr[i]);
                                            }
                                            enumirate();

                                            if ($('#cfreezeRik_chkbox').attr('r_id') == $('#cRiks_list').val()) {
                                                $('#cfreezeRik_chkbox').prop('checked', true);
                                            } else {
                                                $('#cfreezeRik_chkbox').prop('checked', false);
                                            }
                                        });

                                        $('#cTbl-list').show();

                                        $('#pane legend').last().text($('#cRiks_list option:selected').text());
                                    } else {
                                        $('#cTbl-list').hide();
                                    }
                                });
                                if($('#grid').getGridParam('currentCustomRik')){
                                    $('#cRiks_list').val($('#grid').getGridParam('currentCustomRik')).change();
                                    $('#cfreezeRik_chkbox').attr('r_id', $('#cRiks_list').val());
                                } else {
                                    hideAjaxLoading();
                                }
                            });
                        }
                    });
                    if($('#grid').getGridParam('currentCustomDistr')){
                        $('#cDistrict_list').val($('#grid').getGridParam('currentCustomDistr')).change();
                    } else {
                        hideAjaxLoading();
                    }
                });

                //checkbox click
                $('#cfreezeRik_chkbox').click(function () {
                    if ($('#cfreezeRik_chkbox').prop('checked') == true) {
                        if ($('#cRiks_list').val() % 1 == 0) {
                            showAjaxLoading();
                            multiajax({
                                qryType: 'cFreezeCustR_id',
                                r_id: $('#cRiks_list').val()
                            });
                            $('#cfreezeRik_chkbox').attr('r_id', $('#cRiks_list').val());
                            $('#cRiks_list').removeClass('error');
                        } else {
                            $('#cRiks_list').addClass('error');
                            $('#cfreezeRik_chkbox').prop('checked', false);
                        }
                    }
                });
                $('#cTbl-list .head').click(function () {
                    addRow();
                    enumirate();
                });
            },
            buttons: {
                "Отмена": {
                    text: "Отмена",
                    click: function () {
                        $('#custColDialog').dialog('close');
                    }
                },
                'Сохранить': {
                    text: "Сохранить",
                    id: 'cSave-button',
                    click: function () {
                        $.ajax({
                            url: 'php/getData.php',
                            type: 'POST',
                            data: {
                                'qryType': 'cSaveColumns',
                                'data': gather(),
                                'cFreezeCustR_id': $('#cfreezeRik_chkbox').prop('checked')},
                            success: function(tr){
                                checkSession(tr);
                                $('#custColDialog').dialog('close');
                                $(location.hash).click();
                            }
                        });
                    }
                }
            }
        });
    };

    $.jqGridEditChvanstvoGrid = function (org) {
        var strId = $("#grid tr.ui-state-highlight").attr("id");
        if(strId == undefined)
            strId = -1;
        var dElId = '#d_name';
        $(dElId+' option:first').prop('disabled', true);
        var rikElId = '#r_name';
        if($(dElId).val() != "" && $(dElId).val() != 0)
            $.jqGridChRegionList(dElId, rikElId, strId, org);

        $(dElId).change(function(){
            if($(this).val() == 0)
                $(rikElId).html('');
            else
                $.jqGridChRegionList(dElId, rikElId, strId, org);
        });
        $(dElId).show().parent().animateHighlight("#FAF000", 1000);

        if(org) {
            $(rikElId).change(function(){ $.jqGridChMoList(rikElId, '#mo_name', strId); });
        }
    };

    $.jqGridChRegionList = function(dElId, rikElId, strId, org){
        var dId = $(dElId).val();

        $.ajax({
            type:"POST",
            url:"php/getData.php",
            dataType:'json',
            data:{'qryType':'chRegionListByOperator', 'districtId':dId, strId: strId, org: org},
            success: function(tr){
                var rName = '',
                    hdr = 'Название региона';
                    var rikOpt = '<option value="">'+hdr+':</option>';

                $.each(tr.data, function(){
                    rName = this.name;

                    if(!isNaN(this.id)){
                        if(tr.data.currRId == this.id){
                            rikOpt += '<option value="'+this.id+'" selected="selected"';
                        } else
                            rikOpt += '<option value="'+this.id+'" ';

                        rikOpt += ' >'+rName+'</option>';
                    }
                });

                $(rikElId).html("").append(rikOpt).change().show().parent().animateHighlight("#FAF000", 1000);
            }
        });
    };

    $.jqGridChMoList = function(rikElId, moElId, usrId){
        var rId = $(rikElId).val();

        $.ajax({
            type:"POST",
            url:"php/getData.php",
            dataType:'json',
            data:{'qryType':'chMoList', 'rId':rId, 'strId':usrId},
            success: function(tr){
                var moOpt = '<option value="">Муниципалитет:</option>';

                $.each(tr.data, function(){
                    if(!isNaN(this.id))
                        moOpt += '<option value="'+this.id+'" '+(tr.data.currMoId == this.id ? "selected=\'selected\'" : "")+'>'+this.name+'</option>';
                });

                $(moElId).html("").append(moOpt).show().parent().animateHighlight("#FAF000", 1000);

            }
        });
    };
    $.FilesForFso = function(grid_id) {
        var getCurrMembCnt = $(grid_id).jqGrid('getGridParam', 'records');
        if(confirm('Вы уверены, что хотите выгрузить файлы для ФСО для ' + getCurrMembCnt + ' человек? После окончания выгрузки, Вам на почту будет направлено уведомление с ссылкой для скачивания')) {
            $.ajax({
                type:"POST",
                url:"php/getData.php",
                dataType:'json',
                data:{'qryType':'filesForFso', evt_id: grid_id.split('_')[1]},
                success: function(tr) {
                }
            });
        }
    };
    $.approveEventMemb = function(grid_id) {
        var ev_id = grid_id.split('_')[1];
        showAjaxLoading();
        $.ajax({
            type: 'POST',
            url: 'php/getData.php',
            dataType: 'json',
            data: {
                qryType: 'getNotApprovedEvntMembCnt',
                ev_id: ev_id
            },
            success: function(tr) {
                hideAjaxLoading();
                var xhtml = 'Будет ' + get_correct_str(tr.data.cnt, 'утвержден', 'утверждено', 'утверждено', true) + ' <span class="color-green">' + tr.data.cnt + '</span> ' + get_correct_str(tr.data.cnt, 'человек', 'человека', 'человек', true) + '. Утвердить?' +
                    '<br><br>' +
                    'Комментарий:<br>'+
                    '<textarea id="approve_evnt_memb_comment"></textarea>';
                $.create_popup_dialog(
                    xhtml,
                    'Утверждение',
                    function () {
                        showAjaxLoading();
                        $.ajax({
                            type: 'POST',
                            url: 'php/getData.php',
                            dataType: 'json',
                            data: {
                                qryType: 'approveEvntMemb',
                                ev_id: ev_id,
                                eml_approved_comment: $('#approve_evnt_memb_comment').val()
                            },
                            success: function (tr) {
                                hideAjaxLoading();
                                $(grid_id).trigger('reloadGrid');
                            }
                        });
                    },
                    false,
                    function () {
                        $('#approve_evnt_memb_comment').width($('#popup_dialog_form').width());
                    }
                );
            }
        });
    };
    $.unapproveEventMemb = function(grid_id, approve_date) {
        var ev_id = grid_id.split('_')[1];

        showAjaxLoading();
        $.ajax({
            type: 'POST',
            url: 'php/getData.php',
            dataType: 'json',
            data: {
                qryType: 'getApprovedEvntMembCnt',
                approve_date: approve_date,
                ev_id: ev_id
            },
            success: function(tr) {
                hideAjaxLoading();
                var xhtml = 'Будет отменено утверждение для <span class="color-green">' + tr.data.cnt + '</span> ' + get_correct_str(tr.data.cnt, 'человека', 'человек', 'человек', true) + '. Отменить утверждение?';
                $.create_popup_dialog(
                    xhtml,
                    'Отмена утверждения',
                    function () {
                        showAjaxLoading();
                        $.ajax({
                            type: 'POST',
                            url: 'php/getData.php',
                            dataType: 'json',
                            data: {
                                qryType: 'unapproveEvntMemb',
                                approve_date: approve_date,
                                ev_id: ev_id
                            },
                            success: function (tr) {
                                hideAjaxLoading();
                                $(grid_id).trigger('reloadGrid');
                            }
                        });
                    }
                );
            }
        });
    };

    $.AllROVitaes = function(params) {
        if (!params) {
            params = 'qryType=allROVitaes';
        }
        showAjaxLoading();
        $.ajax({
            type: 'POST',
            url: 'php/getData.php',
            dataType: 'json',
            data: {qryType: 'districts'},
            success: function (tr) {
                hideAjaxLoading();
                if (checkSession(tr)) {
                    var districts_html = '';
                    for (var i = 0; i < tr.data.length; i++) {
                        districts_html +=
                            '<div style="padding-bottom: 3px;">' +
                                '<a target="_blank" href="php/getData.php?' + params + '&d_id=' + tr.data[i].d_id + '&d_name=' + tr.data[i].d_name + '">' + tr.data[i].d_name + '</a>' +
                            '</div>';
                    }
                    $.create_popup_dialog(districts_html, 'ФО', false, false, function(popup_id) {
                        $('#' + popup_id + ' .ui-button-text').html('Ок');
                    });
                }
            }
        });
    };
    $.allSecretaryVitaes = function (rik_leads) {
        $.AllROVitaes('qryType=allSecretaryVitaes&rik_leads=' + (rik_leads ? 'true' : 'false'));
    };
    $.allRpsVitaes = function () {
        $.AllROVitaes('qryType=allRpsVitaes');
    };
    $.getUikElectionResults = function(rowId, evt){
        $("#alertmodHistory .ui-jqdialog-title").html('Результаты выборов');
        var path = (budgetFlag ? '../' : '');
        $("#alertmodHistory .ui-jqdialog-content").removeAttr('style');
        $("#alertmodHistory").css({width: '780px', top: '15%'});
        $("#alertmodHistory").css({left: ($(document).width() - $("#alertmodHistory").width())/2});
        $.jgrid.viewModal("#alertmodHistory",{});
        $("#historyDialog").html('<img src="'+path+'css/images/ajax-loader.gif">');
        var id = rowId == undefined ? $(evt.target).parent().find('td[aria-describedby="grid_uik_id"]').html() : rowId;

        $.ajax({
            type:"GET",
            url:"../php/getData.php",
            dataType:"json",
            data:{id: id, qryType: 'getUikElectionResults'},
            success:function (tr) {
                $("#historyDialog").html(tr.data);
            }
        });
    };
    $.inlineDropValue = function(elem) {
        $.extend(true, $.jgrid.inlineEdit, {
            beforeSaveRow: function () {
                if ($.isArray(elem)) {
                    $.each(elem, function(i, val){
                        if(!$.isNumeric($('#' + val).parent().find('.party_match').attr('m_id'))) {
                            $('#' + val).val('');
                        }
                    });
                } else {
                    if (!$.isNumeric($('#' + elem).parent().find('.party_match').attr('m_id'))) {
                        $('#' + elem).val('');
                    }
                }
            }
        });
    };
    $.getHistoryByMonth = function(tableName, rowName, rowId){
        var histDate, histMsg;
        var dialog = $('<div id="show_row_history"><div tabindex="1">Выберите месяц/год:</div><div><input type="text" tabindex="2" /></div><div class="msg error-msg"></div><div id="table_row_history" class="hidden"></div></div>')
            .dialog({
                autoOpen: true,
                title: 'Лист изменений записи',
                modal: true,
                resizable: false,
                zIndex : 3001,
                width: 330,
                height: 190,
                position: { my: 'center', mx: 'center', of: window },
                open: function(ev, ui) {
                    histDate = $('#show_row_history input');
                    histMsg = $('#show_row_history .msg');
                    histDate.datepicker({
                        dateFormat: "MM yy",
                        showButtonPanel: true,
                        changeMonth: true,
                        changeYear: true,
                        showAnim: "slideDown",
                        maxDate: 0,
                        minDate: new Date(2010, 1, 1),
                        yearRange: "2010:+0",
                        beforeShow: function(input, inst) {
                            $('#ui-datepicker-div').addClass('without-calendar');
                        },
                        onClose: function(dateText, inst) {
                            $('#ui-datepicker-div').removeClass('without-calendar');
                            histDate.datepicker('setDate', new Date(inst.selectedYear, inst.selectedMonth, 1));
                            histDate.data('month', inst.selectedMonth+1);
                            histDate.data('year', inst.selectedYear);
                            histDate.removeClass('error');
                        }
                    });
                },
                close: function(ev, ui) {
                    $(this).dialog('destroy');
                    $('#show_row_history').remove();
                },
                buttons: {
                    "Экспорт в эксель": function(){
                        if(histDate.data('month') && histDate.data('year')) {
                            showAjaxLoading();
                            $.ajax({
                                type: "GET",
                                url: "../php/getData.php",
                                dataType: "json",
                                data: {table: tableName, id: rowId, month: histDate.data('month'), year: histDate.data('year'), qryType: 'getTrackByMonth'},
                                success: function (tr) {
                                    hideAjaxLoading();
                                    if(tr.cnt > 0) {
                                        histMsg.text('');
                                        $('#table_row_history').html($('#'+rowId+' td[aria-describedby="grid_'+rowName+'"]').text()+'<br>Период: '+histDate.val()+'<br>'+tr.data);
                                        tableToExcel('#table_row_history', tableName.split('_')[1] + '_excel');
                                    } else {
                                        histMsg.text('Нет данных для выбранного периода.')
                                    }
                                }
                            });
                        } else {
                            histDate.addClass('error');
                        }
                    }
                }
            });
    };

    $.verifyAPRecord = function(rowId, grid){
        var rowData = $(grid).jqGrid('getRowData', rowId);

        if (rowData['ap_verified'] == 'Yes'){
            $.create_popup_dialog('<span class="error">Карточка уже верифицирована</span>', 'ошибка'); return;
        }

        $.ajax({
            url: 'php/tbl.ARBITRAGE.php',
            type: 'POST',
            dataType: 'json',
            data: {
                oper: 'verificate',
                ap_id: rowId,
            },
            success: function(data){
                $(grid).trigger('reloadGrid');
            },
            error: function(tr){
                var error = JSON.parse(tr.responseText);
                    error = error['error'];

                $.create_popup_dialog('<span class="error">' + error + '</span>', 'ошибка');
            }
        });
    }

    $.arbitrageFullExcelHandler = function() {
        $('<div id="arbitrage_full_report"></div>').html(getTemplate('#arbitrage_full_report_tmpl')).dialog(
            getDialog(
                {
                    title: 'Полный отчет',
                    open: function(ev, ui){
                        var datePickerParams = {
                            dateFormat:      'dd.mm.yy',
                            showAnim:        'slideDown',
                            yearRange:       '-100',
                            changeYear:      true,
                            changeMonth:     true,
                        };

                        $("#aribtrage_full_report_end_date").datepicker(datePickerParams);
                        $("#aribtrage_full_report_start_date")
                            .datepicker(datePickerParams)
                            .change(
                                function(){
                                    $('#get_report_btn').toggleClass('disabled', ($(this).val() == ''));
                                }
                            )
                            .blur();
                    },
                    buttons: [
                        {
                            text:  "Получить отчет",
                            id:    "get_report_btn",
                            class: "button f-right disabled",
                            click: function() {
                                if (!$('#get_report_btn').hasClass('disabled')){
                                    var fromDate = $("#aribtrage_full_report_start_date").val(),
                                        toDate   = $("#aribtrage_full_report_end_date").val();

                                    var dialog = $(this);
                                    var handleExport = function(res){
                                        var endDateFormatted = toDate;
                                        if (toDate == ''){
                                            // Format date for report header
                                            var formatDate = function(date){
                                                return date < 10 ? '0' + date : date;
                                            }
                                            endDateFormatted = new Date();
                                            endDateFormatted = 'd.m.y'
                                                .replace('d', formatDate(endDateFormatted.getDate()))
                                                .replace('m', formatDate(endDateFormatted.getMonth() + 1))
                                                .replace('y', endDateFormatted.getFullYear())
                                        }

                                        var download = $.customExcelExporter(res, {
                                            header: 'Отчетный период<br>' + fromDate + ' - ' + endDateFormatted,
                                            preventDownload: true,
                                            columns: {
                                                row:             '№',
                                                region:          'Субъект РФ',
                                                arbitrage_cases: 'Количество судебных дел'
                                            }
                                        });

                                        // Default download handler doesn't work for some reason, so we have to download it manually
                                        document.getElementById('arbitrage_full_report').appendChild(download); download.click();
                                        document.getElementById('arbitrage_full_report').removeChild(download);
                                        dialog.dialog('close');
                                    };

                                    $.get('php/tbl.ARBITRAGE.php', { start: fromDate, end: toDate, oper: 'report_full' }, handleExport, 'json');
                                }
                            }
                        }
                    ]
                },
                {
                    includeCloseButton: true,
                    overrideBehaviour: false,
                }
            )
        )
        .dialog('open')
    }

    $.customExcelExporter = function(res, params){
        var filename = params.filename || 'exportdata.xls',
            theader  = params.header   || '',
            tfooter  = params.footer   || '',
            tcontent = '';

        var uri      = 'data:application/vnd.ms-excel;base64,';
        var template = '' +
            '<html ' +
                'xmlns:o="urn:schemas-microsoft-com:office:office"' +
                'xmlns:x="urn:schemas-microsoft-com:office:excel"' +
                'xmlns="http://www.w3.org/TR/REC-html40"' +
            '>' +
                '<head>' +
                    '<meta http-equiv="Content-Type" content="text/html; charset=UTF-8"/>' +
                        '<!--[if gte mso 9]>' +
                            '<xml>' +
                                '<x:ExcelWorkbook>' +
                                    '<x:ExcelWorksheets>'+
                                        '<x:ExcelWorksheet>' +
                                            '<x:Name>Worksheet</x:Name>' +
                                            '<x:WorksheetOptions>' +
                                                '<x:DisplayGridlines/>' +
                                            '</x:WorksheetOptions>' +
                                        '</x:ExcelWorksheet>' +
                                    '</x:ExcelWorksheets>' +
                                '</x:ExcelWorkbook>' +
                            '</xml>' +
                        '<![endif]-->' +
                '</head>' +
                '<body>' +
                    '<table>' +
                        '{theader}'  +
                        '{tcontent}' +
                        '{tfooter}'  +
                    '</table>' +
                '</body>' +
            '</html>';

        var columns  = Object.keys(params.columns);

        var drawHeader = function(header, columns){
            header = '' +
                '<b style="font-size:14px; font-weight: bold;">' + header + '</b><tr></tr>' +
                '<tr style="font-size:14px; font-weight: bold; border: 1px solid black;">' +
                    '{theaderContent}' +
                '</tr>';

            var _theaderContent = '';
            $.each(columns, function(idx, column){
                _theaderContent += '<td>' + params.columns[column] + '</td>\n'
            })

            return header.replace(/\{theaderContent\}/, _theaderContent);
        }

        var drawContent = function(content, data, columns){
            var drawCell = function(idx, row){
                content += '<tr>';
                $.each(columns, function(idx, column){
                    content += '<td>' + (row[column] ? row[column] : '') + '</td>\n';
                });
                content += '</tr>';
            }
            $.each(data, drawCell);

            return content;
        }

        var downloadXML = function(uri, template, filename){
            var downloadElement = document.createElement('a');

            var base64 = function(uri, template){
                return uri + window.btoa(
                    unescape(
                        encodeURIComponent(template)
                    )
                );
            }

            downloadElement.download = filename;
            downloadElement.href     = base64(uri, template);

            if (!params.preventDownload){
                document.body.appendChild(downloadElement); downloadElement.click();
                document.body.removeChild(downloadElement);
            }

            return downloadElement;
        }

        template = template.replace(/\{theader\}/,  drawHeader(theader, columns))
                           .replace(/\{tcontent\}/, drawContent(tcontent, res.data, columns))
                           .replace(/\{tfooter\}/,  tfooter);

        return downloadXML(uri, template, filename);
    }

    $.addToNFlist = function(){
        $.ajax({
            type: "GET",
            url: "../../php/tbl.NOTIFIES.FILTERS.php",
            dataType: "json",
            data: { oper: 'getSavedFilters'},
            success: function(res){

                var options = '<option value="0">Выберите фильтр</option>';

                $.each(res.data, function(idx, filter){
                    options += '<option value="'+ filter.sf_id +'">' + filter.sf_name + '</option>';
                })

                $('<div>' +
                    '<h3 id="selectedFilterError" style="color:red; display: none;">Фильтр не выбран</h3>' +
                    '<select id="selectedFilter" class="grey form-input-style">' + options +'</select>' +
                  '</div>')
                .dialog({
                    title: 'Загрузить в выборку',
                    modal: true,
                    width: 'auto',
                    close: function(ev, ui)
                    {
                        $(this).dialog('destroy');
                        $(this).remove();
                    },
                    buttons: [
                        {
                            text: 'Загрузить',
                            class: 'buttom submit f-right',
                            click: function(ev, ui){

                                var rowId = $(this).find('#selectedFilter').find('option:selected').val();
                                if (rowId == 0){
                                    $('#selectedFilterError').css('display', 'block');
                                    return;
                                }

                                $(this).dialog('close');
                                $.moveToNFList(parseInt(rowId), true);
                            }
                        },
                        {
                            text: 'Отмена',
                            class: 'button f-left',
                            click: function(ev, ui) { $(this).dialog('close') }
                        }
                    ]
                });
            }
        });
    }

    $.moveToNFList = function(rowid, reloadGrid)
    {
        $.ajax({
            url: "../../php/getData.php",
            dataType: "json",
            data: { qryType: 'checkNotifyListCount' },
            success: function (tr) {

                var notifyListCount = tr.data;
                var setNFListCallback = function(replace)
                {
                    showAjaxLoading();

                    var requestCallbackDialog = function(title, body){
                        hideAjaxLoading();

                        $('<div>' + body + '</div>').dialog({
                            title: title,
                            modal: true,
                            close: function(ev, ui){
                                $(this).dialog('destroy');
                                $(this).remove();
                            },
                            buttons: [{
                                text: 'Закрыть',
                                class: 'button f-left',
                                click: function(ev, ui){
                                    $(this).dialog('close')
                                    if (reloadGrid){
                                        $('#grid').trigger('reloadGrid');
                                    }
                                }
                            }]
                        });
                    };

                    var $callbackComplete = $.Deferred();

                    if (replace) {
                        $.ajax({
                            type: "POST",
                            url: "../../php/tbl.MEMB.NOTIFIES.php",
                            dataType: "json",
                            async: false,
                            data: { oper: 'remove_notify_list' },
                            success: function (res) {
                                $callbackComplete.resolve();
                            },
                            error: function(error) {
                                $callbackComplete.reject();
                                requestCallbackDialog('Ошибка', error);
                            }
                        });
                    } else {
                        $callbackComplete.resolve()
                    }

                    $callbackComplete.done(
                        $.ajaxToNFList(
                            {
                                oper: 'add_notify_list',
                                savedFilterId: rowid
                            },
                            function(res){ requestCallbackDialog('Получатели добавлены', 'Получатели добавлены в выборку для рассылки')},
                            function(error){ requestCallbackDialog('Ошибка', error) }
                        )
                    );
                }

                if (notifyListCount > 0) {
                    $(
                        '<div>' +
                            'В текущей выборке ' + get_correct_str(notifyListCount,' запись', ' записи', ' записей') + '. ' +
                            'Вы можете добавить к ним записи из загружаемой выборки, либо заменить их (текущая выборка будет предварительно очищена).' +
                        '</div>'
                    ).dialog({
                        title: 'Внимание',
                        modal: true,
                        close: function(ev, ui)
                        {
                            $(this).dialog('destroy');
                            $(this).remove();
                        },
                        buttons: [
                            {
                                text: "Заменить",
                                class: "submit button f-right",
                                click: function(ev,ui)
                                {
                                    setNFListCallback(true);
                                    $(this).dialog('close');
                                }
                            },
                            {
                                text: "Добавить",
                                class: "button",
                                click: function(ev,ui)
                                {
                                    setNFListCallback(false);
                                    $(this).dialog('close');
                                }
                            },
                            {
                                text: "Отмена",
                                class: "button f-left",
                                click: function(ev,ui){ $(this).dialog('close') }
                            }
                        ]
                    });
                } else {
                    setNFListCallback(false);
                }
            }
        });
    }

    $.clearNotifyList = function()
    {
        $('<div></div>')
            .html('Из выборки будут удалены все получатели. Продолжить?')
            .dialog({
                title: 'Удалить',
                autoOpen: true,
                resizable: false,
                modal: true,
                zIndex : 3001,
                height: 'auto',
                width: 'auto',
                open: function(ev, ui) {
                    var _that = $(this);
                    $('body .ui-widget-overlay:last').click(function(){
                        _that.dialog('close');
                    });
                },
                close: function(ev, ui)
                {
                    $(this).dialog('destroy');
                    $(this).remove();
                },
                buttons: [
                    {
                        text: "Удалить",
                        class: "submit button f-right",
                        click: function()
                        {
                            var _that = $(this);
                            showAjaxLoading();
                            $.ajax({
                                type: "POST",
                                url: "../../php/tbl.MEMB.NOTIFIES.php",
                                dataType: "json",
                                async: false,
                                data: { oper: 'remove_notify_list' },
                                success: function (res) {
                                    _that.dialog('close');
                                    $(grid).trigger('reloadGrid');
                                },
                            });
                        }
                    }, {
                        text: "Отмена",
                        style: "color: #bdbdbd;",
                        class: "button f-left",
                        click: function(ev,ui){ $(this).dialog('close'); }
                    }
                ]
            });
    };

    $.ajaxToNFList = function(data, succesCallback, errorCallback){
        $.ajax({
            type: "POST",
            url: "../../php/tbl.MEMB.NOTIFIES.php",
            dataType: "json",
            data: data,
            success: succesCallback,
            error: errorCallback
        });
    };

    $.ajaxCheckPhoneMobile = function(grid_type, $postData, $isChecked, successCallback, errorCallback){
        showAjaxLoading();
        $.ajax({
            type: "POST",
            url: "../../php/tbl.MEMB.NOTIFIES.php",
            dataType: "json",
            data: {
                oper:       'check_phone_mobile_list',
                grid_type:  grid_type,
                filters:    $postData.filters,
                memberBDay: $postData.memberBDay,
                phoneMobile: $isChecked
            },
            success: successCallback,
            error: errorCallback
        }).always(function(data){
            hideAjaxLoading();
            checkSession(data);
        });
    };

    $.getCorrectStringSelection = function(data){
        return 'В выборку для рассылки ' +
            get_correct_str(data.phoneMobile, ' будет ', ' будут ', ' будет ', true) +
            get_correct_str(data.phoneMobile, ' добавлен ', ' добавлены ', ' добавлено ', true) +
            get_correct_str(data.phoneMobile, ' получатель', ' получателя', ' получателей') +
            ". Добавить?";
    };

    $.addNotifyList = function(gridId, grid_type, role)
    {
        var $grid = $(gridId),
            $postData = $grid.jqGrid('getGridParam', 'postData'),
            $recordsCount = $grid.jqGrid('getGridParam', 'records');

        var saveFilterBlock = $('#save_filter_tmpl');
            saveFilterBlock = saveFilterBlock.html().replace(/\{TMPL\}/g, '');

        var createDialogOpen = function(ev, ui){

            var _that = $(this);
            $('body .ui-widget-overlay:last').click(function(){
                _that.dialog('close');
            });

            _that.find('input[type="checkbox"]#is_save').change(function(){
                let saveFilterParams = _that.find('#save_filter_dtl');

                if ($(this).is(':checked')){
                    saveFilterParams.removeClass('hidden');
                } else {
                    saveFilterParams.addClass('hidden');
                }
            });

            var $inputSaveFilterMobile = _that.find('#save_filter_mobile');
            $inputSaveFilterMobile.change(function(){
                var $isChecked = $(this).is(':checked') ? 1 : 0;
                $.ajaxCheckPhoneMobile(grid_type, $postData, $isChecked, function(data){
                    if(data.phoneMobile > 0){
                        _that.find('span.add_personality_to_selection').html($.getCorrectStringSelection(data));
                        return false;
                    }
                    createErrorDialog('Новые получатели на найдены');
                    $inputSaveFilterMobile.is(':checked') ? $inputSaveFilterMobile.prop('checked', false):$inputSaveFilterMobile.prop('checked', true);
                }, function(){
                    createErrorDialog(('Перезагрузите страницу и повторите, пожалуйста, попытку'));
                });
            })
        }

        var createErrorDialog = function(error)
        {
            $('<div></div>')
                .html(error)
                .dialog(Object.assign({}, dialogSettings, { title:'Ошибка', buttons:[closeButton] }));
        };

        var dialogSettings =
        {
            autoOpen: true,
            resizable: false,
            modal: true,
            zIndex : 3001,
            height: 'auto',
            width: 'auto',
            open: function(ev, ui) {
                var _that = $(this);
                $('body .ui-widget-overlay:last').click(function(){
                    _that.dialog('close');
                });
            },
            close: function(ev, ui)
            {
                $(this).dialog('destroy');
                $(this).remove();
            },
        };

        var submitButton = {
            'text': "Добавить в рассылку",
            'class': "submit button f-right",
            click: function()
            {

                var dialog = $(this);
                var data = {
                    oper:       'add_notify_list',
                    grid_type:  grid_type,
                    filters:    $postData.filters,
                    memberBDay: $postData.memberBDay,
                    phoneMobile: $('#save_filter_mobile').is(':checked') ? 1 : 0
                }
                var errorCallback = function(error)
                {
                    hideAjaxLoading();
                    createErrorDialog('При создании рассылки возникла ошибка');

                    dialog.dialog('close');
                };

                if (dialog.find('input[type="checkbox"]#is_save').is(':checked'))
                {
                    var filterName = dialog.find('#save_filter_name').val();
                    var filterType = dialog.find('#save_filter_type').find('option:selected').val();

                    if (filterName === ''){
                        dialog.find('#save_filter_name').css('border', '1px solid red');
                        dialog.find('#save_filter_name').css('padding', '1px');
                        return;
                    } else {
                        data['filterName'] = filterName;
                        data['filterType'] = filterType;
                    }
                }

                showAjaxLoading();
                $.ajaxToNFList(data, function (res) {
                    if (res.result){
                        hideAjaxLoading();

                        $('<div></div>')
                            .html('Получатели добавлены в выборку для рассылки')
                            .dialog(Object.assign({}, dialogSettings, { title:'Получатели добавлены', buttons:[closeButton] }));

                        dialog.dialog('close');
                    }
                    else {
                        errorCallback();
                    }
                }, errorCallback);
            }
        },
        closeButton =  {
            text: "Закрыть",
            style: "color: #bdbdbd;",
            class: "button f-left",
            click: function(ev,ui){ $(this).dialog('close'); }
        };

        if (role != 'sys-admin'){
            if ($postData.filters) {
                var rules = JSON.parse($postData.filters)['rules'];
                if (rules.length === 1){
                    if (rules[0].field === 'r_name' && !$postData.memberBDay){
                        $postData._search = false;
                    }
                }
            }
        }

        if ($recordsCount > 0 && ($postData._search || $postData.memberBDay))
        {
            $.ajaxCheckPhoneMobile(grid_type, $postData, 0, function(data){
                if(!data.phoneMobile) {
                    createErrorDialog('Новые получатели на найдены');
                    return false;
                }
                $('<div></div>')
                    .html(
                        '<span class="add_personality_to_selection">' +
                        $.getCorrectStringSelection(data) +
                        '</span><br>' + saveFilterBlock
                    )
                    .dialog(Object.assign({}, dialogSettings, { title:'Добавить в рассылку', open: createDialogOpen, buttons:[submitButton, closeButton] }));
            }, function(){
                createErrorDialog(('Перезагрузите страницу и повторите, пожалуйста, попытку'));
            });
        }
        else
        {
            createErrorDialog(($recordsCount > 0 ? 'Для добавления в рассылку необходимо задать фильтр' : 'Получатели на найдены'));
        }
    };

    $.removeFromNotifyList = function(grid)
    {
        var memberIds = $(grid).jqGrid('getGridParam', 'selarrrow')
        $('<div>Получатель будет удален из выборки. Продолжить?</div>').dialog({
            title: 'Удалить',
            autoOpen: true,
            resizable: false,
            modal: true,
            zIndex : 3001,
            height: 'auto',
            width: 'auto',
            open: function(ev, ui) {
                var _that = $(this);
                $('body .ui-widget-overlay:last').click(function(){
                    _that.dialog('close');
                });
            },
            close: function(ev, ui)
            {
                $(this).dialog('destroy');
                $(this).remove();
            },
            buttons: [
                {
                    text: "Удалить",
                    class: "submit button f-right",
                    click: function()
                    {
                        var _that = $(this);
                        showAjaxLoading();
                        $.ajax({
                            type: "POST",
                            url: "../../php/tbl.MEMB.NOTIFIES.php",
                            dataType: "json",
                            async: false,
                            data: { oper: 'remove_member', m_id: memberIds.join(',') },
                            success: function (res) {
                                _that.dialog('close');
                                $(grid).trigger('reloadGrid')
                            },
                        });
                    }
                }, {
                    text: "Отмена",
                    style: "color: #bdbdbd;",
                    class: "button f-left",
                    click: function(ev,ui){ $(this).dialog('close'); }
                }
            ]
        });
    };

    $.getPublicationExportBtn = function(single, rowid) {
        if(single) {
            window.open('php/tbl.DEPUTIES.PUBLICATIONS.PRN.php?id=' + rowid);
        } else {
            showAjaxLoading();
            $.ajax({
                type: "GET",
                url: "../../php/getData.php",
                dataType: "json",
                data: {qryType: 'getDeputesSurnameFirstLetter'},
                success: function (tr) {
                    if (checkSession(tr)) {
                        hideAjaxLoading();
                        var dialog = $('<div id="show_letters"><div tabindex="1">Выберите буквы:</div><div id="letters"></div></div>')
                            .dialog({
                                autoOpen: true,
                                title: 'Выберите начальную букву фамилий',
                                modal: true,
                                resizable: false,
                                zIndex: 3001,
                                width: 330,
                                height: 790,
                                position: {my: 'center', mx: 'center', of: window},
                                open: function (ev, ui) {
                                    $.each(tr.data, function (idx, l) {
                                        $('#letters').append('<div><input type="checkbox" data-let="' + l.let + '">&nbsp;&nbsp' + l.let + '</div>')
                                    })
                                },
                                close: function (ev, ui) {
                                    $(this).dialog('destroy');
                                    $('#show_letters').remove();
                                },
                                buttons: {
                                    "Экспорт": function () {
                                        var lets = ""
                                        $('#letters').find('input').each(function (idx, el) {
                                            if ($(el).attr('checked')) {
                                                lets += '\'' + $(el).data('let') + '\','
                                            }
                                        });
                                        if (lets != "") window.open('php/tbl.DEPUTIES.PUBLICATIONS.PRN.php?letters=' + lets.slice(0, -1));
                                    }
                                }
                            });
                    }
                }
            });
        }
    };

    set_party_match = function(elem, set_fio, set_id, remove_party_match_unlink_btn, not_empty_return, remove, new_struct, values_for, set_bday, cb, additionalFilters, sitememb, is_ignore_rights, setPartyOptions){
        var confirm_match = {},
            addPar = values_for && values_for.length > 0 && values_for[0] == 'add_paragraph' && $.isNumeric(values_for[2]) && (elem.attr('m_id') == '' || elem.attr('m_id') == -1),
            parUpdate = '', m_data, m_transfer_data, flds_for_choose = [],
            is_deputy_meeting = location.hash == '#deputies_meetings',
            ignore_rights = is_ignore_rights || is_deputy_meeting,
            upu_rights = typeof setPartyOptions !== 'undefined' && setPartyOptions.upu_rights === true,
            commentatorOperators = typeof setPartyOptions !== 'undefined' && setPartyOptions.commentatorOperators === true,
            /*
            * publicReceptionPreset - объект с заданными (d_id, r_id, mo_id), если заданы
            * */
            publicReceptionData = typeof setPartyOptions !== 'undefined' && typeof setPartyOptions.publicReceptionData !== 'undefined'
                ? setPartyOptions.publicReceptionData
                : null,
            membersRenderingLimit = values_for && values_for.length > 0 && values_for[0] == 'memb_merge' ? 100 : null;

        if(values_for && values_for.length > 0 && values_for[0] == 'memb_merge')
            flds_for_choose = [
                'em_email','m_name','m_surname','m_middlename','m_sex', 'm_bday', 'm_birth_place','m_party_memb','m_party_card_number',
                'm_entry_date','m_structural_unit','m_vs_member','m_gs_member','m_rkrk_participate','m_mkrk_participate', 'm_ckk_participate',
                'm_po_post', 'm_council_po', 'm_election_date', 'm_elected_first_time_flag', 'm_reception_head', 'm_auditor',
                'm_gdrf_deputy', 'm_zs_deputy', 'm_gomp_deputy', 'm_gpsp_deputy', 'm_sf_deputy', 'm_assist_gdrf_deputy', 'm_assist_zs_deputy',
                'm_election_results', 'm_election_date_of_last_election', 'm_election_experience', 'm_deputy_status', 'm_deputy_group_name',
                'm_assist_gomp_deputy', 'm_assist_gpsp_deputy', 'm_assist_sf_deputy', 'm_main_place_work', 'm_main_place_work_post',
                'm_email','m_addition_email', 'm_phone_mobile', 'm_phone_work', 'm_phone_alt', 'm_address', 'm_comment', 'm_comment_regional_office_works',
                'm_comment_technology_management', 'm_comment_financial_and_economic_security', 'm_comment_organizational_management',
                'm_protected_member', 'm_passport_series', 'm_passport_num', 'm_passport_issue', 'm_passport_date', 'm_passport_issued_department_code', 'm_req_date',
                'm_education', 'm_addition_info', 'm_scholar_degree', 'm_honors', 'm_social_category', 'm_scope',
                'm_party_entry_protocol', 'm_party_entry_ik', 'm_party_card_date', 'm_party_supporter',
                'm_supporter_admission_date', 'm_personal_photo_small_full_path', 'm_photo_site_small_full_path',
                'm_personal_education', 'm_personal_profession', 'm_personal_labor_activity','m_socio_political_activities',
                'm_temp_cooper', 'm_temp_cooper_party', 'm_omsu_head', 'm_omsu_territory_name', 'm_ac_deputy', 'm_mun_mkrk',
                'm_role', 'm_ipaddr', 'm_data_h', 'm_empl_send_pass',
                'sa_request_date', 'sa_action1', 'sa_action2', 'sa_action3', 'sa_action4', 'sa_action5', 'sa_action6', 'sa_party', 'sa_resume_date', 'sa_resume_papka', 'sa_resume_anketa'
            ];


        if(values_for && values_for.length > 0 && values_for[0] == 'add_paragraph' && !values_for[6]) parUpdate = true;

        if(elem.hasClass('warning')){
            confirm_match = {text: 'подтвердить соответсвие', func: function(){
                elem.removeClass('no_match').removeClass('warning').html('');
                $('#popup_dialog_form').dialog('close');
            }};
        }
        var remove_party_match_btn  = {};
        if(remove_party_match_unlink_btn){
            remove_party_match_btn = {text: 'очистить форму', func: function(){
                $(new_struct || parUpdate ? '#disctrict1':'#popup_dialog_form #disctrict0').val('').change();
                $('#popup_dialog_form').find('input, select').val('').focusout();
            }};
        } else {
            remove_party_match_btn = {text: 'снять соответствие', func: function(){
                if (set_fio) {
                    if ($.isArray(set_fio)) {
                        $.each(set_fio, function( i, val ){
                            if (remove) {
                                $(val).val('');
                            } else {
                                $(val).prop('readonly', false);
                            }
                        });
                    } else {
                        if (remove) {
                            $(set_fio).val('');
                        } else {
                            $(set_fio).prop('readonly', false);
                            if (set_bday) {
                                $(set_bday).prop('readonly', false).datepicker('enable');
                            }
                        }
                    }
                }

                if (set_id) {
                    if (not_empty_return) {
                        $(set_id).val('-1');
                    } else {
                        $(set_id).val('');
                    }
                }

                elem.attr('m_id', '').addClass('no_match').removeClass('warning').html('');
                $('#popup_dialog_form').dialog('close');
            }};
        }
        var section = null;
        if (location.hash === '#zs_list' && set_id === '#frdp_m_id') {
            section = '-fractions';
        }

        var partyMemberForm = '#add_party_match_tmpl',
            $surnamePartyCardNumberErrorElm = {};

        if (additionalFilters && additionalFilters.m_rik_id)
            partyMemberForm = '#add_party_member_match_tmpl';

        $.create_popup_dialog(
            $(partyMemberForm).html().replace(/\{TMPL\}/g, ''),
            'партийное соответствие',
            -1,
            [{text: 'поиск', func: function(){
                var get_members_data = {
                    qryType: 'get_members',
                    m_district_id: $(new_struct || parUpdate ? '#disctrict1' : '#disctrict0').val(),
                    m_rik_id: addPar ? values_for[2] : $(new_struct|| parUpdate ? '#rik_unit1' : '#rik_unit0').val(),
                    m_mo_id: $(new_struct || parUpdate ? '#mo_unit1' : '#mo_unit0').val(),
                    m_po_id: $(new_struct || parUpdate ? '#po_unit1' : '#po_unit0').val(),
                    m_sex: $('#mem_sex').val(),
                    m_surname: ($('#mem_surname').hasClass('grey') ? '' : $('#mem_surname').val()),
                    m_name: ($('#mem_name').hasClass('grey') ? '' : $('#mem_name').val()),
                    m_middlename: ($('#mem_middlename').hasClass('grey') ? '' : $('#mem_middlename').val()),
                    m_bday: ($('#mem_bday').hasClass('grey') ? '' : $('#mem_bday').val()),
                    m_party_card_number: ($('#mem_party_card_number').hasClass('grey') ? '' : $('#mem_party_card_number').val()),
                    m_role: values_for && values_for[0] == 'add_operator' ? true : false,
                    getMembData: values_for && values_for[0] == 'memb_merge' ? true : false,
                    gdrf_deputy: location.hash === '#deputies_meetings',
                    section: section,
                    upu_rights: upu_rights,
                    membersRenderingLimit: membersRenderingLimit
                };
                if ($.isNumeric(elem.attr('zs_id'))) {
                    get_members_data.zs_id = elem.attr('zs_id');
                }

                if (additionalFilters) {
                    get_members_data['additionalFilters'] = additionalFilters;
                }

                if (is_ignore_rights) {
                    get_members_data['noRikMatch'] = true;
                }

                $surnamePartyCardNumberErrorElm.hide();
                if($.trim(get_members_data.m_surname) === '' && $.trim(get_members_data.m_party_card_number) === '') {
                    $surnamePartyCardNumberErrorElm.show();
                    return false;
                }

                showAjaxLoading();
                $.ajax({
                    type: "POST",
                    url: dirUp + "php/getData.php",
                    dataType: 'json',
                    data: get_members_data,
                    success: function (tr) {
                        hideAjaxLoading();
                        checkSession(tr);

                        if(tr.data === 'enter_surname_or_party_card_number'){
                            $surnamePartyCardNumberErrorElm.show();
                            return false;
                        }

                        var xhtml = '';

                        if(tr.data && tr.data.length){
                            for (var i = 0; i < tr.data.length; i++){
                                xhtml +=
                                    '<div class="link" picked="'+i+'" m_id="' + tr.data[i].m_id + '">' +
                                    tr.data[i].memb_f + ' ' +
                                    tr.data[i].memb_n + ' ' +
                                    tr.data[i].memb_o + ' (' +
                                    tr.data[i].memb_bday + ', ' +
                                    tr.data[i].r_name + ')'+
                                    '</div>'
                            }
                            if (membersRenderingLimit && tr.data.length == membersRenderingLimit) {
                                xhtml += `<p class="partyMatchMembersLimitNotice">Показано только ${membersRenderingLimit} записей из ${tr.queryRowCount[0].count} найденных. <br>Пожалуйста, уточните критерий поиска, если не видите нужного персоналия.</p>`;
                            }
                        } else {
                            xhtml = 'ничего не найдено';
                        }

                        $.create_popup_dialog(xhtml, 'результат поиска');
                        $('#popup_dialog1 .link').click(function() {
                            var i = $(this).attr('picked');
                            if(set_fio) {
                                if( $.isArray(set_fio)) {
                                    if(values_for && values_for.length > 0 && values_for[0] != 'add_paragraph'){
                                        if(values_for[0] == 'add_employee') {
                                            if (set_fio[0]) $(set_fio[0]).prop('readonly', true).val(tr.data[i].memb_f + ' ' + tr.data[i].memb_n + ' ' + tr.data[i].memb_o).focus().blur();
                                            if (set_fio[1]) $(set_fio[1]).val(tr.data[i].m_phone_work).focus().blur();
                                            if (set_fio[2]) $(set_fio[2]).val(tr.data[i].m_phone_mobile).focus().blur();
                                            if (set_fio[3]) $(set_fio[3]).val(tr.data[i].m_phone_alt).focus().blur();
                                            if (set_fio[4]) $(set_fio[4]).val(tr.data[i].m_email).focus().blur();
                                        }else if(values_for[0] == 'add_operator') {
                                            if (set_fio[0]) $(set_fio[0]).prop('readonly', true).val(tr.data[i].memb_f + ' ' + tr.data[i].memb_n + ' ' + tr.data[i].memb_o).focus();
                                            if (set_fio[1]) {
                                                if (typeof tr.data[i].m_email == 'string' && tr.data[i].m_email != '')
                                                    $(set_fio[1]).val(tr.data[i].m_email).prop('readonly', true).focusin();
                                                else
                                                    $(set_fio[1]).val('').prop('readonly', false).focusout();
                                            }
                                        }
                                    } else {
                                        if (set_fio[0]) $(set_fio[0]).prop('readonly', true).val(tr.data[i].memb_f);
                                        if (set_fio[1]) $(set_fio[1]).prop('readonly', true).val(tr.data[i].memb_n);
                                        if (set_fio[2]) $(set_fio[2]).prop('readonly', true).val(tr.data[i].memb_o);
                                    }
                                } else {
                                    if(new_struct) $(set_fio).removeClass('grey');
                                    if(values_for && values_for.length > 0 && values_for[0] == 'memb_merge') $(set_fio).focus();
                                    $(set_fio).prop('readonly', true).val(tr.data[i].memb_f + ' ' + tr.data[i].memb_n + ' ' + tr.data[i].memb_o);
                                    if (set_bday) {
                                        $(set_bday).prop('readonly', true).val(tr.data[i].memb_bday).datepicker('disable');
                                    }
                                }
                            }

                            if(sitememb)
                            {
                                $('#m_position_site').val(tr.data[i].m_position_site).focus().blur();
                                $('#m_bio_site').val(tr.data[i].m_bio_site || '').focus().blur();

                                if (tr.data[i].m_photo_site_small_full_path);
                                    $('.customelement#m_photo_site > table > tbody > .vert-al-top > td.image > img').attr('src', tr.data[i].m_photo_site_small_full_path);
                            }

                            if(set_id) $(set_id).val(tr.data[i].m_id).trigger('change');
                            if(values_for && values_for.length > 0 && !commentatorOperators) {
                                if (values_for[0] == 'add_paragraph') {
                                    var table = values_for[1],
                                        thisNum = values_for[3];
                                    if(table.find('.par_num_'+thisNum).parent().find('.er-flag').length == 0)
                                        table.find('.par_num_'+thisNum).after('<h1 class="er-flag"><img src="css/images/flag1.png"></h1>');
                                    table.find('.subject_prop_'+thisNum).val(1).change();
                                    table.find('.subject_prop_val_'+thisNum).val(values_for[4]).change();
//                        table.find('.paragraph'+values_for[5]+' .subjectPropVal .ui-combobox input').val($('.combobox.subject_prop_val_'+thisNum+' option[value=7]').html());
                                    table.find('.nationality_'+thisNum+', .education_'+thisNum+', .state_servant_'+thisNum+', .name.name_'+thisNum+', .surname.surname_'+thisNum+', .middlename.middlename_'+thisNum)
                                        .addClass('required')
                                        .prop('disabled', false);
                                    table.find('.paragraph'+values_for[5]+' .add_experience').show();
                                } else if(values_for[0] == 'memb_merge'){
                                    if($('#memb_merge_form .merge-link.open').hasClass('hidden')){
                                        $('#memb_merge_form .memb_data').remove();
                                        $('#memb_merge_form .merge-link.open').removeClass('hidden');
                                        $('#memb_merge_form .merge-link.close').addClass('hidden');
                                    }

                                    if (set_fio) {
                                        if (set_fio === '#m_fio') {
                                            m_data = tr.data[i];
                                        } else if (set_fio === '#m_transfer_fio') {
                                            m_transfer_data = tr.data[i];
                                        }
                                    }

                                    if($('#m_transfer_id').val() != -1 && $('#m_id').val() != -1){
                                        if(!m_data || !m_transfer_data){
                                            $.ajax({
                                                type: "POST",
                                                url: dirUp + "php/getData.php",
                                                dataType: 'json',
                                                data: {
                                                    qryType: 'get_members',
                                                    m_id: !m_data ? $('#m_id').val() : $('#m_transfer_id').val(),
                                                    getMembData: true
                                                },
                                                success: function (tr) {
                                                    hideAjaxLoading();
                                                    checkSession(tr);

                                                    if(!m_data)
                                                        m_data = tr.data[0];
                                                    else
                                                        m_transfer_data = tr.data[0];

                                                }
                                            });
                                        }

                                        $('#memb_merge_form .merge-link.close').click(function() {
                                            $('#memb_merge_form .memb_data').remove();
                                            $('#memb_merge_form .merge-link.open').removeClass('hidden');
                                            $('#memb_merge_form .merge-link.close').addClass('hidden');
                                            $('#memb_merge').css({
                                                'left': 0,
                                                'margin-left': (window.innerWidth - $('#memb_merge').outerWidth())/2
                                            });
                                            $('.ui-widget-overlay:last').css('height', window.innerHeight);
                                        });

                                        $('#memb_merge_form .merge-link.open').click(function(){
                                            $('#memb_merge_form .memb_data').remove();
                                            $('#memb_merge_form .merge-link.close').removeClass('hidden');
                                            $('#memb_merge_form .merge-link.open').addClass('hidden');
                                            if(m_data && m_transfer_data){
                                                $.each(m_data, function(k,v){
                                                    if($.inArray(k, flds_for_choose) != -1){
                                                        if((v != '' && v != null || m_transfer_data[k] != '' && m_transfer_data[k] != null) && (v != m_transfer_data[k] || k === 'm_personal_photo_small_full_path' || k === 'm_photo_site_small_full_path')) {
                                                            var header = '';
                                                            switch(k) {
                                                                case('sa_request_date'):
                                                                    header = 'Дата написания заявления';
                                                                    break;
                                                                case('sa_action1'):
                                                                    header = 'Участие в массовых мероприятиях';
                                                                    break;
                                                                case('sa_action2'):
                                                                    header = 'Поддержка кандидатов от Партии на выборах';
                                                                    break;
                                                                case('sa_action3'):
                                                                    header = 'Участие в избирательных кампаниях в качестве агитатора';
                                                                    break;
                                                                case('sa_action4'):
                                                                    header = 'Подписка на партийную прессу';
                                                                    break;
                                                                case('sa_action5'):
                                                                    header = 'Готовность материальной поддержки Партии';
                                                                    break;
                                                                case('sa_action6'):
                                                                    header = 'Другая форма поддержки';
                                                                    break;
                                                                case('sa_party'):
                                                                    header = 'Намерение о вступлении в Партию';
                                                                    break;
                                                                case('sa_resume_date'):
                                                                    header = 'Дата внесения в реестр';
                                                                    break;
                                                                case('sa_resume_papka'):
                                                                    header = 'Номер папки';
                                                                    break;
                                                                case('sa_resume_anketa'):
                                                                    header = 'Номер анкеты';
                                                                    break;
                                                                case('m_personal_photo_small_full_path'):
                                                                    header = 'Фото';
                                                                    break;
                                                                case('m_photo_site_small_full_path'):
                                                                    header = 'Фото (для сайта)';
                                                                    break;
                                                                case 'm_empl_send_pass':
                                                                    header = 'Высылать пароль сотруднику';
                                                                    break;
                                                                default:
                                                                    header = $('#jqgh_grid_'+k).text();
                                                            }

                                                            v = convertDataForUserView(k, v);
                                                            m_transfer_data[k] = convertDataForUserView(k, m_transfer_data[k]);

                                                            var first_val = '',
                                                                second_val = '';
                                                            if (k === 'm_personal_photo_small_full_path') {
                                                                first_val = v ? '<img class="width-200 vert-al-middle margin-center" src="' + v + '">' : '';
                                                                second_val = m_transfer_data[k] ? '<img class="width-200 vert-al-middle margin-center" src="' + m_transfer_data[k] + '">' : '';
                                                            } else if (k === 'm_photo_site_small_full_path') {
                                                                first_val = v ? '<img class="width-200 vert-al-middle margin-center" src="' + v + '">' : '';
                                                                second_val = m_transfer_data[k] ? '<img class="width-200 vert-al-middle margin-center" src="' + m_transfer_data[k] + '">' : '';
                                                            } else if (!['m_passport_series', 'm_passport_num', 'm_passport_issue', 'm_passport_date', 'm_passport_issued_department_code'].includes(k) || values_for[1]) { //values_for[1] - доступ к паспортным данным
                                                                first_val = v;
                                                                second_val = m_transfer_data[k];
                                                            } else {
                                                                first_val = '<i>информация скрыта</i>';
                                                                second_val = '<i>информация скрыта</i>';
                                                            }

                                                            let resultKey = k;
                                                            if (resultKey === 'm_temp_cooper_party') {
                                                                header = 'Временно сотрудничающий (Политическая партия)';
                                                                resultKey = resultKey + '_id';
                                                            }

                                                            $('#memb_merge_form .members_data').append(
                                                                '<tr class="memb_data">' +
                                                                    '<td class="row_name">' + header + '</td>' +
                                                                    '<td class="memb_merge_' + resultKey + '_first">' + first_val + '</td>' +
                                                                    '<td class="memb_merge_' + resultKey + '_second">' + second_val + '</td>' +
                                                                    '<td>' +
                                                                        '<select class="' + resultKey + '">' +
                                                                            '<option value="0">Первое значение</option>' +
                                                                            '<option value="1" selected>Второе значение</option>' +
                                                                        '</select>' +
                                                                    '</td>' +
                                                                '</tr>'
                                                            );
                                                        }
                                                    }
                                                });
                                            }
                                            $('#memb_merge').css({
                                                'left': 0,
                                                'margin-left': (window.innerWidth - $('#memb_merge').outerWidth())/2
                                            });
                                            $('.ui-widget-overlay:last').css('height', document.documentElement.scrollHeight);
                                        });
                                    }
                                } else {
                                    showAjaxLoading();
                                    $.ajax({
                                        type: "POST",
                                        url: dirUp + "php/getData.php",
                                        dataType: 'json',
                                        data: {qryType: 'getOperator', m_id: tr.data[i].m_id},
                                        success: function (tr) {
                                            hideAjaxLoading();
                                            checkSession(tr);

                                            if (values_for[0] == 'add_employee') {
                                                if (tr.data && $.isNumeric(tr.data.em_id)) {
                                                    $('#empl_login').attr('em_id', tr.data.em_id);
                                                    $('#empl_login').attr('login', '');

                                                    $('#empl_login').val(tr.data.em_email).prop('readonly', true);
                                                    $('#empl_login').focusin();
                                                    $('#empl_pass').focusin();
                                                    $('#empl_pass').val(tr.data.em_pass_src).focusout();
                                                } else {
                                                    $('#empl_login').attr('em_id', '');
                                                    $('#empl_login').attr('login', tr.data.login);

                                                    $('#empl_pass').val('').focusout();
                                                    $('#empl_pass').prop('type', 'text');
                                                    $('#empl_login').val(tr.data.login + '@' + values_for[1] + '.er.ru').focusin();
                                                }
                                            } else if (values_for[0] == 'add_operator') {
                                                if (tr.data && $.isNumeric(tr.data.em_id)) {
                                                    $('#oper_login').attr('em_id', tr.data.em_id);
                                                    if (tr.data.em_pass != null) {
                                                        $('#work_panel_wrap .generate').slideUp(500);
                                                        $('#oper_pass').val(tr.data.em_pass);
                                                        $('#oper_pass').prop('type', 'password');
                                                        $('#oper_pass').prop('readonly', true).focusin();
                                                    } else {
                                                        $('#oper_pass').val('').focusout().prop('readonly', false);
                                                        $('#oper_pass').prop('type', 'text');
                                                    }
                                                } else {
                                                    $('#work_panel_wrap .generate').slideDown(500);
                                                    $('#oper_login').attr('em_id', '');

                                                    $('#oper_pass').val('').focusout().prop('readonly', false);
                                                    $('#oper_pass').prop('type', 'text');
                                                }

                                                $('#oper_login').val(tr.data.em_email).focusin();

                                            }
                                        }
                                    });
                                }
                            }
                            elem.attr('m_id', $(this).attr('m_id')).removeClass('no_match').removeClass('warning').html('');
                            $('#popup_dialog_form, #popup_dialog_form1').dialog('close');
                            if (cb && typeof cb === 'function') {
                                cb(tr.data[i]);
                            }
                        });
                    }
                });
            }},
            confirm_match,
            remove_party_match_btn],
            function(dialog_id){
                $surnamePartyCardNumberErrorElm = $('#'+dialog_id).find('div.enter_surname_or_party_card_number');
                $surnamePartyCardNumberErrorElm.hide();
            }
        );

        if(ignore_rights && is_deputy_meeting){
            $('#popup_dialog_form').append('<span class="color-green field">* только депутаты ГД РФ</span>');
        } else if (additionalFilters && (additionalFilters.m_gdrf_deputy || additionalFilters.m_sf_deputy)){
            ignore_rights = __userRole__ === 'r-operator';
        }

        if(new_struct || parUpdate){
            $('#popup_dialog_form #disctrict0').attr('id','disctrict1');
            $('#popup_dialog_form #rik_unit0').attr('id','rik_unit1');
            $('#popup_dialog_form #mo_unit0').attr('id','mo_unit1');
            $('#popup_dialog_form #po_unit0').attr('id','po_unit1');
        }

        $.tipTipMy(new_struct || parUpdate ? '#disctrict1':'#disctrict0','Федеральный округ');
        $.tipTipMy(new_struct || parUpdate ? '#rik_unit1':'#rik_unit0','Региональное отделение');
        $.tipTipMy(new_struct || parUpdate ? '#mo_unit1':'#mo_unit0','Местное отделение');
        $.inputHints(new_struct || parUpdate ? '#po_unit1':'#po_unit0','Выбрать Первичное отделение:');
        $.inputHints('#mem_surname','Фамилия:');
        $.inputHints('#mem_name','Имя:');
        $.inputHints('#mem_middlename','Отчество:');
        $.tipTipMy('#mem_sex','Пол');
        $.inputHints('#mem_bday','Дата рождения:');
        $.inputHints('#mem_party_card_number','Партийный билет:');

        $('#mem_surname').blur();
        $("#mem_bday").datepicker({
            dateFormat: "dd.mm.yy",
            changeMonth: true,
            changeYear: true,
            showAnim: "slideDown",
            defaultDate: currentDateYearShift(-18),
            yearRange: '-100:-16'
        });

        let setPresetRIK = addPar ? values_for[2] : false,

            /*
            * Флаги для ОП (общественной приемной)
            * d_id (ФО), r_id (РО)
            * Для Центральной (isPublicReceptionCentral): d_id - null, r_id - null, pr_level = Центральная
            * Для Региональной (isPublicReceptionPresetRegional): d_id - число, r_id - число, pr_level = Региональная
            * Для Местной (isPublicReceptionPresetLocal): d_id - число, r_id - число, pr_level = Местная
            * Блокируется ФО + РО для pr_level = Региональная && pr_level = Местная
            * */
            isPublicReceptionRegional = false;

        if (publicReceptionData) {
            isPublicReceptionRegional = publicReceptionData.pr_level === 'Региональная' ||
                publicReceptionData.pr_level === 'Местная';

            setPresetRIK = isPublicReceptionRegional ? publicReceptionData.r_id : false;
        }

        showAjaxLoading();
        $.ajax({
            type: "POST",
            url: dirUp + 'php/getData.php',
            dataType: 'json',
            data: {
                qryType: 'districts',
                childLvl: 'mo',
                preset_rId: setPresetRIK,
                ignore_rights: ignore_rights,
                upu_rights: upu_rights,
            },
            success: function (tr) {
                hideAjaxLoading();
                if(checkSession(tr)) {
                    var distrOpt = '';
                    $.each(tr.data, function(){
                        distrOpt += '<option value="'+this.d_id+'" '+(addPar || isPublicReceptionRegional ? "selected=\'selected\'" : "")+'>'+this.d_name+'</option>';
                    });
                    $(new_struct || parUpdate ? '#disctrict1' : '#disctrict0').append(distrOpt).prop('disabled', addPar || isPublicReceptionRegional ? true : false);

                    var rId, mId, pId;
                    $(new_struct || parUpdate ? '#disctrict1' : '#disctrict0').bind('change', function(e, set_data){
                        rId = 0;
                        mId = 0;
                        pId = 0;

                        $(new_struct || parUpdate ? '#po_unit1' : '#po_unit0').parent().parent().slideUp(500);
                        $(new_struct || parUpdate ? '#po_unit1' : '#po_unit0').html("");
                        if($(this).val() != ''){
                            $(new_struct || parUpdate ? '#rik_unit1':'#rik_unit0').parent().parent().slideDown(500);
                            $(new_struct || parUpdate ? '#rik_unit1':'#rik_unit0').addClass('grey');
                            $(new_struct || parUpdate ? '#mo_unit1':'#mo_unit0').parent().parent().slideUp(500);
                            $(new_struct || parUpdate ? '#mo_unit1':'#mo_unit0').prop('disabled',true);
                            $(new_struct || parUpdate ? '#mo_unit1':'#mo_unit0').addClass('grey');

                            if(set_data) {
                                if (set_data.rId) {
                                    rId = set_data.rId;
                                }
                                if (set_data.mId) {
                                    mId = set_data.mId;
                                }
                                if (set_data.pId) {
                                    pId = set_data.pId;
                                }
                            }

                            /*
                            * Добавление условий для "Уровней Общественных приемных"
                            * Для "Региональной" / "Местной"
                            * */
                            let currentRIK = addPar ? values_for[2] : rId;
                            if (isPublicReceptionRegional) {
                                currentRIK = publicReceptionData.r_id;
                            }

                            getRIKListByDistrict({
                                ignore_rights: ignore_rights,
                                disctrId: $(this).val(),
                                i: (new_struct || parUpdate ? 1 : 0),
                                rId: currentRIK,
                                mId: mId,
                                pId: pId,
                                childLvl: 'mo',
                                rikDD: false,
                                preset_rId: (addPar || isPublicReceptionRegional ? true : false),
                                upu_rights: upu_rights,
                                isPublicReceptionRegional
                            });
                        } else {
                            $(new_struct || parUpdate ? '#rik_unit1':'#rik_unit0').parent().parent().slideUp(500);
                            $(new_struct || parUpdate ? '#mo_unit1':'#mo_unit0').parent().parent().slideUp(500);
                            $(new_struct || parUpdate ? '#rik_unit1, #mo_unit1' : '#rik_unit0, #mo_unit0').prop('disabled',true);

                            $(new_struct || parUpdate ? '#rik_unit1':'#rik_unit0').html('<option value="">Региональное отделение:</option>');
                            $(new_struct || parUpdate ? '#mo_unit1':'#mo_unit0').html('<option value="">Местное отделение:</option>');
                        }
                    });

                    $(new_struct || parUpdate ? '#rik_unit1':'#rik_unit0').change(function(e){
                        $(new_struct || parUpdate ? '#mo_unit1':'#mo_unit0').addClass('grey');
                        $(new_struct || parUpdate ? '#po_unit1':'#po_unit0').prop('disabled', false);
                        $(new_struct || parUpdate ? '#po_unit1':'#po_unit0').html("");
                        $(new_struct || parUpdate ? '#mo_unit1':'#mo_unit0').parent().parent().slideDown(500);
                        if ($(this).val() == ''){

                            if(addPar)
                                getMOListByRIK({ignore_rights: ignore_rights, rId: values_for[2], i: (new_struct || parUpdate ? 1 : 0)});
                            else
                                $(new_struct || parUpdate ? '#mo_unit1':'#mo_unit0').parent().parent().slideUp(500);

                        } else {
                            $(new_struct || parUpdate ? '#po_unit1':'#po_unit0').parent().parent().slideUp(500);
                            getMOListByRIK({ignore_rights: ignore_rights, rId: $(this).val(), i: (new_struct || parUpdate ? 1 : 0), upu_rights: upu_rights});
                        }
                    });

                    $(new_struct || parUpdate ? '#mo_unit1':'#mo_unit0').change(function(){
                        $(new_struct || parUpdate ? '#po_unit1':'#po_unit0').addClass('grey').val('').focusout();
                        if ($(this).val() == ''){
                            $(new_struct || parUpdate ? '#po_unit1':'#po_unit0').parent().parent().slideUp(500);
                        } else {
                            getPOListBy($(new_struct || parUpdate ? '#disctrict1' : '#disctrict0').val(),$(new_struct || parUpdate ? '#rik_unit1':'#rik_unit0').val(),$(this).val(), new_struct || parUpdate ? 1 : 0, {upu_rights: upu_rights});
                        }
                    });

                    if (addPar || isPublicReceptionRegional) {
                        $(new_struct || parUpdate ? '#disctrict1':'#disctrict0').change();
                        $(new_struct || parUpdate ? '#rik_unit1':'#rik_unit0').change();
                        $(new_struct || parUpdate ? '#mo_unit1':'#mo_unit0').on('mouseover',function(){

                            if ($(new_struct || parUpdate ? '#mo_unit1 option':'#mo_unit0 option').length < 2) {
                                $(new_struct || parUpdate ? '#rik_unit1' : '#rik_unit0').change();
                            }
                        });
                    }

                    if(elem.attr('m_id') != '' && elem.attr('m_id') != -1){
                        $.ajax({
                            type: "POST",
                            url: dirUp + "php/getData.php",
                            dataType: 'json',
                            data: {
                                qryType: 'get_members',
                                m_id: elem.attr('m_id'),
                                section: section,
                                upu_rights: upu_rights
                            },
                            success: function (tr) {
                                hideAjaxLoading();
                                checkSession(tr);

                                tr = tr.data[0];
                                if (!tr) {
                                    return;
                                }
                                $(new_struct || parUpdate ? '#disctrict1' : '#disctrict0').val(tr.m_district_id).trigger('change', [{rId: tr.m_rik_id, mId: tr.m_mo_id, pId: tr.m_po_id}]);

                                $('#mem_surname').val(tr.memb_f).focusin().focusout();
                                $('#mem_name').val(tr.memb_n).focusin().focusout();
                                $('#mem_middlename').val(tr.memb_o).focusin().focusout();
                                $('#mem_sex').val(tr.memb_sex);
                                $('#mem_bday').val(tr.memb_bday).focusin().focusout();
                            }
                        });
                    }
                }
            }
        });
    };

    $.smsPeriodReport = function () {
        $.create_popup_dialog(
            $('#sms_period_report_tmpl').html().replace(/\{TMPL\}/g, ''),
            'Отчет за период',
            function () {
                $('#sms_period_report_form').submit();
            },
            false,
            function () {
                var date = new Date();
                $('#sms_period_year').val(date.getFullYear());
                $('#sms_period_month').val(('0' + (date.getMonth() + 1)).slice(-2));
            }
        );
    };

    $.copyRow = (exceptFields) => {
        const Grid = $('#grid');
        const {selrow, colModel} = Grid.jqGrid('getGridParam');
        const rowData = Grid.getRowData( selrow );
        if(!selrow) {
            return $.selectRowWarning('#grid', -1, 'Выберите запись для копирования.');
        }

        // http://www.trirand.com/jqgridwiki/doku.php?id=wiki%3aform_editing#adding_row
        Grid.jqGrid("editGridRow", "new", {
            recreateForm: true,
            topinfo: '<center><b>ЧЕРЕЗ КОПИРОВАНИЕ ВЫБРАННОЙ ЗАПИСИ</b></center><hr>',
            // top: '0px',
            width: 'auto',
            closeAfterAdd: true,
            afterSubmit: (response) => {
                return JSON.parse(response.responseText);
            },
        });

        Grid.GridToForm( selrow, '#TblGrid_grid' );
        $.each($('#TblGrid_grid .FormElement'), (idx, elm) => {
            const model = colModel.find(item => item.name === elm.id);
            const $elm = $(elm);
            if(elm.id === 'd_name') {
                $elm.html(`<option value="${rowData.d_id}">${rowData.d_name}</option>`);
            }
            if(elm.id === 'r_name') {
                $elm.html(`<option value="${rowData.r_id}">${rowData.r_name}</option>`);
            }
            if(elm.id === 'mo_name') {
                $elm.html(`<option value="${rowData.mo_id}">${rowData.mo_name}</option>`);
            }
            if(model && model.name === elm.id && model.stype === 'text' && model.unformat) {
                $elm.val(model.unformat($elm.val(), {}, $elm));
            }
            if(exceptFields.includes(elm.id) ) {
                $(elm).val('');
            } else {
                $('#tr_'+elm.id).hide();
            }
        })
    };

    $.getVCReport = () => {
        $(`<div class="get-vc-report-dialog"></div>`)
            .html(`<div>Выберите месяц:<br><div class="vc-report-period"></div></div>`)
            .dialog({
                autoOpen: true,
                title: 'Данные по наличию отчетов ВЦ',
                modal: true,
                width: 'auto',
                open: () => {
                    datepicker = $('.vc-report-period').datepicker( {
                        changeMonth: true,
                        changeYear: true,
                        dateFormat: 'yy-mm',
                        minDate: new Date(2021, 0, 1),
                        maxDate: 1,
                        onChangeMonthYear: (year, month, inst) => {
                            $(datepicker).datepicker('setDate', new Date(year, month-1, 1));
                        },
                    });
                },
                buttons: {
                    'Экспорт': () => {
                        window.open(`php/excel.vc_report.php?period=${$(datepicker).val()}`);
                    }
                }
            });
    };
})(jQuery);

(function($) {
    $.fn.hasScrollBar = function() {
        return this.get(0).scrollHeight > this.height();
    }
})(jQuery);

$.fn.titlebar_fix = function(){
    var scroll_fix = function(style_top_title, style_top_toppager, style_top_toppager_left){
        $(document).on('DOMNodeInserted', 'body > .ui-widget-overlay', function () {
            $(window).unbind('scroll').scroll( function() {
                if(!$('#gbox_grid_tmp').length) {
                    $('#gview_grid .ui-jqgrid-titlebar').css('top', style_top_title - $(window).scrollTop() + 'px');
                    $('#grid_toppager').css('top', style_top_toppager - $(window).scrollTop() + 'px');
                    $('#grid_toppager_left').css('top',style_top_toppager_left - $(window).scrollTop() + 'px')
                }
                if($('#tel_book_search').length){
                    $('#tel_book_search').css('top', '209' - $(window).scrollTop() + 'px');
                }
                var cat_allid = $('#grid').jqGrid('getDataIDs');
                $.each(cat_allid, function( i, val ){
                    if($('#grid_'+val).length){
                        if($('#grid_'+val+'_t_toppager').css("position") === "fixed") {
                            $('#grid_' + val + '_t_toppager').css('top', ((__pinGridHeader__)? '255' : '210') - $(window).scrollTop() + 'px');
                        }else if($('#grid_'+val+' #grid_'+val+'_t'+' div[id$="_t_toppager"][dir="ltr"]').css("position") === "fixed") {
                                $('#grid_'+val+' #grid_'+val+'_t'+' div[id$="_t_toppager"][dir="ltr"]').css('top', ((__pinGridHeader__) ? '255' : '210') - $(window).scrollTop() + 'px');
                        }
                    }
                });
            });
        });
    };

    if(typeof __userSkin__ == 'undefined' || __userSkin__ == 'wittera'){ // DEFAULT
        scroll_fix(160, 160, 160);
    }else if(__userSkin__ == 'bondi'){ // BONDI BEACH
        scroll_fix(154, 184, 183);
    }else if(__userSkin__ == 'mikki'){   // BLACK AND WHITE
        scroll_fix(132, 184, 183);
    }else if(__userSkin__ == 'linen'){    // LINEN
        scroll_fix(107, 170, 178);
    }else if(__userSkin__ == 'pumpkin'){ // PUMPKIN
        scroll_fix(129, 178, 183);
    }
};

jQuery.validator.addMethod(
    "membDate",
    function(value, element) {
        var check = false;
        var re = /^\d{1,2}\.\d{1,2}\.\d{4}$/;
        jQuery.validator.messages.membDate = 'Укажите дату в формате ДД.ММ.ГГГГ';
        if( re.test(value)){
            var adata = value.split('.');
            var gg = parseInt(adata[0],10);
            var mm = parseInt(adata[1],10);
            var aaaa = parseInt(adata[2],10);
            var xdata = new Date(aaaa,mm-1,gg);
            var today = new Date($('#mem_bday').attr('data-current-time'));
            var getAge = function () {
                var y, m, d;
                y = today.getFullYear() - xdata.getFullYear();
                m = today.getMonth() - xdata.getMonth();
                d = today.getDate() - xdata.getDate();

                if (m < 0 || m === 0 && d < 0) {
                    y--;
                }

                if (d < 0) {
                    m--;
                    d += 33 - new Date(today.getFullYear(), today.getMonth() - 1, 33).getDate();
                }

                if (m < 0) {
                    m += 12;
                }

                return [y, m, d];
            };
            var memberAge = getAge();

            if ( ( xdata.getFullYear() == aaaa ) && ( xdata.getMonth () == mm - 1 ) && ( xdata.getDate() == gg ) ){

                if($(element).attr('id') == 'mem_bday'){

                    if ( memberAge[0] === 100 && memberAge[1] > 0 || memberAge[0] === 100 && memberAge[2] > 0 || memberAge[0] > 100 ){
                        jQuery.validator.messages.membDate = 'Введите корректную дату';
                        check = false;
                    }else if( memberAge[0] < 16 ){
                        jQuery.validator.messages.membDate = 'Возраст не может быть менее 16 лет';
                        check = false;

                    }else check = true;

                }else if($(element).attr('id') == 'passport_date'){
                    $(element).addClass('error');
                    $(element).passportDateValid($(element).val());

                    if($(element).attr('validate') == 'false'){
                        check = false;
                    }else {
                        $(element).removeClass('error');
                        check = true;
                    }

                } else if($('#passport_date').attr('validate') == 'true'){
                    $(element).addClass('error');

                    if($(element).attr('id') == 'supporter_admission_date')
                        $(element).passportDateValid($(element).val(), 'Дата зачисления в сторонники');

                    if($(element).attr('id') == 'entry_date')
                        $(element).passportDateValid($(element).val(), 'Дата вступления');

                    if($(element).attr('validate') == 'false'){
                        check = false;
                    }else {
                        $(element).removeClass('error');
                        check = true;
                    }

                } else check = true;
            } else check = false;
        } else check = false;

        return this.optional(element) || check;
    },
    jQuery.validator.messages.membDate
);
